// import { FaTimes } from "react-icons/fa";
// import React, { act, useState } from "react";
// import CreatePage from "../../controls/CreatePage";
// import PageSection from "../../controls/PageSection";
// import Input from "../../controls/Input";
// import ImageUpload from "../../controls/ImageUpload";
// import Select from "../../controls/Select";
// import CustomSwitch from "../../controls/CustomSwitch";
// import { useEffect } from "react";
// import { fetchCategory } from "../../../api/CategoryApi";
// import { fetchSubCategory, } from "../../../api/subCategoryApi";
// import { fetchBrands } from "../../../api/brandApi";
// import { checkSkusAlreadyExist, fetchProducts, handleAddProduct, handleAddVariants } from "../../../api/ProductApi";
// import { uploadImagesToServer } from "../../../../uploadImageToServer"
// import Autocompletesearch from "../../controls/Autocompletesearchbk";
// import { useNavigate, useParams } from "react-router-dom";
// import { toast } from "react-toastify";
// import { handleEditProduct, fetchSingleProductApi } from "../../../api/ProductApi";
// import { fetchMembership } from "../../../api/MembershipApi";
// import Loading from "../../controls/Loading";
// import ConfirmBox from "../../controls/ConfirmBox";
// import AddCategory from "../category/AddCategory";
// import AddSubCategory from "../subcategory/AddSubCategory";
// import AddBrand from "../brand/AddBrand";
// import Cataloguesearchdrawer from "./Cataloguesearchdrawer";
// import { fetchStore } from "../../../api/storeApi";
// import { useLocation } from "react-router-dom";
// import Globalcataloguelabel from "../../controls/Globalcataloguelabel";
// import TextArea from "../../controls/TextArea";
// import Button from "../../controls/Button";
// import Icon from "../../../assets/icons/Icon";
// import { fetchTaxes } from "../../../api/taxApi";
// import MultiAutocomplete from "../../controls/MultiAutocomplete";
// import QuillEditor from "../../controls/QuillEditor";
// import { useRef } from 'react';
// import { useSelector, useDispatch } from "react-redux";
// import { selectProductModule } from "../../../redux/slices/customFieldSlice";
// import { selectUser, selectRegistration } from "../../../redux/slices/userSlice";
// import useCurrencySymbol from "../../controls/CurrencySymbol";
// import { getUOMs, isMobileView } from "../../controls/CommonFunctions"
// import PopupModal from "../../controls/PopupModal";
// import InfoModal from "../../controls/InfoModal";

// const Addproduct = ({ onSave, onClose, selectedProductID }) => {
//   const productCustomFields = useSelector(selectProductModule);
//   const user = useSelector(selectUser);

//   const registration = useSelector(selectRegistration);

//   const [productAutoGeneratedSKU, setProductAutoGeneratedSKU] = useState(registration?.AutoGenerateSKU || false);
//   const [isPincode, setIsPincode] = useState(false);
//   console.log(registration, "select registration");
//   const currencySymbol = useCurrencySymbol();
//   const [markup,setMarkup]=useState(0);


//   // Get the first product field (if available)
//   const customFieldData = productCustomFields;
//   console.log("customfields", customFieldData);

//   const topRef = useRef(null);

//   const [dataLoading, setDataLoading] = useState(false);
//   const [chargeTaxesonthisProduct, setChargeTaxesonthisProduct] = useState(registration?.IsAllowChargeTaxOnProduct || false);
//   const [taxInclusiveSales, setTaxInclusiveSales] = useState(registration?.IsAllowTaxInclusiveOnSales || false);
//   const [taxInclusivePurchase, setTaxInclusivePurchase] = useState(false);
//   const [taxDropDownValue, setTaxDropDownValue] = useState("");
//   const [taxDropDownLabel, setTaxDropDownLabel] = useState("");
//   const [infoType, setInfoType] = useState("");

//   const [showInfoModal, setShowInfoModal] = useState(false);
//   const [inventoryDropDownValue, setInventoryDropDownValue] = useState("FIFO");


//   const [categoryData, setCategoryData] = useState([]);
//   const [categoryName, setCategoryName] = useState("");
//   const [categoryId, setCategoryId] = useState("");

//   const [subCategoryName, setSubCategoryName] = useState("");
//   const [subCategoryId, setSubCategoryId] = useState("");
//   const [filteredsubcategorydata, setfilteredsubcategorydata] = useState([]);

//   const [brandData, setBrandData] = useState([]);
//   const [brandName, setBrandName] = useState("");
//   const [brandId, setBrandId] = useState("");

//   //input values 
//   const [productName, setProductName] = useState("");
//   const [sku, setSku] = useState(productAutoGeneratedSKU ? "Auto Generate" : "");
//   const [psin, setPsin] = useState("");
//   const [barcode, setBarcode] = useState("");
//   const [supplyPrice, setSupplyPrice] = useState("");
//   const [marginPercentage, setMarginPercentage] = useState("");
//   const [marginAmount, setMarginAmount] = useState("");
//   const [msp, setMsp] = useState("");
//   const [retailPrice, setRetailPrice] = useState("");
//   const [discountPercentage, setDiscountPercentage] = useState("");
//   const [discountAmount, setDiscountAmount] = useState("");
//   const [mrp, setMrp] = useState("");
//   const [hsnSacCode, setHsnSacCode] = useState("");

//   //additional setting toogles variables
//   const [favourite, setFavourite] = useState(false);
//   const [allowPriceEdit, setAllowPriceEdit] = useState(registration?.IsAllowPriceEdit || false);
//   const [discountable, setDiscountable] = useState(true);
//   const [allowTaxChange, setAllowTaxCharge] = useState(registration?.IsAllowTaxChange ||  false);
//   const [PromptforQtyattheTimeBilling, setPromptforQtyatthetimeBilling] = useState(false);
//   const [sequenceNo, setSequenceNo] = useState("");
//   const [repackProduce, setRepackProduce] = useState(false);
//   const [bom, setBom] = useState(false);
//   const [bomManual, setBomManual] = useState(false);
//   const [canbeUsedasConsumable, setCanbeUsedasConsumable] = useState(false);
//   const [showAdditionalChargesonBillPrint, setShowAdditionalChargesonBillPrint] = useState(false);

//   //name rror variable
//   const [productNameError, setProductNameError] = useState("");
//   const [skuError, setSkuError] = useState("");
//   const [barcodeError, setBarcodeError] = useState("");
//   const [categoryError, setCategoryError] = useState("");
//   const [retailPriceError, setRetailPriceError] = useState("");
//   const [mrpError, setMrpError] = useState("");
//   const [mrpAndRetailPriceError, setMrpAndRetailPriceError] = useState("");
//   const navigate = useNavigate();

//   const [imgArray, setImgArray] = useState([]); // Store the array of uploaded images.
//   const [imgLoading, setimgLoading] = useState(false); // Track loading state.

//   const [addCategoryComp, setAddCategoryComp] = useState(false);
//   const [openSubCategory, setOpenSubCategory] = useState(false);
//   const [openAddBrand, setOpenAddBrand] = useState(false);
//   const [catalogueSearchDrawer, setCatalogueSearchDrawer] = useState(false);

//   const [allSubCategoryData, setAllSubCategoryData] = useState([]);
//   const [storeData, setStoreData] = useState([]);
//   const [storeDataInInventory, setStoreDataInInventory] = useState([]);

//   const [isGc, setIsGc] = useState(false);
//   const [customFeild1, setCustomField1] = useState("");
//   const [customFeild2, setCustomField2] = useState("");
//   const [customFeild3, setCustomField3] = useState("");
//   const [customFeild4, setCustomField4] = useState("");
//   const [customFeild5, setCustomField5] = useState("");
//   const [customFeild6, setCustomField6] = useState("");

//   const [autoGenerateSKU, setAutoGenerateSKU] = useState(false);
//   const [serviceDuration, setServiceDuration] = useState(0);
//   const [walletTopUpSameAsRetailPrice, setWalletTopUpSameAsRetailPrice] = useState(false);
//   const [walletTopUpAmount, setWalletTopUpAmount] = useState(0);
//   const [walletTopUpError, setWalletTopUpError] = useState("");
//   const [editWalletTopUpAmount, setEditWalletTopUpAmount] = useState(false);



//   const [productType, setProductType] = useState("");
//   const [productTypeID, setproductTypeID] = useState("");
//   const [productTypeError, setproductTypeError] = useState("");

//   const [OMNIEnabled, setOMNIEnabled] = useState(false);
//   const [maxOrderQty, setMaxOrderQty] = useState(0);



//   //new field varaibels 
//   const [packagingCharges, setPackagingCharges] = useState('');
//   const [soldAtSpecificStoresOnly, setSoldAtSpecificStoresOnly] = useState(false);
//   const [someStoresHaveDifferentPricing, setSomeStoresHaveDifferentPricing] = useState(false);
//   const [taxBaseOnRetailPrice, setTaxBaseOnRetailPrice] = useState(false);
//   const [taxData, setTaxData] = useState([]);

//   const [uniqueLabel, setUniqueLabel] = useState("");
//   const [batchTrackingBatchNoRequired, setBatchTrackingBatchNoRequired] = useState(false);
//   const [batchTrackingMRPRequired, setBatchTrackingMRPRequired] = useState(false);
//   const [batchTrackingExpDateRequired, setBatchTrackingExpDateRequired] = useState(false);
//   const [batchTrackingMfgDateRequired, setBatchTrackingMfgDateRequired] = useState(false);
//   const [batchTrackingDateFormat, setBatchTrackingDateFormat] = useState('');

//   const [defaultSalesUOMValue, setDefaultSalesUOMValue] = useState("");
//   const [defaultSalesUOMLabel, setDefaultSalesUOMLabel] = useState("");
//   const [defaultPurchaseUOMValue, setDefaultPurchaseUOMValue] = useState("");
//   const [defaultPurchaseUOMLabel, setDefaultPurchaseUOMLabel] = useState("");

//   const [shortDescription, setShortDescription] = useState("");
//   const [longDescription, setLongDescription] = useState("");

//   const [outOfStock, setOutOfStock] = useState(false);
//   const [associateMembership, setAssociateMembership] = useState(false);
//   const [membership, setMembership] = useState("");
//   const [membershipID, setMembershipID] = useState("");
//   const [membershipData, setMembershipData] = useState([]);

//   const [validityInDays, setValidityInDays] = useState("");
//   const [validityInDaysError, setValidityInDaysError] = useState("");
//   const [packageServices, setPackageServices] = useState([]);
//   const [services, setServices] = useState([]);
//   const [selectedService, setSelectedService] = useState({});
//   const [packagesServiceError, setPackageServiceError] = useState("");


//   const [error, setError] = useState(false);

//   const uomOptionData = getUOMs;
//   console.log("uomoption", uomOptionData);


//   const fetchGlobalCatalogueObject = (product) => {
//     stateData(product);
//     console.log("proudct", product);
//   }

//   const stateData = (product) => {
//     setCategoryName("");
//     setCategoryId("");
//     setSubCategoryName("");
//      setSubCategoryId("");
//     setBrandName("");
//     setBrandId("");
// // CATEGORY & SUBCATEGORY
// if (
//   product?.Category &&
//   Array.isArray(categoryData) &&
//   categoryData.length
// ) {
//   const category = categoryData.find(
//     (c) => c.Name === product.Category
//   );

//   if (category) {
//     setCategoryName(category.Name);
//     setCategoryId(category.key);
//     setCategoryError("");

//     // SUBCATEGORY
//     if (
//       product?.Subcategory &&
//       Array.isArray(allSubCategoryData) &&
//       allSubCategoryData.length
//     ) {
//       const subCategory = allSubCategoryData.find(
//         (c) => c.Name === product.Subcategory
//       );

//       if (subCategory) {
//         setSubCategoryName(subCategory.Name);
//         setSubCategoryId(subCategory.key);
//       }
//     }
//   }
// }

// // BRAND
// if (
//   product?.Brand &&
//   Array.isArray(brandData) &&
//   brandData.length
// ) {
//   const brand = brandData.find(
//     (b) => b.Brand === product.Brand
//   );

//   if (brand) {
//     setBrandName(brand.Brand);
//     setBrandId(brand.key);
//   }
// }


//     setMrpError("");
//     setProductNameError("");
//     setBarcodeError("");
//     setCategoryError("");
//     console.log("Global data:", product);
//     setProductName(product?.name);
//     setBarcode(product?.Code);
//     // setPsin(product?.PincodeProductID);
//     setMrp(product?.MRP);
//     // setCustomField3(product?.Type);
//     // setCustomField1(product?.Code);
//     // setCustomField2("GC");
//     // setCategoryName(product?.Category);
//     // setSubCategoryName(product?.Subcategory);
//     // setBrandName(product?.Brand);



//     // If `ProductImages` is an array of image URLs

//     setImgArray(product?.ProductImages);



//   };

//   const { key } = useParams();
//   useEffect(() => {
//     if (key || selectedProductID) {
//       let productID = key || selectedProductID;
//       fetchsingledata(productID); // Fetch single product data if key is present
//     }
//     else {
//       const e = { label: "Goods for sale", value: "1", id: 1 };
//       setproductTypeID(e.id);
//       setProductType(e.label);
//       onProductTypeChange(e)
//     }
//   }, []);

//   const fetchsingledata = async (key) => {
//     setDataLoading(true);
//     try {
//       const response = await fetchSingleProductApi(key);
//       console.log("response data", response);
//       console.log("response data", response);
//       const filteredData = response;


//       setDataLoading(false);
//       const product = filteredData;
//       console.log("product data", product);
//       setProductName(product.Name);
//       setSku(product.SKU);
//       setBarcode(product.BarCode);
//       setMarginAmount(product.MarginAmount);
//       setMarginPercentage(product.MarginPercentage);
//       setSupplyPrice(product.SupplyPrice);
//       setMsp(product.MSP);
//       setRetailPrice(product.RetailPrice);
//       setDiscountPercentage(product.DiscountPercentage);
//       setDiscountAmount(product.DiscountAmount);
//       setMrp(product.MRP);
//       setHsnSacCode(product.HSNSACCode);
//       setPsin(product.PincodeProductID);
//       setChargeTaxesonthisProduct(product.ChargeTaxOnProduct);
//       setTaxInclusiveSales(product.TaxInclusive);
//       setTaxInclusivePurchase(product.TaxInclusivePurchase);
//       setTaxDropDownLabel(product.TaxGroup);
//       setTaxDropDownValue(product.TaxID);
//       setInventoryDropDownValue(product.InventoryType);
//       setCategoryName(product.Category);
//       setCategoryName(product.Category);
//       setCategoryId(product.CategoryID);
//       setSubCategoryName(product.SubCategory);
//       setSubCategoryName(product.SubCategory);
//       setSubCategoryId(product.SubCategoryID);
//       setBrandName(product.Brand);
//       setBrandName(product.Brand);
//       setBrandId(product.BrandID);
//       setAllowTaxCharge(product.AllowTaxChange);
//       setFavourite(product.Favourite);
//       setAllowPriceEdit(product.AllowPriceEdit);
//       setDiscountable(product.AllowDiscount);
//       setPromptforQtyatthetimeBilling(product.QtyPrompt);
//       setSequenceNo(product.SequenceNo);
//       setRepackProduce(product.RepackProduce);
//       setBom(product.BOM);
//       setBomManual(product.BOMManual);
//       setCanbeUsedasConsumable(product.CanBeUsedAsConsumable);
//       setShowAdditionalChargesonBillPrint(product.ShowAsAdditionalCharges);
//       setUniqueLabel(product.UniqueLabel);
//       setSoldAtSpecificStoresOnly(product.AccessibleToSelectedStores);
//       setSomeStoresHaveDifferentPricing(product.StoreSpecificPricing);
//       setBatchTrackingBatchNoRequired(product.BatchTrackingBatchNoRequired);
//       setBatchTrackingMRPRequired(product.BatchTrackingMRPRequired);
//       setBatchTrackingMfgDateRequired(product.BatchTrackingMfgDateRequired);
//       setBatchTrackingExpDateRequired(product.BatchTrackingExpDateRequired);
//       setBatchTrackingDateFormat(product.BatchTrackingDateFormat);
//       setAutoGenerateSKU(product.AutoGenerateSKU);
//       setWalletTopUpAmount(product.WalletTopUpAmount);
//       setWalletTopUpSameAsRetailPrice(product.WalletTopUpSameAsRetailPrice);
//       setEditWalletTopUpAmount(product.EditWalletTopUpAmount);
//       setMarkup(product?.Markup || 0);
//       setValidityInDays(product.ValidityInDays);
//       setPackageServices(product.PackageServices);


//       {
//         setCustomField1(product.CustomField1);
//         setCustomField2(product.CustomField2);
//         setCustomField3(product.CustomField3);
//         setCustomField4(product.CustomField4);
//         setCustomField5(product.CustomField5);
//         setCustomField6(product.CustomField6);
//       }

//       setproductTypeID(product.ProductTypeID);
//       console.log("productType id", product.ProductTypeID);
//       setProductType(product.ProductType);
//       setPackagingCharges(product.PackagingCharges);
//       setShortDescription(product.Description);
//       setLongDescription(product.LongDescription);
//       setOutOfStock(product.OutOfStock);
//       setOMNIEnabled(product.OMNIEnabled);
//       setAssociateMembership(product.AssociateMembership);
//       setMembership(product.Membership);
//       setMembershipID(product.MembershipID);
//       setTaxBaseOnRetailPrice(product.PriceBasedTax);

//       if (product.TaxPriceRange && product.TaxPriceRange.length > 0) {
//         const taxRows = product.TaxPriceRange.map(range => ({
//           FromPrice: range.FromPrice || "",
//           ToPrice: range.ToPrice || "",
//           TaxID: range.TaxID || "",
//           TaxGroup: range.TaxGroup || "",
//         }));
//         setTaxOnRetailPriceRows(taxRows);
//       }

//       // Set StoreSpecificPrices
//       if (product.StoreSpecificPrices && product.StoreSpecificPrices.length > 0) {
//         const storeRowsData = product.StoreSpecificPrices.map((store) => ({
//           Store: store.Store,
//           StoreID: store.StoreID,
//           SupplyPrice: store.SupplyPrice,
//           MarginAmount: store.MarginAmount,
//           Markup:store?.Markup || 0,
//           MarginPercentage: store.MarginPercentage,
//           MSP: store.MSP,
//           RetailPrice: store.RetailPrice,
//           DiscountPercentage: store.DiscountPercentage,
//           DiscountAmount: store.DiscountAmount,
//           WalletTopUpSameAsRetailPrice: store.WalletTopUpSameAsRetailPrice,
//           WalletTopUpAmount: store.WalletTopUpAmount,
//           EditWalletTopUpAmount: store.EditWalletTopUpAmount,

//           MRP: store.MRP,
//         }));
//         setStoreSpecificPricesRows([{ Store: "", StoreID: "", SupplyPrice: "", MSP: "", MarginAmount: "", MarginPercentage: "", RetailPrice: "", DiscountPercentage: "", DiscountAmount: "", MRP: "" }, ...storeRowsData]);

//       }


//       if (product.UOM) {
//         const selectedUOM = uomOptionData.find(option => option.value === product.UOM);
//         setPrimaryUomValue(product.UOM);
//         setPrimaryUomLabel(selectedUOM.label);
//       }
//       if (product.SalesUOM) {
//         try {
//           const salesSelectedUOM = uomOptionData.find(option => option.value === product.SalesUOM);
//           setDefaultSalesUOMValue(product.SalesUOM);
//           setDefaultSalesUOMLabel(salesSelectedUOM.label);
//         }
//         catch (err) {
//           setDefaultSalesUOMValue("");
//           setDefaultSalesUOMLabel("");
//         }
//       }
//       if (product.PurchaseUOM) {
//         try {
//           const purchaseSelectedUOM = uomOptionData.find(option => option.value === product.PurchaseUOM);
//           setDefaultPurchaseUOMValue(product.PurchaseUOM);
//           setDefaultPurchaseUOMLabel(purchaseSelectedUOM.label);
//         }
//         catch (e) {
//           setDefaultPurchaseUOMValue("");
//           setDefaultPurchaseUOMLabel("");
//         }
//       }
//       if (product.UOM) {
//         const selectedUOM = uomOptionData.find(option => option.value === product.UOM);
//         setPrimaryUomValue(product.UOM);
//         setPrimaryUomLabel(selectedUOM.label);
//       }
//       if (product.SalesUOM) {
//         try {
//           const salesSelectedUOM = uomOptionData.find(option => option.value === product.SalesUOM);
//           setDefaultSalesUOMValue(product.SalesUOM);
//           setDefaultSalesUOMLabel(salesSelectedUOM.label);
//         }
//         catch (err) {
//           setDefaultSalesUOMValue("");
//           setDefaultSalesUOMLabel("");
//         }
//       }
//       if (product.PurchaseUOM) {
//         try {
//           const purchaseSelectedUOM = uomOptionData.find(option => option.value === product.PurchaseUOM);
//           setDefaultPurchaseUOMValue(product.PurchaseUOM);
//           setDefaultPurchaseUOMLabel(purchaseSelectedUOM.label);
//         }
//         catch (e) {
//           setDefaultPurchaseUOMValue("");
//           setDefaultPurchaseUOMLabel("");
//         }
//       }



//       if (product.SecondaryUOMs && product.SecondaryUOMs.length > 0) {
//         // Map the fetched data to the state
//         const secondaryUoms = product.SecondaryUOMs.map((data) => ({
//           secondaryUOM: data.SecondaryUOM,
//           secondaryUOMValue: data.SecondaryUOMValue,
//           conversion: data.Conversion.toString(),
//         }));

//         // Set the state with the fetched data
//         setUomTableRows([{ secondaryUOM: "", secondaryUOMValue: "", conversion: "" }, ...secondaryUoms]);

//         // Create default UOM options from the fetched data
//         const primaryUomObj = {
//           value: product.UOM,
//           label: uomOptionData.find(option => option.value === product.UOM)?.label || product.UOM
//         };

//         const secondaryUomObjs = product.SecondaryUOMs.map(data => ({
//           value: data.SecondaryUOMValue,
//           label: data.SecondaryUOM
//         }));

//         setDefaultUomOptions([primaryUomObj, ...secondaryUomObjs]);
//       }
//       // Set variants and attributes
//       // Set Attributes and Variants
//       if (product.Attributes && product.Attributes.length > 0) {
//         const attributeRows = product.Attributes.map((attr) => ({
//           attribute: attr.Attribute,
//           values: attr.AttributeValues.map((val) => val.value),
//         }));
//         setAddAttributeRow(attributeRows);
//       }
//       console.log("product.Variants", product?.Variants?.length);
//       if (product?.Variants && product.Variants.length > 0) {
//         const variantRows =
//           product.Variants
//             .sort((a, b) =>
//               (a.SKU || "").localeCompare(b.SKU || "", undefined, {
//                 numeric: true,
//                 sensitivity: "base"
//               })
//             )
//             .map((variant) => ({
//               attribute: variant.Name,
//               sku: variant.SKU,
//               mrp: variant.MRP || "",
//               retailPrice: variant.RetailPrice || "",
//               supplyPrice: variant.SupplyPrice || "",
//               discountAmount: variant.DiscountAmount || "",
//               discountPercentage: variant.DiscountPercentage || "",
//               marginAmount: variant.MarginAmount || "",
//               marginPercentage: variant.MarginPercentage || "",
//               productID: variant.ProductID || "",
//               msp: variant.MSP || "",
//               skuError: variant.SKUError || "",
//               isDeleted: variant.IsDeleted || false
//             })) || [];

//         console.log("variantRows", variantRows.length);
//         setAddVariantRow(variantRows);
//       }

//       //       if (product.Variants && product.Variants.length > 0) {
//       //         const variantRows = product.Variants.map((variant) => ({
//       //           attribute: variant.Name,
//       //           sku: variant.SKU,
//       //           mrp: variant.MRP || "",
//       // supplyPrice:variant.SupplyPrice || 0,
//       //           retailPrice: variant.RetailPrice || "",
//       //           discountAmount: variant.DiscountAmount || "",
//       //           discountPercentage: variant.DiscountPercentage || "",
//       //           productID:variant.ProductID || "",
//       //           msp:variant.MSP || ""
//       //         }));
//       //         setAddVariantRow(variantRows);
//       //       }



//       if (product.StoreSpecificQtys && product.StoreSpecificQtys.length > 0) {
//         // Map the fetched store quantities to match your storeQtys structure
//         const storeQtysData = product.StoreSpecificQtys.map(store => ({
//           StoreCode: store.StoreCode,
//           StoreID: store.StoreID,
//           StoreName: store.StoreName,
//           InStockQty: store.InStockQty,
//           MinQty: store.MinQty,
//           MaxQty: store.MaxQty,
//           ReorderQty: store.ReorderQty,

//         }));
//         setStoreQtys(storeQtysData);
//       }

//       if (product.Images && product.Images.length > 0) {
//         // Map through images and store in imgArray (you can set them directly to state)
//         setImgArray(product.Images.map(image => image.ImagePath)); // Assuming `ImagePath` holds the URL or Base64 string
//       }
//       console.log("porduct brand ", product.Brand, "category", product.Category);


//       if (product.Images && product.Images?.length > 0) {
//         // Map through images and store in imgArray (you can set them directly to state)
//         setImgArray(product.Images.map(image => image.ImagePath)); // Assuming `ImagePath` holds the URL or Base64 string
//       }
//       console.log("porduct brand ", product.Brand, "category", product.Category);


//     } catch (error) {
//       setDataLoading(false);
//       console.error("Error fetching single product data:", error);
//       toast.error("Error fetching product data.");
//     }
//   };

//   const fetchServices = async (packageSearchValue) => {
//     try {
//       const response = await fetchProducts(
//         packageSearchValue,
//         0,
//         packageSearchValue ? 1000 : 10,
//         "Services",

//         // filters.psin,
//         // filters.globalCatalogue === "all" ? "" : filters.globalCatalogue
//       );

//       if (response.code === "0") {
//         setServices(response?.products);
//       } else {
//         setServices([]);
//         toast.error(response.message || "Failed to fetch services!");
//       }
//     } catch (error) {
//       console.error(error);
//       toast.error("Error fetching products.");
//       setServices([]);
//     }
//   };


//   // Fetch all categories (do not filter by IsDeleted here)
//   const fetchcategoryData = async () => {
//     try {
//       const response = await fetchCategory();
//       const categories = response.productCategories.filter(
//         (e) => !e.IsDeleted);
//       setCategoryData(categories);
//     } catch (err) {
//       console.error("Error fetching categories:", err);
//     }
//   };

//   // Fetch API data on component mount
//   const fetchSubCategoriesData = async () => {
//     try {

//       const response = await fetchSubCategory();
//       const subCategory = response.productSubCategories.filter(
//         (e) => !e.IsDeleted);
//       // AxiosAPI.get(`/catalog/subcategories`);
//       setAllSubCategoryData(subCategory);

//       console.log("all sub category data :", response.productSubCategories);

//       // console.log("sub category data", response);
//     } catch (error) {
//       console.error("Error sub category:", error);
//     }
//   };

//   const fetchBrandsData = async () => {
//     try {
//       const response = await fetchBrands();
//       console.log("brand data", response.productBrands);
//       const brands = response.productBrands.filter(
//         (e) => !e.IsDeleted);
//       setBrandData(brands);
//     } catch (error) {
//       console.log(error);
//     }
//   };

//   const fetchTaxesData = async () => {
//     try {
//       const response = await fetchTaxes();
//       const filteredData = response.productTaxes.filter((tax) => tax.IsDeleted === false);
//       setTaxData(filteredData);
//       console.log("taxdata", taxData);
//     } catch (error) {
//       console.error("Error fetching taxes:", error);
//     }
//   };

//   const taxOption = taxData.map(item => ({
//     value: item.key,
//     label: item.TaxGroup
//   }));

//   const fetchstoredata = async () => {
//     try {
//       let response = await fetchStore();
//       console.log("store data", storeData.stores);  // Check if stores exist
//       const stores = response.stores.filter((e) => !e.IsDeleted)
//       setStoreData(stores);  // Assuming 'stores' is an array
//       if (!key) {
//         setStoreDataInInventory(stores);
//       }


//     } catch (error) {
//       console.log("store data error", error);
//     }
//   };

//   const fetchMembershipData = async () => {
//     try {
//       const response = await fetchMembership();
//       const filterData = response.MembershipData.filter((e) => !e.IsDeleted);
//       setMembershipData(filterData);
//     } catch (error) {
//       console.log("error in membership", error);
//     }
//   };




//   useEffect(() => {
//     fetchcategoryData();
//     fetchBrandsData();
//     fetchSubCategoriesData();
//     fetchTaxesData();
//     fetchstoredata();
//     fetchMembershipData();
//     fetchServices();
//   }, []);


//   const storeOptions = storeData.map(store => ({
//     value: store.key,  // Assuming 'key' is a unique identifier for each store
//     label: store.StoreName,  // Display the StoreName in the dropdown
//   }));


//   // Calculate Discount Percentage from Discount Amount and Retail Price
//   const calculateDiscountPercentage = (discountAmount, retailPrice) => {
//     if (retailPrice === 0) return 0; // To avoid division by zero
//     const discountPercentage = (discountAmount / retailPrice) * 100;
//     return  discountPercentage;
//   };

//   // Calculate Discount Amount from Discount Percentage and Retail Price
//   const calculateDiscountAmount = (discountPercentage, retailPrice) => {
//     if (retailPrice === 0) return 0; // To avoid division by zero
//     const discountAmount = (discountPercentage / 100) * retailPrice;
//     return discountAmount;
//   };

//   const handleImageUpload = async (image) => {
//     // Start loading
//     setimgLoading(true);
//     // Simulate image upload
//     const uploadurl = await uploadImagesToServer(image); // Replace with your actual upload logic

//     console.log("uploadurl", uploadurl);

//     if (uploadurl && imgArray.length < 4) {
//       setImgArray((prevImgArray) => [...prevImgArray, uploadurl]);
//     }
//     setimgLoading(false); // Stop loading after image is uploaded
//   };

//   const [showConfirmBox, setShowConfirmBox] = useState(false); // Controls visibility of confirm box
//   const [deleteIndex, setDeleteIndex] = useState(null); // Tracks the index of the image to delete
//   // Function to handle when the delete button is clicked
//   const handleImageDelete = (index) => {
//     setDeleteIndex(index); // Store the image index to delete
//     setShowConfirmBox(true); // Show the confirmation box
//   };

//   // Function to handle the image deletion confirmation
//   const handleConfirmDelete = () => {
//     if (deleteIndex !== null) {
//       // Remove the image from the array
//       const newImgArray = imgArray.filter((_, i) => i !== deleteIndex);
//       setImgArray(newImgArray);
//     }
//     setShowConfirmBox(false); // Hide the confirmation box after deletion
//   };

//   // Function to handle cancellation
//   const handleCancelDelete = () => {
//     setShowConfirmBox(false); // Hide the confirm box without doing anything
//   };


//   const handleRemoveClick = () => {
//     stateData(null);
//     setIsGc(false);
//     setProductName("");
//     setBarcode("");
//     setMrp("");
//     setRetailPrice("");

//     setMrpError("");
//     setProductNameError("");
//     setBarcodeError("");
//     setCategoryError("");
//     setProductName("");
//     setBarcode("");
//     setPsin("");
//     setMrp("");
//     setCustomField3("");
//     setCustomField1("");
//     setCustomField2("");
//     setCategoryName("");
//     setSubCategoryName("");
//     setBrandName("");
//     setImgArray([]);


//   };


//   //inventory specific storqty table 
//   const [storeQtys, setStoreQtys] = useState([]);

//   // Initialize storeQtys when storeDataInInventory changes
//   useEffect(() => {
//     if (storeDataInInventory.length > 0) {
//       setStoreQtys(storeDataInInventory.map(store => ({
//         StoreCode: store.StoreCode,
//         StoreID: store.key,
//         StoreName: store.StoreName,
//         InStockQty: 0,
//         MinQty: 0,
//         MaxQty: 0,
//         ReorderQty: 0,
//       })));
//     }
//   }, [storeDataInInventory]);


//   // Update handler
//   const handleQtyChange = (index, field, value) => {
//     const updatedQtys = [...storeQtys];
//     updatedQtys[index][field] = value;
//     setStoreQtys(updatedQtys);
//   };


//   //inventory specific qty close here

//   //table code 
//   // State to hold rows
//   const [storeSpecificPricesRows, setStoreSpecificPricesRows] = useState([{
//     Store: "",
//     StoreID: "",
//     SupplyPrice: 0,
//     MarginAmount: 0,
//     MarginPercentage: 0,
//     MSP: 0,
//     RetailPrice: 0,
//     DiscountPercentage: 0,
//     DiscountAmount: 0,
//     WalletTopUpSameAsRetailPrice: false,
//     WalletTopUpAmount: 0,
//     EditWalletTopUpAmount: false,
//     Markup:0,
//     MRP: 0
//   }]);

//   // Handle input changes
//   const handleStoreRowChange = (index, field, value) => {
//     const updatedRows = [...storeSpecificPricesRows];

//     if (field === 'storeSelection') {
//       updatedRows[index] = {
//         ...updatedRows[index],
//         Store: value.label,
//         StoreID: value.value
//       };
//     } else {
//       updatedRows[index][field] = value;

//       // Auto-calculate discount amounts
//       if (['RetailPrice', 'DiscountPercentage', 'DiscountAmount'].includes(field)) {
//         const retailPrice = parseFloat(updatedRows[index].RetailPrice) || 0;
//         const discountPercentage = parseFloat(updatedRows[index].DiscountPercentage) || 0;
//         const discountAmount = parseFloat(updatedRows[index].DiscountAmount) || 0;

//         if (field === 'DiscountPercentage') {
//           updatedRows[index].DiscountAmount = retailPrice ? ((discountPercentage / 100) * retailPrice).toFixed(2) : "";
//         } else if (field === 'DiscountAmount') {
//           updatedRows[index].DiscountPercentage = retailPrice ? ((discountAmount / retailPrice) * 100).toFixed(2) : "";
//         } else if (field === 'RetailPrice') {
//           if (updatedRows[index].DiscountPercentage) {
//             updatedRows[index].DiscountAmount = ((parseFloat(updatedRows[index].DiscountPercentage) / 100) * retailPrice).toFixed(2);
//           } else if (updatedRows[index].DiscountAmount) {
//             updatedRows[index].DiscountPercentage = retailPrice ? ((parseFloat(updatedRows[index].DiscountAmount) / retailPrice * 100).toFixed(2)) : "";
//           }
//         }
//       }
//     }

//     setStoreSpecificPricesRows(updatedRows);
//   };

//   // Add new row
//   const [storeError, setStoreError] = useState("");
//   const [retailPriceErrorUnderSpecificStore, setRetailPriceErrorUnderSpecificStore] = useState("");
//   const addStoreSpecificPriceRow = () => {
//     let storeError = "";
//     let retailPriceError = "";
//     // Check if store is already selected in other rows
//     const selectedStoreID = storeSpecificPricesRows[0].StoreID;
//     const isStoreAlreadyUsed = storeSpecificPricesRows.some(
//       (row, index) => index !== 0 && row.StoreID === selectedStoreID
//     );

//     if (!selectedStoreID) {
//       storeError = "Please select store!";
//     } else if (isStoreAlreadyUsed) {
//       storeError = "This store is already added!";
//     }

//     if (productTypeID !== 4) {
//       if (storeSpecificPricesRows[0].RetailPrice === "" || storeSpecificPricesRows[0].RetailPrice == 0) {
//         retailPriceError = "Please enter retail price!";
//       }
//     }



//     if (storeError !== "" || retailPriceError !== "") {
//       setStoreError(storeError);
//       setRetailPriceErrorUnderSpecificStore(retailPriceError);
//       return;
//     }

//     // Copy all values from first row
//     const firstRow = storeSpecificPricesRows[0];
//     setStoreSpecificPricesRows([
//       // Keep the store selection but clear other fields in first row
//       {
//         Store: "",
//         StoreID: "",
//         SupplyPrice: 0,
//         MarginAmount: 0,
//         MarginPercentage: 0,
//         MSP: 0,
//         RetailPrice: 0,
//         DiscountPercentage: 0,
//         DiscountAmount: 0,
//         WalletTopUpSameAsRetailPrice: false,
//         WalletTopUpAmount: 0,
//         EditWalletTopUpAmount: false,
//         Markup:0,
//         MRP: 0
//       },
//       // Add new row with all values from first row
//       ...storeSpecificPricesRows.slice(1),
//       {
//         Store: firstRow.Store,
//         StoreID: firstRow.StoreID,
//         SupplyPrice: firstRow.SupplyPrice,
//         MarginAmount: firstRow.MarginAmount,
//         MarginPercentage: firstRow.MarginPercentage,
//         MSP: firstRow.MSP,
//         RetailPrice: firstRow.RetailPrice,
//         DiscountPercentage: firstRow.DiscountPercentage,
//         DiscountAmount: firstRow.DiscountAmount,
//         WalletTopUpSameAsRetailPrice: firstRow.WalletTopUpSameAsRetailPrice,
//         WalletTopUpAmount: firstRow.WalletTopUpAmount,
//         EditWalletTopUpAmount: firstRow.EditWalletTopUpAmount,
//         Markup:firstRow?.Markup || 0,
//         MRP: firstRow.MRP
//       }
//     ]);
//   };

//   // Remove row
//   const removeStoreSpecificPriceRow = (index) => {
//     if (storeSpecificPricesRows.length <= 1) return;
//     const newRows = [...storeSpecificPricesRows];
//     newRows.splice(index, 1);
//     setStoreSpecificPricesRows(newRows);
//   };

//   //
//   // State to hold rows, where keys are dynamic based on the label
//   const [taxOnRetailPriceRows, setTaxOnRetailPriceRows] = useState([{
//     FromPrice: "",
//     ToPrice: "",
//     TaxID: "",
//     TaxGroup: "",
//   }]);

//   // Add a new row to the form
//   const addRow = () => {
//     setTaxOnRetailPriceRows([...taxOnRetailPriceRows, {
//       FromPrice: "",
//       ToPrice: "",
//       TaxID: "",
//       TaxGroup: ""
//     }]);
//   };

//   // Remove a row from the form
//   const removeRow = (index) => {
//     const newRows = [...taxOnRetailPriceRows];
//     newRows.splice(index, 1);
//     setTaxOnRetailPriceRows(newRows);
//   };

//   // Handle input changes dynamically based on the label
//   const handleInputChangeTaxOnRetailPrice = (index, label, value) => {
//     const updatedRows = [...taxOnRetailPriceRows];
//     updatedRows[index][label] = value;
//     setTaxOnRetailPriceRows(updatedRows);
//   };



//   //varinats code 
//   // State to manage the attribute input and error message
//   const [defineAttribute, setDefineAttribute] = useState("");
//   const [defineAttributeError, setDefineAttributeError] = useState("");
//   const [addAttributeRow, setAddAttributeRow] = useState([]); // State to hold added attribute rows
//   const [addVariantRow, setAddVariantRow] = useState([]); // State to manage the variant rows

//   const handleAddAttributeBtnClick = () => {
//     if (addAttributeRow.length >= 3) {
//       toast.error("You can only add up to 3 attributes.");
//       return;
//     }
//     if (defineAttribute.trim() === "") {
//       setDefineAttributeError("Please Enter Attribute");
//       return;
//     }

//     // Add a new row with the entered attribute name and empty values
//     const newRow = { attribute: defineAttribute, values: [] };
//     setAddAttributeRow([...addAttributeRow, newRow]);

//     // Reset the input and error message
//     setDefineAttribute("");
//     setDefineAttributeError("");
//   };

//   // Handle change in selected values for a particular row
//   const handleAutocompleteChange = (event, newValue, action, index) => {
//     const updatedRows = [...addAttributeRow];
//     const previousValues = [...updatedRows[index].values]; // Store previous values
//     updatedRows[index].values = newValue; // Update the specific row's values
//     setAddAttributeRow(updatedRows);

//     // Update the second table's Variant Name column with action and previous values
//     updateVariantTable(newValue, action, index, previousValues);
//   };

//   // Function to update the second table's Variant Name column
//   const updateVariantTable = (newValue, action, changedIndex, previousValues) => {
//     // Generate all combinations of values from the first table
//     const generateCombinations = (rows) => {
//       if (rows.length === 0) return [];
//       if (rows.length === 1) return rows[0].values;

//       return rows.reduce((acc, row) => {
//         if (row.values.length === 0) return acc;
//         if (acc.length === 0) return row.values;

//         return acc.flatMap((name) => row.values.map((value) => `${name} / ${value}`));
//       }, []);
//     };

//     // Generate all combinations
//     const variantNames = generateCombinations(addAttributeRow);

//     // Get current variant rows to preserve existing data
//     const currentVariantRows = [...addVariantRow];

//     // Create a map of existing variants for quick lookup
//     const existingVariantsMap = new Map();
//     currentVariantRows.forEach(row => {
//       existingVariantsMap.set(row.attribute, row);
//     });

//     // If a value was removed, handle soft deletion
//     if (action === 'removeOption') {
//       // Find which value(s) were removed by comparing with previous state
//       const removedValues = previousValues.filter(value => !newValue.includes(value));

//       if (removedValues.length > 0) {
//         removedValues.forEach(removedValue => {
//           // Find all variants that contain the removed value
//           const variantsToUpdate = currentVariantRows.filter(variant =>
//             variant.attribute.includes(removedValue)
//           );

//           // Update these variants - mark as deleted if they have productID, otherwise remove
//           variantsToUpdate.forEach(variant => {
//             if (variant.productID && variant.productID !== "") {
//               // Mark as deleted but keep in the array
//               existingVariantsMap.set(variant.attribute, {
//                 ...variant,
//                 isDeleted: true
//               });
//             } else {
//               // Remove completely if no productID
//               existingVariantsMap.delete(variant.attribute);
//             }
//           });
//         });
//       }
//     }

//     // Update the second table with the combined variant names while preserving existing data
//     const newVariantRows = variantNames.map((name) => {
//       // Check if this variant already exists
//       const existingVariant = existingVariantsMap.get(name);

//       if (existingVariant) {
//         // Return the existing variant with all its data preserved
//         return {
//           ...existingVariant,
//           attribute: name, // Keep the name in case it changed
//           isDeleted: false // Reset isDeleted if variant is recreated
//         };
//       } else {
//         // Create new variant with default values
//         return {
//           attribute: name,
//           sku: "",
//           skuError: "",
//           mrp: mrp || "",
//           retailPrice: retailPrice || "",
//           discountAmount: discountAmount || "",
//           discountPercentage: discountPercentage || "",
//           supplyPrice: supplyPrice || "",
//           marginPercentage: marginPercentage || "",
//           marginAmount: marginAmount || "",
//           msp: msp || "",
//           productID: "",
//           isDeleted: false
//         };
//       }
//     });

//     // Also include deleted variants that have productID (for data preservation)
//     const deletedVariantsWithProductID = Array.from(existingVariantsMap.values())
//       .filter(variant =>
//         variant.isDeleted &&
//         variant.productID &&
//         variant.productID !== "" &&
//         !variantNames.includes(variant.attribute)
//       );

//     // Combine new variants with preserved deleted variants
//     const finalVariantRows = [...newVariantRows, ...deletedVariantsWithProductID];

//     // Set the new variant rows, preserving existing data
//     setAddVariantRow(finalVariantRows);
//   };
//   // Handle remove row
//   const handleRemoveAttributeRow = (index) => {
//     const updatedRows = addAttributeRow.filter((_, rowIndex) => rowIndex !== index);
//     setAddAttributeRow(updatedRows);

//     // Update the variant table based on the new attribute rows
//     updateVariantTableAfterAttributeChange(updatedRows);
//   };

//   // Helper function to update variants when attributes change
//   const updateVariantTableAfterAttributeChange = (updatedAttributeRows) => {
//     const generateCombinations = (rows) => {
//       if (rows.length === 0) return [];
//       if (rows.length === 1) return rows[0].values;

//       return rows.reduce((acc, row) => {
//         if (row.values.length === 0) return acc;
//         if (acc.length === 0) return row.values;

//         return acc.flatMap((name) => row.values.map((value) => `${name} / ${value}`));
//       }, []);
//     };

//     const variantNames = generateCombinations(updatedAttributeRows);
//     const currentVariantRows = [...addVariantRow];

//     const existingVariantsMap = new Map();
//     currentVariantRows.forEach(row => {
//       existingVariantsMap.set(row.attribute, row);
//     });

//     const newVariantRows = variantNames.map((name) => {
//       const existingVariant = existingVariantsMap.get(name);
  
//       if (existingVariant) {
//         return {
//           ...existingVariant,
//           attribute: name,
//           isDeleted: false
//         };
//       } else {
//         return {
//           attribute: name,
//           sku: "",
//           skuError: "",
//           mrp: mrp || "",
//           retailPrice: retailPrice || "",
//           discountAmount: discountAmount || "",
//           discountPercentage: discountPercentage || "",
//           supplyPrice: supplyPrice || "",
//           marginPercentage: marginPercentage || "",
//           marginAmount: marginAmount || "",
//           msp: msp || "",
//           productID: "",
//           isDeleted: false
//         };
//       }
//     });

//     // Include deleted variants that have productID
//     const deletedVariantsWithProductID = Array.from(existingVariantsMap.values())
//       .filter(variant =>
//         variant.isDeleted &&
//         variant.productID &&
//         variant.productID !== "" &&
//         !variantNames.includes(variant.attribute)
//       );

//     const finalVariantRows = [...newVariantRows, ...deletedVariantsWithProductID];
//     setAddVariantRow(finalVariantRows);
//   };

//   // Handle SKU change
//   const handleSkuChange = (e, index) => {
//     const updatedRows = [...addVariantRow];
//     updatedRows[index].sku = e.target.value; // Convert to uppercase
//     updatedRows[index].skuError = "";
//     setAddVariantRow(updatedRows);


//   };





//   // Handle variant input value changes
//   // Handle variant input value changes
//   const handleVariantInputChange = (e, field, index) => {
//     const updatedRows = [...addVariantRow];

//     if (field === "marginAmount") {
//       updatedRows[index][field] = e.target.value;
//       let response = calculateMargin(e.target.value, updatedRows[index].supplyPrice, "amount");
//       console.log("response", response);
//       updatedRows[index]["retailPrice"] = response.retailPrice;
//       updatedRows[index]["marginPercentage"] = response.marginPercentage;
//     }
//     else if (field === "marginPercentage") {
//       updatedRows[index][field] = e.target.value;
//       let response = calculateMargin(e.target.value, updatedRows[index].supplyPrice, "percentage");
//       console.log("response", response);
//       updatedRows[index]["retailPrice"] = response.retailPrice;
//       updatedRows[index]["marginAmount"] = response.marginAmount;
//     }
//     else if (field === "retailPrice") {
//       updatedRows[index][field] = e.target.value;
//       let response = calculateMargin(e.target.value, updatedRows[index].supplyPrice, "retailPrice");
//       console.log("response", response);
//       updatedRows[index]["marginAmount"] = response.marginAmount;
//       updatedRows[index]["marginPercentage"] = response.marginPercentage;

//       if (e.target.value && updatedRows[index]["discountPercentage"]) {
//         const discountAmount = calculateDiscountAmount(parseFloat(updatedRows[index]["discountPercentage"]) || 0, e.target.value);
//         updatedRows[index]["discountAmount"] = discountAmount;
//       }
//       else {
//         updatedRows[index]["discountAmount"] = 0;
//       }

//     }
//     else if (field === "discountAmount") {
//       updatedRows[index][field] = e.target.value;
//       const retailPrice = updatedRows[index].retailPrice || 0;
//       const discountPercentage = calculateDiscountPercentage(parseFloat(e.target.value) || 0, retailPrice);
//       updatedRows[index]["discountPercentage"] = discountPercentage;
//     }
//     else if (field === "discountPercentage") {
//       updatedRows[index][field] = e.target.value;
//       const retailPrice = updatedRows[index].retailPrice || 0;
//       const discountAmount = calculateDiscountAmount(parseFloat(e.target.value) || 0, retailPrice);
//       updatedRows[index]["discountAmount"] = discountAmount;

//     }
//     else {
//       // For all other fields, just update the value
//       updatedRows[index][field] = e.target.value;
//     }

//     setAddVariantRow(updatedRows);
//   };

//   // Handle removing a row
//   const handleRemoveVariantRow = (index) => {
//     const variantToRemove = addVariantRow[index];

//     // Update variant rows
//     const updatedVariantRows = [...addVariantRow];
//     if (key || selectedProductID) {
//       updatedVariantRows[index].isDeleted = true;
//     } else {
//       updatedVariantRows.splice(index, 1);
//     }
//     setAddVariantRow(updatedVariantRows);

//     // Update attribute rows only if not in edit mode
//     // if (!key && !selectedProductID) {
//     updateAttributeRowsAfterVariantRemoval(updatedVariantRows);
//     // }
//   };

//   // Improved function that only removes values not used in any remaining variants
//   const updateAttributeRowsAfterVariantRemoval = (currentVariantRows) => {
//     // Get all active variant names (excluding deleted ones)
//     const activeVariantNames = currentVariantRows
//       .filter(variant => !variant.isDeleted)
//       .map(variant => variant.attribute);

//     // Extract all values used in active variants
//     const usedValues = new Set();
//     activeVariantNames.forEach(variantName => {
//       const parts = variantName.split(' / ');
//       parts.forEach(part => usedValues.add(part));
//     });

//     // Update attribute rows, keeping only values that are still used
//     const updatedAttributeRows = addAttributeRow.map(row => {
//       const valuesToKeep = row.values.filter(value =>
//         usedValues.has(value)
//       );

//       return {
//         ...row,
//         values: valuesToKeep
//       };
//     });

//     setAddAttributeRow(updatedAttributeRows);
//   };
//   const splitCombinations = (combinedString, attributeCount = 3) => {
//     // Handle case where input might be an array instead of a single string
//     if (Array.isArray(combinedString)) {
//       return combinedString.map(str => splitCombinations(str, attributeCount));
//     }

//     const parts = combinedString.split(' / ');
//     const result = {};

//     for (let i = 0; i < attributeCount; i++) {
//       result[`Attribute${i + 1}`] = parts[i] || "";
//     }

//     return result;
//   };

//   const prepareVariantDataForDatabase = () => {
//     // Extract attributes
//     const attributes = addAttributeRow.map((row) => row.attribute);

//     // Prepare variant data
//     const variants = addVariantRow.map((variant) => {
//       console.log("variant ", variant);
//       const variantName = variant.attribute;
//       const sku = variant.sku;
//       if (!autoGenerateSKU) {
//         if (sku == "") {
//           toast.error("please enter sku");
//           return;
//         }
//       }
//       let attribute = splitCombinations(variantName, 3);
//       console.log("attribute", attribute);
//       return {
//         ...attribute,
//         DiscountAmount: variant.discountAmount || 0,
//         DiscountPercentage: variant.discountPercentage || 0,
//         IsDeleted: variant.isDeleted,
//         MRP: variant.mrp || 0,
//         MSP: variant.msp || 0,
//         Name: variantName,
//         ProductID: variant.productID,
//         RetailPrice: variant.retailPrice || 0,
//         MarginAmount: variant.marginAmount || 0,
//         MarginPercentage: variant.marginPercentage || 0,
//         SKU: sku,
//         SKUError: variant.skuError,
//         SupplyPrice: variant.supplyPrice || 0,
//       };
//     });

//     return {
//       Attributes: addAttributeRow.map((row) => ({
//         Attribute: row.attribute,
//         AttributeValues: row.values.map((value) => ({ label: value, value })),
//       })),
//       Variants: variants,
//     };
//   };

//   //uom code here
//   const [uomTableRows, setUomTableRows] = useState([{ secondaryUOM: "", secondaryUOMValue: "", conversion: "" }]);
//   const [primaryUomValue, setPrimaryUomValue] = useState("");
//   const [primaryUomLabel, setPrimaryUomLabel] = useState("");
//   const [secondaryUomSelectError, setSecondaryUomSelectError] = useState("");
//   const [conversionErrorMessage, setConversionErrorMessage] = useState("");
//   const [primaryUomError, setPrimaryUomError] = useState("");
//   const [defaultUomOptions, setDefaultUomOptions] = useState([]);

//   // Handle Secondary UOM Select Change
//   const handleSecondaryUOMChange = (index, item) => {
//     const updatedRows = [...uomTableRows];
//     updatedRows[index].secondaryUOM = item.label;
//     updatedRows[index].secondaryUOMValue = item.value;
//     setUomTableRows(updatedRows);
//   };

//   // Handle Conversion Input Change
//   const handleConversionChange = (index, e) => {
//     const value = e.target.value;
//     const updatedRows = [...uomTableRows];
//     updatedRows[index].conversion = value;
//     setUomTableRows(updatedRows);
//   };

//   // Handle Add Button Click
//   const handleAddUomRow = () => {
//     const firstRow = uomTableRows[0];

//     let primaryUomError = "";
//     let secondaryUomSelectError = "";
//     let conversionErrorMessage = "";

//     // Validate if Primary UOM is selected
//     if (primaryUomLabel.trim() == "" || !primaryUomLabel) {
//       primaryUomError = "Please select a Primary UOM";
//     }

//     // Validate if Secondary UOM is selected
//     if (!firstRow.secondaryUOM) {
//       secondaryUomSelectError = "Please select a Secondary UOM";
//     }

//     // Validate if Conversion is entered
//     if (!firstRow.conversion) {
//       conversionErrorMessage = "Please enter conversion value";
//     }

//     if (primaryUomError !== "" || secondaryUomSelectError !== "" || conversionErrorMessage !== "") {
//       setPrimaryUomError(primaryUomError);
//       setSecondaryUomSelectError(secondaryUomSelectError);
//       setConversionErrorMessage(conversionErrorMessage);
//       return;
//     }

//     // Create objects for primary and secondary UOMs
//     const primaryUomObj = { value: primaryUomValue, label: primaryUomLabel };
//     const secondaryUomObj = {
//       value: firstRow.secondaryUOMValue,
//       label: firstRow.secondaryUOM
//     };

//     // Update the defaultUomOptions array with both objects
//     setDefaultUomOptions(prevOptions => {
//       // Combine both objects into one array for checking
//       const newObjects = [];

//       // Only add primary if it doesn't exist
//       if (!prevOptions.some(option => option.value === primaryUomObj.value)) {
//         newObjects.push(primaryUomObj);
//       }

//       // Only add secondary if it's different from primary and doesn't exist
//       if (primaryUomObj.value !== secondaryUomObj.value &&
//         !prevOptions.some(option => option.value === secondaryUomObj.value)) {
//         newObjects.push(secondaryUomObj);
//       }

//       // If we have new objects to add, append them
//       if (newObjects.length > 0) {
//         return [...prevOptions, ...newObjects];
//       }

//       return prevOptions;
//     });

//     // Add a new row with the selected Primary UOM, Secondary UOM, and Conversion
//     setUomTableRows([
//       ...uomTableRows,
//       {
//         secondaryUOM: firstRow.secondaryUOM,
//         secondaryUOMValue: firstRow.secondaryUOMValue,
//         conversion: firstRow.conversion
//       }
//     ]);

//     // Clear the first row fields
//     setUomTableRows((prevRows) => [
//       { secondaryUOMValue: "", secondaryUOM: "", conversion: "" },
//       ...prevRows.slice(1)
//     ]);

//     // Log the data to the console
//     const dataToLog = uomTableRows
//       .slice(1) // Exclude the first row (add row)
//       .map((row) => ({
//         SecondaryUOM: row.secondaryUOM,
//         Conversion: parseFloat(row.conversion),
//         SecondaryUOMValue: row.secondaryUOMValue
//       }));

//     console.log(dataToLog);
//     console.log("Default UOM Options:", [...defaultUomOptions, primaryUomObj, secondaryUomObj]);
//   };

//   // Handle Remove Button Click
//   const handleRemoveUomRow = (index) => {
//     const updatedRows = uomTableRows.filter((_, i) => i !== index);
//     setUomTableRows(updatedRows);

//   };
//   let SecondaryUomData = uomTableRows
//     .slice(1) // Exclude the first row (add row)
//     .map((row) => ({
//       SecondaryUOM: row.secondaryUOM,
//       Conversion: parseFloat(row.conversion),
//       SecondaryUOMValue: row.secondaryUOM.substring(0, 3).toUpperCase() // Example: "DRUMS" -> "DRM"
//     }));

//   //save functionality 
//   const handlesaveclick = async () => {
//     if (!autoGenerateSKU) {
//       // Check for empty SKUs and set errors
//       const hasEmptySkus = addVariantRow.some(variant => variant.sku.trim() === "");

//       if (hasEmptySkus) {
//         const updatedRows = addVariantRow.map(variant => {
//           if (variant.sku.trim() === "") {
//             return { ...variant, skuError: "Please enter SKU" };
//           }
//           return variant;
//         });
//         setAddVariantRow(updatedRows);
//         toast.error("Please enter SKU for all variants");
//         return;
//       }
//     }
//     // Reset all errors first
//     let productTypeError = "";
//     let productNameError = "";
//     let skuError = "";
//     let barcodeError = "";
//     let categoryError = "";
//     let retailPriceError = "";
//     let mrpError = "";
//     let mrpAndRetailPriceError = "";
//     let walletTopUpError = "";
//     let packageServicesError = "";
//     let validityInDaysError = "";

//     if ((!soldAtSpecificStoresOnly) &&
//       productTypeID === 4 &&
//       !walletTopUpSameAsRetailPrice &&
//       walletTopUpAmount === 0
//     ) {
//       walletTopUpError = "Please provide wallet recharge value";
//     }

//     if (productType.trim() === "") {
//       productTypeError = "Please select product type!";
//     }



//     if (productName.trim() === "") {
//       productNameError = "Please provide product name!";
//     }
//     if (sku.trim() === "") {
//       skuError = "Please provide SKU!";
//     }

//     if (categoryName.trim() === "") {
//       categoryError = "Please select category!";
//     }
//     if (!soldAtSpecificStoresOnly) {
//       if (retailPrice == "") {
//         retailPriceError = "Please provide retail price!";
//       }

//     }

//     // Special case for MRP < Retail Price
//     console.log("mrp", mrp, "retailprice", retailPrice);
//     if (retailPrice < 0) {
//       retailPriceError = "Retail price cannot be negative";
//     }
//     if (mrp < 0) {
//       mrpError = "MRP cannot be negative";
//     }


//     if (mrp > 0 && retailPrice > 0) {
//       const mrpNum = Number(mrp);
//       const retailPriceNum = Number(retailPrice);
//       if (mrpNum < retailPriceNum) {
//         console.log("error occurred");
//         mrpAndRetailPriceError = "MRP can't be less than retail price!";
//         retailPriceError = "please enter correct retail price";
//         mrpError = "please enter correct mrp price";
//       } else {
//         console.log("error not occurred");
//         mrpAndRetailPriceError = "";
//         retailPriceError = "";
//         mrpError = "";
//       }
//     }
//     // if ((mrp && retailPrice)) {
//     //   if(mrp>=retailPrice){
//     //   mrpAndRetailPriceError = "";
//     //   retailPriceError = "";
//     //   mrpError = "";
//     //   }
//     // }
//     if (productTypeID === 5) {
//       if (validityInDays == "") {
//         validityInDaysError = "Please provide validity in day's";
//         // console.log('validityInDaysError',validityInDaysError)
//       }
//       if (packageServices.length === 0) {
//         packageServicesError = "Please select atleast one service.";
//         // console.log('packageServicesError',packageServicesError)
//       }
//     }



//     // Check if any errors exist
//     if (productTypeError || productNameError || skuError || barcodeError || categoryError ||
//       retailPriceError || mrpError || mrpAndRetailPriceError || walletTopUpError || validityInDaysError || packageServicesError) {
//       topRef.current?.scrollIntoView({ behavior: 'smooth' });
//       //  toast.error("Please enter mandatory fields!");
//       setproductTypeError(productTypeError);
//       setProductNameError(productNameError);
//       setSkuError(skuError);
//       setBarcodeError(barcodeError);
//       setCategoryError(categoryError);
//       setRetailPriceError(retailPriceError);
//       setMrpError(mrpError);
//       setMrpAndRetailPriceError(mrpAndRetailPriceError);
//       setWalletTopUpError(walletTopUpError);
//       setValidityInDaysError(validityInDaysError);
//       setPackageServiceError(packageServicesError);
//       setError(true);
//       return;
//     }
//     setMrpAndRetailPriceError("");
//     setError(false);
//     setDataLoading(true);

//     const images = imgArray.map((image) => ({
//       ImagePath: image,
//       ImageSize: ""
//     }));
//     let hasError = false;
//     // Build the payload
//     const payload = {
//       IsDeleted: false,
//       Name: productName,
//       SKU: sku,
//       BarCode: barcode,
//       Category: categoryName,
//       CategoryID: categoryId,
//       Description: shortDescription,
//       LongDescription: longDescription,
//       SubCategory: subCategoryName,
//       SubCategoryID: subCategoryId,
//       Brand: brandName,
//       BrandID: brandId,
//       SupplyPrice: Number(supplyPrice),
//       MSP: Number(msp),
//       MarginAmount: Number(marginAmount),
//       MarginPercentage: Number(marginPercentage),
//       RetailPrice: Number(retailPrice),
//       DiscountAmount: Number(discountAmount),
//       DiscountPercentage: Number(discountPercentage),
//       MRP: Number(mrp),
//       ChargeTaxOnProduct: chargeTaxesonthisProduct,
//       TaxInclusive: taxInclusiveSales,
//       TaxInclusivePurchase: taxInclusivePurchase,
//       HSNSACCode: hsnSacCode,
//       TaxGroup: taxDropDownLabel,
//       TaxID: taxDropDownValue,
//       InventoryType: inventoryDropDownValue,
//       Favourite: favourite,
//       AllowPriceEdit: allowPriceEdit,
//       AllowDiscount: discountable,
//       AllowTaxChange: allowTaxChange,
//       QtyPrompt: PromptforQtyattheTimeBilling,
//       OMNIEnabled: OMNIEnabled,
//       SequenceNo: sequenceNo,
//       RepackProduce: repackProduce,
//       OutOfStock: outOfStock,
//       Membership: membership,
//       MembershipID: membershipID,
//       BOM: bom,
//       BOMManual: bomManual,
//       CanBeUsedAsConsumable: canbeUsedasConsumable,
//       ShowAsAdditionalCharges: showAdditionalChargesonBillPrint,
//       StoreSpecificQtys: storeQtys,
//       Images: images,
//       CustomField1: customFeild1,
//       CustomField2: customFeild2,
//       CustomField3: customFeild3,
//       CustomField4: customFeild4,
//       CustomField5: customFeild5,
//       CustomField6: customFeild6,
//       UniqueLabel: uniqueLabel,
//       BatchTrackingBatchNoRequired: batchTrackingBatchNoRequired,
//       BatchTrackingMRPRequired: batchTrackingMRPRequired,
//       BatchTrackingMfgDateRequired: batchTrackingMfgDateRequired,
//       BatchTrackingDateFormat: batchTrackingDateFormat,
//       BatchTrackingExpDateRequired: batchTrackingExpDateRequired,
//       SecondaryUOMs: SecondaryUomData,
//       SalesUOM: defaultSalesUOMValue,
//       PurchaseUOM: defaultPurchaseUOMValue,
//       UOM: primaryUomValue,
//       ProductType: productType,
//       ProductTypeID: productTypeID,
//       PackagingCharges: packagingCharges,
//       AssociateMembership: associateMembership,
//       StoreSpecificPrices: storeSpecificPricesRows.slice(1),
//       StoreSpecificPricing: someStoresHaveDifferentPricing,
//       AccessibleToSelectedStores: soldAtSpecificStoresOnly,
//       TaxPriceRange: taxOnRetailPriceRows,
//       PriceBasedTax: taxBaseOnRetailPrice,
//       WalletTopUpSameAsRetailPrice: walletTopUpSameAsRetailPrice,
//       WalletTopUpAmount: walletTopUpSameAsRetailPrice
//         ? retailPrice
//         : walletTopUpAmount,
//       EditWalletTopUpAmount: editWalletTopUpAmount,
//       PackageServices: packageServices,
//       Markup:markup || 0,
//       ValidityInDays: Number(validityInDays),
//       ServiceDuration: serviceDuration,
//       AutoGenerateSKU: autoGenerateSKU,
//       MaxOrderQty: Number(maxOrderQty),
//       ...prepareVariantDataForDatabase(),

//     };
//     // let omniTag = "",
//     //   prodName = "",
//     //   prodSKU = "";
//     // prodName = payload.Name.replace(
//     //   /[@!&\/\\#,+()$~%.'"`_:*?<>{}-]/g,
//     //   ""
//     // ).replace(/[' ']/g, "_");
//     // prodSKU = payload.SKU.replace(
//     //   /[@!&\/\\#,+()$~%.'"`_:*?<>{}-]/g,
//     //   ""
//     // ).replace(/[' ']/g, "_");
//     // omniTag = prodName + "_" + prodSKU;
//     // payload.OMNITag = omniTag;
//     console.log("payloaddata--", payload)
//     // If editing, include the identifier in the payload
//     if (payload.Variants?.length > 0 && !autoGenerateSKU) {
//       const skus = payload.Variants.map((item) => item.SKU?.trim());
//       const skuExistResponse = await checkSkusAlreadyExist(payload?.Variants);

//       const updatedRows = [...addVariantRow];
//       let hasDuplicate = false;

//       skuExistResponse?.result?.forEach((res) => {
//         // Update ALL rows that match this SKU, not just the first one
//         updatedRows.forEach((row, rowIndex) => {
//           console.log(row.sku + "-> " + res.sku);
//           if (row.sku == res.sku) {
//             if (res.code === "1") {
//               updatedRows[rowIndex].skuError = "SKU already exists!";
//               hasDuplicate = true;
//             } else {
//               updatedRows[rowIndex].skuError = "";
//             }
//           }
//         });
//       });
//       setAddVariantRow(updatedRows);
//       if (hasDuplicate) {
//         toast.error("Please check variants sku !");
//         hasError = true;
//         setDataLoading(false);
//         return;
//       }
//     }


//     if (payload.Variants?.length > 0) {
//       const hasDuplicate = payload.Variants.some(
//         (item) => item.skuError && item.skuError !== ""
//       );


//       if (hasDuplicate) {
//         toast.error("Please check variants sku !");
//         setDataLoading(false);
//         hasError = true;
//         return;
//       }
//     }

//     try {
//       let response;
//       if (key) {
//         response = await handleEditProduct(payload, key);
//       } else {
//         response = await handleAddProduct(payload);
//       }

//       if (response?.code === "0") {
//         toast.success(`Product ${key ? "updated" : "created"} successfully`);

 

//         if (onSave) {
//           onSave(response.product);
//           onClose();
//         }
//       } else {
//         hasError = true;
//         toast.error(
//           response?.message || `Product ${key ? "update" : "creation"} failed`
//         );
        
//             const tempProduct = response?.product;
//             if (tempProduct?.Variants && tempProduct?.Variants?.length > 0) {
//               const variantRows = tempProduct.Variants.map((variant) => ({
//                 attribute: variant.Name,
//                 sku: variant.SKU,
//                 mrp: variant.MRP || "",
//                 retailPrice: variant.RetailPrice || "",
//                 supplyPrice: variant.SupplyPrice || "",
//                 discountAmount: variant.DiscountAmount || "",
//                 discountPercentage: variant.DiscountPercentage || "",
//                 productID: variant.ProductID || "",
//                 marginAmount: variant.MarginAmount,
//                 marginPercentage: variant.MarginPercentage,
//                 msp: variant.MSP || "",
//                 skuError: variant.SKUError || "",
//                 isDeleted: variant.IsDeleted,

//               }));
//               setAddVariantRow(variantRows);
//             }

//             return;
//       }
//     } catch (error) {
//       hasError = true;
//       if (error.response) {
//         toast.error(error.response.data?.message || "An error occurred");
//       } else if (error.request) {
//         toast.error("No response from server");
//       } else {
//         toast.error(error.message || "An error occurred");
//       }
//     } finally {
//       // setTimeout(() => {
//       //   if (!onSave) {
//       //     navigate("/catalogue/product");
//       //   }
//       //   setDataLoading(false);
//       // }, 3000); // 5000 ms = 5 seconds
//       if (!hasError) {
//         setTimeout(() => {
//           if (!onSave) {
//             navigate("/catalogue/product");
//           }
//           setDataLoading(false); // stop loader after navigation
//         }, 3000);
//       } else {
//         setDataLoading(false);
//       }

//     }



//   };

//   const handleCancel = () => {
//     if (onSave) {
//       onClose();
//     }
//     else {
//       navigate(-1);
//     }
//   }

//   const resetInventoryFields = () => {
//     setPrimaryUomLabel("");
//     setPrimaryUomValue("");


//     SecondaryUomData = [];
//     setDefaultUomOptions([]);
//     setUomTableRows([{ secondaryUOM: "", secondaryUOMValue: "", conversion: "" }]);
//     setUniqueLabel("");
//     setDefaultPurchaseUOMLabel("");
//     setDefaultPurchaseUOMLabel("");
//     setDefaultSalesUOMLabel("");
//     setDefaultSalesUOMValue("");
//     setDefineAttribute("");
//     setAddAttributeRow([]);
//     setAddVariantRow([]);

//     setAutoGenerateSKU(false);
//     setBatchTrackingBatchNoRequired(false);
//     setBatchTrackingMfgDateRequired(false);
//     setBatchTrackingMRPRequired(false);
//     setBatchTrackingExpDateRequired(false);
//   }

//   const onProductTypeChange = (type) => {
//     let productTypeID = type.id;
//     let productType = type.label;

//     if (productTypeID !== "") {
//       setproductTypeError("");
//     }

//     setproductTypeID(productTypeID),
//       setProductType(productType);
//     setInventoryDropDownValue("FIFO");
//     resetInventoryFields();


//   };


//   console.log("gc", customFeild2, "customerField4", customFeild4);

//   const inventoryInfo = {
//     FIFO: {
//       title: "FIFO (First In – First Out)",
//       meaning: "The products you bought first are sold first.",
//       whyUseful:
//         "Helps in keeping old stock moving, avoids expired or outdated products staying in storage.",
//       bestFor:
//         "Grocery stores, supermarkets, pharmacies (milk, bread, medicines – sell older stock first).",
//       example:
//         "If you buy 10 milk packets today and 10 more tomorrow, the system will sell today’s 10 packets first.",
//     },
//     "Unique No": {
//       title: "Unique No",
//       meaning:
//         "Each product or service gets a unique identification number (like a code).",
//       whyUseful: "Easy to track and manage products individually.",
//       bestFor:
//         "Electronics, appliances, jewelry, services (where each item has a serial number or code).",
//       example:
//         "A mobile phone with IMEI number or a gold chain with a unique tag.",
//     },
//     Variants: {
//       title: "Variants",
//       meaning: "Same product but in different options like size, color, or type.",
//       whyUseful:
//         "Makes it easy to manage multiple versions of the same product under one product name.",
//       bestFor: "Clothing, shoes, cosmetics, accessories.",
//       example:
//         "A T-shirt in sizes S, M, L, XL or a lipstick available in Red, Pink, and Nude shades.",
//     },
//     "Batch Tracking": {
//       title: "Batch Tracking",
//       meaning:
//         "Products are tracked based on their batch number, manufacturing date, and expiry date.",
//       whyUseful: "Important for products that expire or need quality tracking.",
//       bestFor: "Medicine shops, food products, cosmetics, chemicals.",
//       example:
//         "A batch of medicines manufactured in January with expiry in December – helps sell before expiry.",
//     },
//   };
//   const renderInfoText = (data) => {
//     if (!data) return null;

//     return (
//       <div className="space-y-2 text-sm leading-relaxed">
//         <p>
//           <span className="font-semibold">{data.title}</span>
//         </p>
//         {data.meaning && (
//           <p>
//             <span className="font-semibold">Meaning: </span>
//             {data.meaning}
//           </p>
//         )}
//         {data.whyUseful && (
//           <p>
//             <span className="font-semibold">Why useful: </span>
//             {data.whyUseful}
//           </p>
//         )}
//         {data.bestFor && (
//           <p>
//             <span className="font-semibold">Best for: </span>
//             {data.bestFor}
//           </p>
//         )}
//         {data.example && (
//           <p>
//             <span className="font-semibold">Example: </span>
//             {data.example}
//           </p>
//         )}
//       </div>
//     );
//   };

//   const calculateMargin = (inputValue, supplyPrice, inputType = 'percentage') => {
//     // Convert inputValue to number and validate
//     const numValue = parseFloat(inputValue) || 0;
//     const numSupplyPrice = parseFloat(supplyPrice) || 0;

//     if (numSupplyPrice <= 0) {
//       return {
//         retailPrice: 0,
//         marginAmount: 0,
//         marginPercentage: 0,
//         supplyPrice: numSupplyPrice,
//         inputType: inputType
//       };
//     }

//     let retailPriceResult, marginAmount, marginPercentage;

//     if (inputType === 'percentage') {
//       // Markup calculation (percentage of cost price)
//       marginPercentage = numValue;
//       retailPriceResult = numSupplyPrice * (1 + (marginPercentage / 100));
//       marginAmount = retailPriceResult - numSupplyPrice;
//     }
//     else if (inputType === 'amount') {
//       // Calculate based on margin amount (markup on cost price)
//       marginAmount = numValue;
//       retailPriceResult = numSupplyPrice + marginAmount;
//       // Margin percentage based on cost price (markup percentage)
//       marginPercentage = (marginAmount / numSupplyPrice) * 100;
//     }
//     else if (inputType === 'retailPrice') {
//       // Calculate based on retail price input
//       retailPriceResult = numValue;
//       marginAmount = retailPriceResult - numSupplyPrice;
//       // Margin percentage based on cost price (markup percentage)
//       marginPercentage = (marginAmount / numSupplyPrice) * 100;
//     }

//     return {
//       retailPrice: Math.round(retailPriceResult * 100) / 100,
//       marginAmount: Math.round(marginAmount * 100) / 100,
//       marginPercentage: Math.round(marginPercentage * 100) / 100,
//       supplyPrice: numSupplyPrice,
//       inputType: inputType
//     };
//   }
//   useEffect(() => {
//     console.log("addVariantRow-->", addVariantRow);

//   }, [addVariantRow])
//   return (

//     <CreatePage title={(key || selectedProductID) ? "Edit Product" : "New Product"}
//       // handleCancel={handleCancel}
//       // handleCancel={handleCancel}
//       handleCancel={handleCancel}
//       handleSave={handlesaveclick}>
//       {dataLoading ? (
//         <Loading />
//       ) : (
//         <div className="grid gap-4" ref={topRef}>

//           {error && (
//             <div className="bg-[#FEEDEE] w-full rounded-lg relative"  >
//               <div className="m-5">
//                 <div className="flex justify-between items-start">
//                   <ul className="max-w-[90%] space-y-1 text-[#000000] list-disc list-inside ">
//                     {[productTypeError, productNameError, skuError, barcodeError, categoryError, mrpAndRetailPriceError, retailPriceError, mrpError, walletTopUpError, validityInDaysError, packagesServiceError]
//                       .filter(Boolean) // Filters out null/undefined/false values
//                       .map((errorMsg, index) => (
//                         <li key={index}>{errorMsg}</li>
//                       ))}
//                   </ul>
//                   <span
//                     onClick={() => setError(false)} // Clear all errors
//                     className="text-red-400 hover:text-red-800 ml-2 w-7 cursor-pointer"
//                   >
//                     <Icon type="remove" />
//                   </span>
//                 </div>
//               </div>
//             </div>
//           )}


//           <PageSection title="GENERAL DETAILS">

//             <div className="grid  mt-2 mb-5">


//               <div className={`grid mt-3 lg:grid-cols-3 sm:grid-cols-1 gap-6`}>

//                 <Select
//                   isMandatory={true}
//                   disabled={key || selectedProductID}
//                   fetchAllObject={true}
//                   label={"Type"}
//                   infoText={
//                     <>
//                       Goods for Sale – Physical items you sell (e.g., rice bag, shirt, mobile phone). <br />
//                       Goods not for Sale – Items you keep for internal use, not for customers (e.g., shop furniture, demo items). <br />
//                       Services – Non-physical things you sell (e.g., haircut, repair service). <br />
//                       Wallet Recharge – Recharge for customer wallet balance in POS. <br />
//                       Packages – Combination of goods or services sold together (e.g., combo meal, beauty package).
//                     </>
//                   }
//                   tooltipPosition="right"
//                   tooltipWidth={"500px"}
//                   value={productTypeID}
//                   options={[
//                     { label: "Goods for sale", value: "1", id: 1 },
//                     { label: "Goods not for sale", value: "2", id: 2 },
//                     { label: "Services", value: "3", id: 3 },
//                     { label: "Wallet Recharge", value: "4", id: 4 },
//                     { label: "Package", value: "5", id: 5 },
//                   ]}
//                   onChange={(e) => {
//                     console.log("e", e);
//                     setproductTypeID(e.id);
//                     setProductType(e.label);
//                     onProductTypeChange(e)
//                   }}
//                   errorMessage={productTypeError}
//                 />



//                 <Input
//                   infoText={"The name of the product/service shown while billing. If you want to show the name in another language for customers, you can enter it in that language.Example: Enter “Milk” in English and “दूध” in Hindi – on customer bill, “दूध” will be printed."}
//                   tooltipWidth={"400px"}
//                   tooltipPosition="right"
//                   label="Name"
//                   isMandatory={true}
//                   type="text"
//                   placeholder="Enter product name.."
//                   value={productName}
//                   onChange={(e) => {
//                     setProductName(e.target.value);
//                     if (e.target.value.trim() !== "") {
//                       setProductNameError("");
//                     }
//                   }}
//                   errorMessage={productNameError}
//                 />

//                 <div>
//                   <Input
//                     isMandatory={true}
//                     label="SKU (Stock Keeping Unit)"
//                     infoText={"A unique code you create for each product for internal tracking.Helps to quickly search products in your POS.Example: T-shirt Blue Large = SKU: TSH-BLU-L."}
//                     tooltipWidth={"300px"}
//                     type="text"
//                     placeholder="Enter sku.."
//                     value={sku}
//                     //disabled={(key || selectedProductID) || productAutoGeneratedSKU}
//                     disabled={productAutoGeneratedSKU}
//                     onChange={(e) => {
//                       setSku(e.target.value);
//                       if (e.target.value.trim() !== "") {
//                         setSkuError("");
//                       }
//                     }}
//                     errorMessage={skuError}
//                   />
//                 </div>

//                 <div>
//                   <Input
//                     isMandatory={false}
//                     label="Barcode (EAN, ISBN, UPC, GTIN, etc.)"
//                     infoText={<div>
//                       <h2>Enter or scan the product’s barcode</h2>
//                       <p>
//                         Enter or scan the product’s barcode (e.g., printed code on groceries, books, clothes).
//                         This helps in fast billing and accurate stock tracking.
//                       </p>

//                       <h3>Types of Barcodes</h3>
//                       <div>
//                         <strong>EAN / UPC</strong> → Common barcodes on most retail products worldwide (like groceries, packaged foods, clothes).
//                       </div>
//                       <div>
//                         <strong>ISBN</strong> → Barcode for books.
//                       </div>
//                       <div>
//                         <strong>GTIN</strong> → Global Trade Item Number – another format for international products.
//                       </div>
//                     </div>
//                     }
//                     tooltipWidth={"400px"}
//                     removeBtnOnclick={isGc && !key ? handleRemoveClick : false}
//                     type="text"
//                     placeholder="Enter barcode.."
//                     value={barcode}
//                     endtext={"Global Catalogue"}
//                     onEnter={() => { console.log("enter"), setCatalogueSearchDrawer(true); }}
//                     handleEndtextOnclick={() => { console.log("click"), setCatalogueSearchDrawer(true); }}
//                     onChange={(e) => {
//                       setBarcode(e.target.value);
//                       if (e.target.value.trim() !== "") {
//                         setBarcodeError("");
//                       }
//                     }}
//                     // disabled={isGc}
//                     errorMessage={barcodeError}
//                   />
//                 </div>

//                 {catalogueSearchDrawer && (
//                   <Cataloguesearchdrawer
//                     barcode={barcode}
//                     setDrawer={setCatalogueSearchDrawer}
//                     globalCatalogueData={fetchGlobalCatalogueObject}
//                   />
//                 )}

//                 {/* {psin && (
//                   <div>
//                     <Input
//                       label="PSIN"
//                       type="text"
//                       placeholder="Enter psin.."
//                       value={psin}
//                       onChange={(e) => setPsin(e.target.value)}
//                       disabled={true}
//                     />
//                   </div>
//                 )}

//                 {isPincode && customFeild2 === "GC" && (!customFeild4 || (!key && !selectedProductID)) && (
//                   <>
//                     <div>
//                       <Select
//                         label={"Catalogue Issue"}
//                         options={[
//                           { label: "Wrong grammage/weight/volume ", value: "Wrong grammage/weight/volume " },
//                           { label: "Wrong Product", value: "Wrong Product" },
//                           { label: "Offer Pack/Combo", value: "Offer Pack/Combo" },
//                           { label: "Wrong Variant", value: "Wrong Variant" },
//                         ]}
//                         onChange={(e) => { setCustomField4(e.target.value) }}
//                         value={customFeild4}
//                         disabled={key || selectedProductID}
//                       />
//                     </div>

//                     <div>
//                       <Input
//                         value={customFeild5}
//                         label="Catalogue Issue Remarks"
//                         type="text"
//                         placeholder="Enter catalogue issue remarks..."
//                         onChange={(e) => setCustomField5(e.target.value)}
//                         disabled={key || selectedProductID}
//                       />
//                     </div>
//                   </>
//                 )} */}



//                 {/* {!isGc && ( */}
//                 {(
//                   <>
//                     <div>
//                       <Autocompletesearch
//                         isMandatory={true}
//                         infoText={"The main group under which the product belongs.Example: “Clothing”, “Groceries”, “Electronics”."}
//                         tooltipWidth={"500px"}
//                         tooltipPosition="right"
//                         value={categoryName}
//                         label="Category"
//                         data={categoryData}
//                         filterKey={["Name"]}
//                         defaultDataCount={500}
//                         onChange={(value) => {
//                           if (value !== "") {
//                             setCategoryError("");
//                           }
//                           console.log("Category input changed:", value);
//                           setCategoryName("");
//                           setCategoryId("");
//                           setfilteredsubcategorydata([]);
//                         }}
//                         onSelect={(item) => {
//                           console.log("Category selected:", item);
//                           setCategoryName(item.Name);
//                           setCategoryId(item.key);
//                           setfilteredsubcategorydata(
//                             allSubCategoryData.filter(
//                               (category) =>
//                                 category.ParentID && category.ParentID.toLowerCase() === item.key.toLowerCase()
//                             )
//                           );
//                         }}
//                         placeholder="Search Category"
//                         showsearch={false}
//                         Addbutntext="Add Category"
//                         Addbuttonclick={() => setAddCategoryComp(true)}
//                         renderSuggestion={(item, index) => (
//                           <div>
//                             <p className="">{item.Name}</p>
//                           </div>
//                         )}
//                         errorMessage={categoryError}
//                       />
//                     </div>

//                     {addCategoryComp && <AddCategory closeDrawer={setAddCategoryComp} onSave={(data) => { console.log("category data adeed", data), setCategoryId(data.categoryID), setCategoryName(data.Name) }} />}

//                     <div>
//                       <Autocompletesearch
//                         infoText={"A smaller group inside the main category.Example: Under “Clothing” → “Men’s Shirts” or “Women’s Kurtis”."}
//                         tooltipWidth={"400px"}
//                         value={subCategoryName}
//                         label="Sub Category"
//                         data={filteredsubcategorydata}
//                         filterKey={["Name"]}
//                         defaultDataCount={500}
//                         onChange={(value) => console.log("sub category input changed:", value)}
//                         onSelect={(item) => {
//                           console.log("subcategory selected:", item);
//                           setSubCategoryId(item.key);
//                           setSubCategoryName(item.Name);
//                         }}
//                         placeholder="Search sub category"
//                         showsearch={false}
//                         Addbutntext="Add Sub Category"
//                         Addbuttonclick={() => setOpenSubCategory(true)}
//                         renderSuggestion={(item, index) => (
//                           <div>
//                             <p className="">{item.Name}</p>
//                           </div>
//                         )}
//                       />
//                     </div>

//                     {openSubCategory && (
//                       <AddSubCategory
//                         categoryID={categoryId}
//                         categoryName={categoryName}
//                         closeDrawer={setOpenSubCategory}
//                         onSave={(data) => {
//                           console.log("sub category data added", data);
//                           setSubCategoryId(data.categoryID);
//                           setSubCategoryName(data.Name);
//                         }}
//                       />
//                     )}

//                     <div>
//                       <Autocompletesearch
//                         infoText={"The brand name of the product.Example: Nike, Samsung, Nestle, Tata."}
//                         tooltipWidth={"300px"}
//                         tooltipPosition="right"
//                         value={brandName}
//                         label="Brand"
//                         data={brandData}
//                         filterKey={["Brand"]}
//                         defaultDataCount={500}
//                         onChange={(value) => console.log("brand input changed:", value)}
//                         onSelect={(item) => {
//                           console.log("Brand selected:", item);
//                           setBrandName(item.Brand);
//                           setBrandId(item.key);
//                         }}
//                         placeholder="Search Brand"
//                         showsearch={false}
//                         Addbutntext="Add Brand"
//                         Addbuttonclick={() => setOpenAddBrand(true)}
//                         renderSuggestion={(item, index) => (
//                           <div>
//                             <p className="">{item.Brand}</p>
//                           </div>
//                         )}
//                       />
//                     </div>

//                     {openAddBrand && <AddBrand closeDrawer={setOpenAddBrand} onSave={(data) => { console.log("brand data adeed ", data.brand), setBrandId(data.brandID), setBrandName(data.Brand) }} />}
//                   </>
//                 )}

//                 {/* {(isPincode && isGc) && (
//                   <>
//                     <div>
//                       <Input
//                         isMandatory={true}
//                         infoText={"The main group under which the product belongs.Example: “Clothing”, “Groceries”, “Electronics”."}
//                         tooltipWidth={"500px"}
//                         tooltipPosition="right"
//                         label="Category"
//                         type="text"
//                         placeholder="Enter category.."
//                         value={categoryName}
//                         onChange={(e) => setCategoryName(e.target.value)}
//                         disabled={true}
//                       />
//                     </div>

//                     <div>
//                       <Input
//                         infoText={"A smaller group inside the main category.Example: Under “Clothing” → “Men’s Shirts” or “Women’s Kurtis”."}
//                         tooltipWidth={"400px"}
//                         label="Sub Category"
//                         type="text"
//                         placeholder="Enter sub category.."
//                         value={subCategoryName}
//                         onChange={(e) => setSubCategoryName(e.target.value)}
//                         disabled={true}
//                       />
//                     </div>

//                     <div>
//                       <Input
//                         infoText={"The brand name of the product.Example: Nike, Samsung, Nestle, Tata."}
//                         tooltipWidth={"300px"}
//                         tooltipPosition="right"
//                         label="Brand"
//                         type="text"
//                         placeholder="Enter Brand.."
//                         value={brandName}
//                         onChange={(e) => setBrandName(e.target.value)}
//                         disabled={true}
//                       />
//                     </div>
//                   </>
//                 )} */}

//                 {productTypeID == 3 &&
//                   <Input
//                     label="Service Time"
//                     type="number"
//                     placeholder="service time"
//                     value={serviceDuration}
//                     onChange={(e) => {
//                       setServiceDuration(e.target.value);

//                     }}
//                   />

//                 }
//               </div>

//               <div>

//                 <div className="mt-[24px] grid grid-cols-1">

//                   <TextArea
//                     infoText={"A one-line description shown only on your online store (not needed if you don’t sell online).Example: “Soft cotton t-shirt with round neck.”"}
//                     tooltipPosition="right"
//                     tooltipWidth={"400px"}
//                     label={"Short Description"} value={shortDescription} onChange={(e) => { setShortDescription(e.target.value) }}
//                     h="100px"
//                     placeholder="Enter Short Description"
//                     errorMessage=""
//                   />

//                 </div>
//                 <div className="mt-[24px] grid grid-cols-1">
//                   {(registration?.key == "1hxUQlaTRjhvPlpZdsI9" || registration?.key == "Xj8lWQb4732SZePXyWdg" || registration?.key=="Txbnw2iE4NOS3lzj4gtF") ?

//                     <TextArea
//                       infoText={"Detailed product information (only for online store).Example: “100% pure cotton t-shirt, available in multiple sizes, machine washable.”"}
//                       tooltipPosition="right"
//                       tooltipWidth={"400px"}
//                       label={"Long Description"} value={longDescription} onChange={(e) => { setLongDescription(e.target.value) }}
//                       h="200px"
//                       placeholder="Enter Long Description"
//                       errorMessage=""
//                     />
//                     :
//                     <QuillEditor
//                       tooltipPosition="right"
//                       tooltipWidth={"400px"}
//                       infoText={"Detailed product information (only for online store).Example: “100% pure cotton t-shirt, available in multiple sizes, machine washable.”"}
//                       label={"Long Description"} minHeight="100px" value={longDescription} onChange={(content) => { setLongDescription(content) }} />

//                   }

//                 </div>

//               </div>
//             </div>
//           </PageSection>

//           <PageSection showInfoIcon={true} title="Images" tooltipWidth="500px" tooltipPosition={"right"} infoText={"Add up to 4 pictures of your product.Useful for online store display, helps customers recognize the item.Example: Front view, side view, color options."}>
//             <div className="grid gap-6 mt-5">
//               <div className="grid lg:grid-cols-1 sm:grid-cols-1">
//                 <div className="flex w-fit items-start">
//                   {/* Set the width to fit the content and align items to the start */}
//                   <div className="image-preview-container">
//                     {/* Show the image upload button if loading is false */}
//                     {imgLoading ? (
//                       <p>Uploading...</p>
//                     ) : (
//                       imgArray.length < 4 && (
//                         <ImageUpload
//                           onImagedelete={() => setImgArray([])} // Clear all images
//                           onImageChange={handleImageUpload} // Handle image change/upload
//                           isMultiple={true}
//                         />
//                       )
//                     )}
//                   </div>

//                   {/* Image Previewer in one row */}
//                   {imgArray.length > 0 && (
//                     <div className="ml-4 mt-2">
//                       <div className="flex space-x-4">
//                         {/* Display images in a row with spacing */}
//                         {imgArray.map((image, index) => (
//                           <div
//                             key={index}
//                             className="relative transition-transform duration-300 ease-in-out hover:scale-110 border border-[#d7d5e2] shadow"
//                           >
//                             <img
//                               src={image}
//                               alt="preview"
//                               className="h-[200px] w-[200px] object-cover" // Fixed size for preview
//                             />
//                             <button
//                               onClick={() => handleImageDelete(index)}
//                               className="cursor-pointer absolute right-1 bottom-1 bg-red-500 text-white rounded-full p-1"
//                             >
//                               <FaTimes />
//                             </button>
//                           </div>
//                         ))}
//                       </div>
//                     </div>
//                   )}
//                 </div>
//               </div>
//             </div>
//           </PageSection>



//           <PageSection title="Price & Taxes">
//             <div className="grid gap-6 mt-5">
//               {(!isMobileView() && storeOptions.length > 1) &&
//                 <div className="grid lg:grid-cols-5 sm:grid-cols-2 gap-3">
//                   <CustomSwitch
//                     formlabel="Sold at specific stores only"
//                     checked={soldAtSpecificStoresOnly}
//                     onChange={(checked) => {
//                       setSoldAtSpecificStoresOnly(checked);
//                       if (checked) setSomeStoresHaveDifferentPricing(false);
//                       setStoreSpecificPricesRows([
//                         // Keep the store selection but clear other fields in first row
//                         {
//                           Store: "",
//                           StoreID: "",
//                           SupplyPrice: 0,
//                           MarginAmount: 0,
//                           MarginPercentage: 0,
//                           MSP: 0,
//                           Markup:0,
//                           RetailPrice: 0,
//                           DiscountPercentage: 0,
//                           DiscountAmount: 0,
//                           WalletTopUpSameAsRetailPrice: false,
//                           WalletTopUpAmount: 0,
//                           EditWalletTopUpAmount: false,
//                           MRP: 0
//                         }]);
//                     }}
//                     infoText="Please select this option if this product is sold only in specific stores"
//                     tooltipPosition="right"
//                     tooltipWidth="450px"
//                   />
//                   {!soldAtSpecificStoresOnly &&
//                     <CustomSwitch
//                       formlabel="Some stores have different pricing"
//                       checked={someStoresHaveDifferentPricing}
//                       onChange={(checked) => {
//                         setSomeStoresHaveDifferentPricing(checked);
//                         if (checked) setSoldAtSpecificStoresOnly(false);
//                            setStoreSpecificPricesRows([
//                         // Keep the store selection but clear other fields in first row
//                         {
//                           Store: "",
//                           StoreID: "",
//                           SupplyPrice: 0,
//                           MarginAmount: 0,
//                           MarginPercentage: 0,
//                           MSP: 0,
//                           RetailPrice: 0,
//                           DiscountPercentage: 0,
//                           DiscountAmount: 0,
//                           WalletTopUpSameAsRetailPrice: false,
//                           WalletTopUpAmount: 0,
//                           Markup:0,
//                           EditWalletTopUpAmount: false,
//                           MRP: 0
//                         }]);
//                       }}
//                       infoText="Please select this option if product pricing is different at some stores"
//                       tooltipPosition="top"
//                       tooltipWidth="450px"
//                       disabled={soldAtSpecificStoresOnly} // Optional: disable if other switch is on
//                     />}
//                 </div>

//               }
//               {(!soldAtSpecificStoresOnly && productTypeID !== 4) &&
//                 <div className="grid lg:grid-cols-5 sm:grid-cols-2 gap-3">
//                   <Input
//                     infoText={`The price at which you buy the product from your supplier.
// (Your cost price / purchase price)`}
//                     tooltipPosition="top"
//                     tooltipWidth={"200px"}
//                     starttext={currencySymbol}
//                     label="Supply Price"
//                     placeholder=""
//                     type="number"
//                     value={supplyPrice}
//                     onChange={(e) => setSupplyPrice(e.target.value)}
//                   />
//                   <Input
//                     infoText={`The markup percentage applied to your supply price to calculate the retail price.
//   Formula: Retail Price = Supply Price × (1 + Margin% / 100)
//   Example: If supply price is 50 and margin is 40%, retail price = 50 × 1.4 = 70`}
//                     tooltipPosition="top"
//                     tooltipWidth={"400px"}
//                     label="Margin %"
//                     placeholder=""
//                     type="number"
//                     value={marginPercentage}
//                     onChange={(e) => {
//                       setMarginPercentage(e.target.value);
//                       let response = calculateMargin(e.target.value, supplyPrice, "percentage");
//                       console.log("response", response);
//                       setRetailPrice(response.retailPrice);
//                       // setMrp(response.mrp);
//                       setMarginAmount(response.marginAmount);
//                     }}
//                     disabled={!supplyPrice}
//                   />
//                   <Input
//                     infoText={`The fixed amount added to your supply price to calculate the retail price.
//   Formula: Retail Price = Supply Price + Margin Amount
// Examples:• Supply: 100, Amount: 50 → Retail: 150 (Margin: 50%)`}
//                     tooltipPosition="top"
//                     tooltipWidth={"400px"}
//                     starttext={currencySymbol}
//                     label="Margin Amount"
//                     placeholder=""
//                     type="number"
//                     value={marginAmount}
//                     onChange={(e) => {
//                       setMarginAmount(e.target.value);
//                       let response = calculateMargin(e.target.value, supplyPrice, "amount");
//                       setRetailPrice(response.retailPrice);
//                       // setMrp(response.mrp);
//                       setMarginPercentage(response.marginPercentage);
//                     }}
//                     disabled={!supplyPrice}
//                   />
//                   <Input
//                     infoText={`The lowest price at which you are willing to sell the product.
// (You should not sell below this to avoid losses)`}
//                     tooltipPosition="top"
//                     tooltipWidth={"300px"}
//                     starttext={currencySymbol}
//                     label="MSP (Minimum Selling Price)"
//                     placeholder=""
//                     type="number"
//                     value={msp}
//                     onChange={(e) => setMsp(e.target.value)}
//                   />
//                   <Input
//                     isMandatory={true}
//                     infoText={`The price you normally sell the product to customers (before any discount).
// (Your shop’s selling price)`}
//                     tooltipPosition="top"
//                     tooltipWidth={"300px"}
//                     starttext={currencySymbol}
//                     label="Retail Price"
//                     placeholder=""
//                     type="number"
//                     value={retailPrice}

//                     onChange={(e) => {
//                       setRetailPrice(e.target.value);
//                       let response = calculateMargin(e.target.value, supplyPrice, "retailPrice");
//                       setMarginAmount(response.marginAmount);

//                       if (e.target.value && discountPercentage) {
//                         const newAmount = calculateDiscountAmount(discountPercentage, e.target.value);
//                         setDiscountAmount(newAmount);
//                       }
//                       else {
//                         setDiscountAmount("");
//                       }

//                       // setMrp(response.mrp);
//                       setMarginPercentage(response.marginPercentage);
//                       if (e.target.value !== "") {
//                         setRetailPriceError("");
//                       }
//                     }
//                     }
//                     errorMessage={retailPriceError}
//                   />
//                   <Input
//                     infoText={`The percentage of discount you want to give to the customer.
// (Example: 10% off on the product)`}
//                     tooltipPosition="left"
//                     tooltipWidth={"400px"}
//                     label="Discount %"
//                     placeholder=""
//                     type="number"
//                     value={discountPercentage}
//                     onChange={(e) => {
//                       const newPercentage = e.target.value;
//                       setDiscountPercentage(newPercentage);
//                       if (retailPrice) {
//                         const newAmount = calculateDiscountAmount(newPercentage, retailPrice);
//                         setDiscountAmount(newAmount);
//                       }
//                     }}
//                   />
//                   <Input
//                     infoText={`The actual money value of the discount in rupees.
// (Example: ₹100 off on a ₹1000 item)`}
//                     tooltipPosition="top"
//                     tooltipWidth={"300px"}
//                     label="Discount Amount"
//                     placeholder=""
//                     starttext={currencySymbol}
//                     type="number"
//                     value={discountAmount}
//                     onChange={(e) => {
//                       const newAmount = e.target.value;
//                       setDiscountAmount(newAmount);
//                       if (retailPrice) {
//                         const newPercentage = calculateDiscountPercentage(newAmount, retailPrice);
//                         setDiscountPercentage(newPercentage);
//                       }
//                     }}
//                   />
//                   <Input
//                     isMandatory={false}
//                     infoText={`The highest price printed on the product by the manufacturer.
// (You cannot sell above this price)`}
//                     tooltipPosition="left"
//                     tooltipWidth={"100px"}
//                     label="MRP (Maximum Retail Price)"
//                     placeholder=""
//                     type="number"
//                     starttext={currencySymbol}
//                     value={mrp}
//                     onChange={(e) => {
//                       setMrp(e.target.value)
//                       if (e.target.value) {
//                         setMrpError("");
//                       }
//                     }
//                     }
//                     errorMessage={mrpError}
//                   />


//                 </div>
//               }
//               {(!soldAtSpecificStoresOnly && productTypeID == 4) &&
//                 <div className="grid lg:grid-cols-5 sm:grid-cols-2 gap-3">


//                   <Input
//                     infoText={`The lowest price at which you are willing to sell the product.
// (You should not sell below this to avoid losses)`}
//                     tooltipPosition="top"
//                     tooltipWidth={"300px"}
//                     starttext={currencySymbol}
//                     label="MSP (Minimum Selling Price)"
//                     placeholder=""
//                     type="number"
//                     value={msp}
//                     onChange={(e) => setMsp(e.target.value)}
//                   />
//                   <Input
//                     isMandatory={true}
//                     infoText={`The price you normally sell the product to customers (before any discount).
// (Your shop’s selling price)`}
//                     tooltipPosition="top"
//                     tooltipWidth={"300px"}
//                     starttext={currencySymbol}
//                     label="Retail Price"
//                     placeholder=""
//                     type="number"
//                     value={retailPrice}
//                     onChange={(e) => {
//                       setRetailPrice(e.target.value);
//                       if (e.target.value !== "") {
//                         setRetailPriceError("");
//                       }
//                     }
//                     }
//                     errorMessage={retailPriceError}
//                   />

//                   <CustomSwitch
//                     formlabel="Wallet recharge amount same as retail price"
//                     checked={walletTopUpSameAsRetailPrice}
//                     onChange={(checked) => {
//                       setWalletTopUpSameAsRetailPrice(checked);

//                     }}
//                   />
//                   {!walletTopUpSameAsRetailPrice && <Input
//                     label="Wallet Recharge Amount"
//                     placeholder=""
//                     type="number"
//                     value={walletTopUpAmount}
//                     onChange={(e) => {
//                       setWalletTopUpAmount(e.target.value)
//                       setWalletTopUpError("");

//                     }
//                     }
//                     errorMessage={walletTopUpError}
//                   />}
//                   {!walletTopUpSameAsRetailPrice && <CustomSwitch
//                     formlabel="Allow user to specify recharge amount at time of billing"
//                     checked={editWalletTopUpAmount}
//                     onChange={(checked) => {
//                       setEditWalletTopUpAmount(checked);

//                     }}
//                   />}

//                 </div>
//               }
//               {(soldAtSpecificStoresOnly || someStoresHaveDifferentPricing) &&
//                 <div>
//                   <div className="mx-auto">
//                     <table className="w-full rounded-md">
//                       <thead className="bg-[#f9f9fb] h-[50px] border-y-[1px] border-[#ddd] text-gray-500">
//                         <tr>
//                           <th className="p-2 text-left">Store</th>
//                           {productTypeID !== 4 && <th className="p-2 text-left">Supply Price</th>}
//                           {productTypeID !== 4 && <th className="p-2 text-left">Margin %</th>}
//                           {productTypeID !== 4 && <th className="p-2 text-left">Margin Amount</th>}
//                           {productTypeID !== 4 && <th className="p-2 text-left">MSP</th>}
//                           <th className="p-2 text-left">Retail Price</th>
//                           {productTypeID !== 4 && <th className="p-2 text-left">Disc %</th>}
//                           {productTypeID !== 4 && <th className="p-2 text-left">Disc Amt</th>}
//                           {productTypeID === 4 && <th className="p-2 text-left">Wallet recharge amount same as retail price</th>}
//                           {productTypeID === 4 && <th className="p-2 text-left">Wallet Recharge Amount</th>}
//                           {productTypeID === 4 && <th className="p-2 text-left">Allow user to specify recharge amount at time of billing</th>}
//                           {productTypeID !== 4 && <th className="p-2 text-left">MRP</th>}
//                           <th className="p-2 text-left"></th>
//                         </tr>
//                       </thead>
//                       <tbody>
//                         {storeSpecificPricesRows.map((row, index) => (
//                           <tr key={index} className='h-[50px] hover:bg-gray-100 border-t border-[#ddd]'>
//                             <td className="p-2">
//                               {index === 0 ? (
//                                 <Select
//                                   fetchAllObject={true}
//                                   placeholder="Select Store"
//                                   options={storeOptions.filter(
//                                     option => !storeSpecificPricesRows.some(
//                                       (row, idx) => idx !== 0 && row.StoreID === option.value
//                                     )
//                                   )}
//                                   value={row.StoreID}
//                                   onChange={(e) => {
//                                     handleStoreRowChange(index, 'storeSelection', e);
//                                     setStoreError("");
//                                   }}
//                                   errorMessage={storeError}
//                                 />
//                               ) : (
//                                 <div>
//                                   <label>{row.Store}</label>
//                                 </div>
//                               )}
//                             </td>


//                             {productTypeID !== 4 && (
//                               <td className="p-2">
//                                 <Input
//                                   placeholder="Enter Supply Price"
//                                   type="number"
//                                   starttext={currencySymbol}
//                                   value={row.SupplyPrice}
//                                   onChange={(e) => handleStoreRowChange(index, 'SupplyPrice', e.target.value)}
//                                 />
//                               </td>
//                             )}


//                             {productTypeID !== 4 && (
//                               <td className="p-2">
//                                 <Input
//                                   placeholder=""
//                                   type="number"
//                                   value={row.MarginPercentage}
//                                   onChange={(e) => {
//                                     handleStoreRowChange(index, 'MarginPercentage', e.target.value)
//                                     let response = calculateMargin(e.target.value, row.SupplyPrice, "percentage");
//                                     console.log("response", response);
//                                     handleStoreRowChange(index, 'RetailPrice', response.retailPrice)
//                                     handleStoreRowChange(index, 'MarginAmount', response.marginAmount)
//                                   }}
//                                 />
//                               </td>
//                             )}
//                             {productTypeID !== 4 && (
//                               <td className="p-2">
//                                 <Input
//                                   placeholder=""
//                                   type="number"
//                                   value={row.MarginAmount}
//                                   onChange={(e) => {
//                                     handleStoreRowChange(index, 'MarginAmount', e.target.value)
//                                     let response = calculateMargin(e.target.value, row.SupplyPrice, "amount");
//                                     console.log("response", response);
//                                     handleStoreRowChange(index, 'RetailPrice', response.retailPrice)
//                                     handleStoreRowChange(index, 'MarginPercentage', response.marginPercentage)
//                                   }}
//                                 />
//                               </td>
//                             )}
//                             {productTypeID !== 4 && (
//                               <td className="p-2">
//                                 <Input
//                                   placeholder="Enter MSP"
//                                   type="number"
//                                   starttext={currencySymbol}
//                                   value={row.MSP}
//                                   onChange={(e) => handleStoreRowChange(index, 'MSP', e.target.value)}
//                                 />
//                               </td>
//                             )}

//                             <td className="p-2">
//                               <Input
//                                 placeholder="Enter Retail Price"
//                                 type="number"
//                                 starttext={currencySymbol}
//                                 value={row.RetailPrice}

//                                 onChange={(e) => {
//                                   handleStoreRowChange(index, 'RetailPrice', e.target.value);
//                                   let response = calculateMargin(e.target.value, row.SupplyPrice, "retailPrice");
//                                   handleStoreRowChange(index, 'MarginAmount', response.marginAmount);
//                                   handleStoreRowChange(index, 'MarginPercentage', response.marginPercentage);
//                                   setRetailPriceErrorUnderSpecificStore("");
//                                 }}
//                                 errorMessage={index === 0 ? retailPriceErrorUnderSpecificStore : ""}
//                               />
//                             </td>

//                             {productTypeID !== 4 && (
//                               <td className="p-2">
//                                 <Input
//                                   placeholder="Enter Disc %"
//                                   type="number"
//                                   value={row.DiscountPercentage}
//                                   onChange={(e) => handleStoreRowChange(index, 'DiscountPercentage', e.target.value)}
//                                 />
//                               </td>
//                             )}

//                             {productTypeID !== 4 && (
//                               <td className="p-2">
//                                 <Input
//                                   placeholder="Enter Disc Amt"
//                                   type="number"
//                                   starttext={currencySymbol}
//                                   value={row.DiscountAmount}
//                                   onChange={(e) => handleStoreRowChange(index, 'DiscountAmount', e.target.value)}
//                                 />
//                               </td>
//                             )}

//                             {productTypeID === 4 && (
//                               <td className="p-2">
//                                 <CustomSwitch
//                                   checked={row.WalletTopUpSameAsRetailPrice}
//                                   onChange={(checked) => {
//                                     handleStoreRowChange(index, 'WalletTopUpSameAsRetailPrice', checked)
//                                   }}
//                                 />
//                               </td>
//                             )}

//                             {productTypeID === 4 && (row.WalletTopUpSameAsRetailPrice ? (
//                               <td className="p-2">
//                                 <Input
//                                   type="number"
//                                   starttext={currencySymbol}
//                                   value={row.WalletTopUpAmount}
//                                   onChange={(e) => handleStoreRowChange(index, 'WalletTopUpAmount', e.target.value)}
//                                 />
//                               </td>
//                             ) : <td className="p-2"></td>)}

//                             {productTypeID === 4 && (row.WalletTopUpSameAsRetailPrice ? (
//                               <td className="p-2">
//                                 <CustomSwitch
//                                   checked={row.EditWalletTopUpAmount}
//                                   onChange={(checked) => {
//                                     handleStoreRowChange(index, 'EditWalletTopUpAmount', checked)
//                                   }}
//                                 />
//                               </td>
//                             ) : <td className="p-2"></td>)}

//                             {productTypeID !== 4 && (
//                               <td className="p-2">
//                                 <Input
//                                   placeholder="Enter MRP"
//                                   type="number"
//                                   starttext={currencySymbol}
//                                   value={row.MRP}
//                                   onChange={(e) => {
//                                     handleStoreRowChange(index, 'MRP', e.target.value);
//                                   }}
//                                 />
//                               </td>
//                             )}

//                             <td className="p-2">
//                               {index === 0 ? (
//                                 <Button
//                                   type="primary"
//                                   px='px-4'
//                                   onClick={addStoreSpecificPriceRow}
//                                   disabled={!storeSpecificPricesRows[0].StoreID}
//                                 >
//                                   <span className="w-5"><Icon type="add" /></span> Add
//                                 </Button>
//                               ) : (
//                                 <div className="p-2">
//                                   <Button
//                                     type="secondary"
//                                     px='px-4'
//                                     onClick={() => removeStoreSpecificPriceRow(index)}
//                                   >
//                                     <span className="w-5"><Icon type="remove" /></span> Remove
//                                   </Button>
//                                 </div>
//                               )}
//                             </td>
//                           </tr>
//                         ))}
//                       </tbody>
//                     </table>
//                   </div>
//                 </div>
//               }
//               <div className="grid lg:grid-cols-6 sm:grid-cols-2 gap-3">
//                 <CustomSwitch
//                   infoText={"Enable taxes if the product is taxable.This means you should turn on the tax option whenever the product attracts GST/VAT or any applicable tax.Example:If you are selling a mobile phone, taxes apply → ✅ Enable Taxes.If you are giving a free carry bag, no tax applies → ❌ Do not enable Taxes."}
//                   tooltipWidth={"500px"}
//                   tooltipPosition="right"
//                   formlabel="Charge taxes on this product"
//                   checked={chargeTaxesonthisProduct}
//                   onChange={(checked) => setChargeTaxesonthisProduct(checked)}
//                 />
//                 {chargeTaxesonthisProduct && (
//                   <>

//                     <CustomSwitch
//                       infoText={"If enabled, tax will be calculated on the *Retail Price (the price you sell to customers)* instead of the supply price. Example:  Retail Price: ₹100  Tax: 18%  Bill shows ₹100 + 18% = ₹118."}
//                       tooltipWidth={"500px"}
//                       formlabel="Tax based on retail price"
//                       checked={taxBaseOnRetailPrice}
//                       onChange={(checked) => setTaxBaseOnRetailPrice(checked)}
//                     />
//                     <CustomSwitch
//                       infoText={"Use this if your selling price already includes tax. Example: MRP on packet: ₹118 (which already has 18% GST included).POS will automatically split it as ₹100 (price) + ₹18 (tax). Customer still sees ₹118 only."}
//                       tooltipWidth={"500px"}
//                       formlabel="Tax inclusive (Sales)"
//                       checked={taxInclusiveSales}
//                       onChange={(checked) => setTaxInclusiveSales(checked)}
//                     />
//                     <CustomSwitch
//                       infoText={"Use this when the price from your supplier already includes tax.Example: You buy an item at ₹118 from supplier (inclusive of 18% GST).POS will record it as base price ₹100 + tax ₹18."}
//                       tooltipWidth={"500px"}
//                       formlabel="Tax inclusive (Purchase)"
//                       checked={taxInclusivePurchase}
//                       onChange={(checked) => setTaxInclusivePurchase(checked)}
//                     />
//                   </>
//                 )}
//               </div>

//               <div className="grid lg:grid-cols-4 sm:grid-cols-2 gap-3">

//                 {chargeTaxesonthisProduct && (
//                   <>
//                     <div>
//                       <Input
//                         infoText={"used for Goods.SAC (Service Accounting Code) → used for Services.These are official codes required for GST compliance. Example:HSN for rice: 1006 HSN for cosmetics: 3304 SAC for salon services: 9997"}
//                         tooltipWidth={"500px"}
//                         tooltipPosition="right"
//                         label="HSN (Harmonized System of Nomenclature)" type="text" placeholder="Enter HSN/SAC Code.." value={hsnSacCode} onChange={(e) => { setHsnSacCode(e.target.value) }} errorMessage="" />
//                       <div className="text-sm text-blue-700  hover:text-blue-400 cursor-pointer" onClick={() => window.open("https://services.gst.gov.in/services/searchhsnsac", "_blank")}>HSN Code Finder (Government GST Portal)</div>
//                       <div className="text-sm text-blue-700 hover:text-blue-400 cursor-pointer" onClick={() => window.open("https://cleartax.in/s/gst-hsn-lookup", "_blank")}>ClearTax HSN/SAC Code List</div>
//                     </div>
//                     {!taxBaseOnRetailPrice &&
//                       // <Select
//                       //   fetchAllObject={true}
//                       //   label={"Tax"}
//                       //   placeholder={"select tax"}
//                       //   options={taxOption}
//                       //   value={taxDropDownLabel}
//                       //   onChange={(e) => {

//                       //   }}
//                       // />

//                       <Autocompletesearch
//                         value={taxDropDownLabel}
//                         defaultDataCount={20}
//                         infoText={"Select the tax rate to apply.In India, most common GST rates are: 0%, 5%, 12%, 18%, 28%.If you are outside India, you can create your own tax percentage as per your country’s rules (like VAT, Sales Tax, etc.)."}
//                         tooltipPosition="right"
//                         tooltipWidth={"500px"}
//                         label="Tax"
//                         data={taxOption}
//                         filterKey={["label"]}
//                         onChange={(value) => console.log("type input changed:", value)}
//                         onSelect={(e) => {
//                           setTaxDropDownValue(e.value);
//                           setTaxDropDownLabel(e.label);
//                           setTaxDropDownLabel(e.label);
//                           console.log("taxDropDownValue", e.value);
//                         }}
//                         placeholder="search or select tax"
//                         showsearch={false}
//                         renderSuggestion={(item) => (
//                           <div>
//                             <p className="">{item.label}</p>
//                           </div>
//                         )}
//                       />
//                     }


//                   </>
//                 )}
//               </div>

//               {taxBaseOnRetailPrice &&

//                 <div className="grid gap-4">
//                   {taxOnRetailPriceRows.map((row, index) => (
//                     <div key={index}>
//                       <div className="grid lg:grid-cols-6 sm:grid-cols-1 gap-4">
//                         {/* Dynamic Input for "Price - From" */}
//                         <Input
//                           label="Price - From"
//                           type="text"
//                           placeholder="Enter Price - From"
//                           value={row["FromPrice"]}
//                           onChange={(e) => handleInputChangeTaxOnRetailPrice(index, "FromPrice", e.target.value)}
//                           errorMessage=""
//                         />
//                         {/* Dynamic Input for "Price - To" */}
//                         <Input
//                           label="Price - To"
//                           type="text"
//                           placeholder="Enter Price - To"
//                           value={row["ToPrice"]}
//                           onChange={(e) => handleInputChangeTaxOnRetailPrice(index, "ToPrice", e.target.value)}
//                           errorMessage=""
//                         />
//                         {/* Dynamic Select for Tax */}
//                         {/* <Select
//                           fetchAllObject={true}
//                           label="Tax"
//                           placeholder="select tax"
//                           options={taxOption}
//                           value={row["TaxID"]}
//                           onChange={(e) => { handleInputChangeTaxOnRetailPrice(index, "TaxGroup", e.label), handleInputChangeTaxOnRetailPrice(index, "TaxID", e.value) }}
//                         /> */}
//                         <Autocompletesearch
//                           value={row["TaxGroup"]}
//                           defaultDataCount={20}
//                           label="Tax"
//                           data={taxOption}
//                           filterKey={["label"]}
//                           onChange={(value) => console.log("type input changed:", value)}
//                           onSelect={(e) => {
//                             { handleInputChangeTaxOnRetailPrice(index, "TaxGroup", e.label), handleInputChangeTaxOnRetailPrice(index, "TaxID", e.value) }
//                           }}
//                           placeholder="search or select tax"
//                           showsearch={false}
//                           renderSuggestion={(item) => (
//                             <div>
//                               <p className="">{item.label}</p>
//                             </div>
//                           )}
//                         />
//                         {/* Add/Remove buttons */}
//                         {index === taxOnRetailPriceRows.length - 1 ? (
//                           <div className="mt-6 w-[86px]">
//                             <Button
//                               type="primary"
//                               onClick={addRow}
//                             >
//                               <span className="w-6"><Icon type="add" /></span> Add
//                             </Button>
//                           </div>
//                         ) : (
//                           <div className="mt-6 w-[86px]">
//                             <Button
//                               type="danger"
//                               onClick={() => removeRow(index)}
//                             >
//                               <span className="w-6"><Icon type="remove" /></span> Remove
//                             </Button>
//                           </div>
//                         )}
//                       </div>
//                     </div>
//                   ))}
//                 </div>


//               }




//             </div>
//           </PageSection>



//           {((productTypeID == 1 || productTypeID == 2)) &&
//             <PageSection title="Inventory">
//               <div className="grid gap-6 mt-5">
//                 <div className="grid lg:grid-cols-6 sm:grid-cols-2 gap-3">

//                   <Select
//                     isMandatory={true}
//                     disabled={key || selectedProductID}
//                     fetchAllObject={true}
//                     label={"Type"}
//                     tooltipPosition="right"
//                     tooltipWidth={"500px"}
//                     infoText={renderInfoText(inventoryInfo[inventoryDropDownValue])} // Dynamic tooltip
//                     placeholder={"select type"}
//                     options={[
//                       { value: "FIFO", label: "FIFO" },
//                       { value: "Unique No", label: "Unique No" },
//                       { value: "Variants", label: "Variants" },
//                       { value: "Batch Tracking", label: "Batch Tracking" },

//                     ]}

//                     value={inventoryDropDownValue}
//                     onChange={(e) => {
//                       setInventoryDropDownValue(e.value);  // Set the dropdown value
//                       resetInventoryFields();
//                       console.log("inventory dropdown value", e.value);  // Log the selected value
//                     }}
//                   />
//                   {inventoryDropDownValue == "Unique No" &&
//                     <Input
//                       infoText={"Enter a Unique Label (like IMEI, Serial Number, or your own code). This helps track individual products for warranty, repairs, and stock accuracy."}
//                       tooltipWidth={"500px"}
//                       tooltipPosition="top"
//                       label="Unique Label"
//                       placeholder="Enter unique label"
//                       value={uniqueLabel}
//                       onChange={(e) => {
//                         setUniqueLabel(e.target.value);
//                       }}

//                     />
//                   }
//                 </div>


//                 {inventoryDropDownValue == "Batch Tracking" &&
//                   <div className="grid lg:grid-cols-6 sm:grid-cols-1 gap-4">
//                     <CustomSwitch
//                       infoText={"This is the unique number given by the manufacturer or created by you for a group of items.Example: You receive 100 strips of Paracetamol Tablets under Batch No. B1234.It helps track which batch was sold in case of complaints, returns, or recalls."}
//                       tooltipPosition="right"
//                       tooltipWidth={"500px"}
//                       formlabel="Batch No"
//                       checked={batchTrackingBatchNoRequired}
//                       onChange={(checked) => setBatchTrackingBatchNoRequired(checked)}
//                     />
//                     <CustomSwitch
//                       infoText={"This is the selling price printed on the product pack by the manufacturer.Example: A shampoo bottle with an MRP of ₹199.Adding MRP ensures correct billing as per printed price."}
//                       tooltipPosition="right"
//                       tooltipWidth={"500px"}
//                       formlabel="MRP (Maximum Retail Price)"
//                       checked={batchTrackingMRPRequired}
//                       onChange={(checked) => setBatchTrackingMRPRequired(checked)}
//                     />
//                     <CustomSwitch
//                       formlabel="Manufacturing Date (Mfg Date)"
//                       infoText={"The date when the product was made or packed.Example: A biscuit packet manufactured in June 2023.Useful for stock rotation (sell older stock first – “FIFO” method)."}
//                       tooltipPosition="top"
//                       tooltipWidth={"500px"}
//                       checked={batchTrackingMfgDateRequired}
//                       onChange={(checked) => {
//                         setBatchTrackingMfgDateRequired(checked);
//                         if (checked) {
//                           setBatchTrackingDateFormat("mm/yy");
//                         } else {
//                           setBatchTrackingDateFormat("");
//                         }
//                       }}
//                     />

//                     <CustomSwitch
//                       formlabel="Exp Date"
//                       infoText={"The last date the product can be sold or used safely.Example: A medicine expiring in May 2025.Helps the shopkeeper avoid selling expired products and manage stock clearance on time."}
//                       tooltipPosition="top"
//                       tooltipWidth={"500px"}
//                       checked={batchTrackingExpDateRequired}
//                       onChange={(checked) => {
//                         setBatchTrackingExpDateRequired(checked);
//                         if (checked) {
//                           setBatchTrackingDateFormat("mm/yy");
//                         } else {
//                           setBatchTrackingDateFormat("");
//                         }
//                       }}
//                     />

//                   </div>

//                 }
//                 {(batchTrackingMfgDateRequired || batchTrackingExpDateRequired) &&
//                   <div className="grid lg:grid-cols-6 sm:grid-cols-1 gap-4">
//                     <Select
//                       infoText={
//                         <>
//                           <p>You can choose your preferred date format.This will be used wherever dates are shown, such as Manufacturing Date (MFG Date) or Expiry Date (EXP Date).</p>
//                           <ul>
//                             <li><b>dd</b> → Day (e.g., 01, 15, 28)</li>
//                             <li><b>mm</b> → Month in numbers (e.g., 02 = Feb, 05 = May)</li>
//                             <li><b>mmm</b> → Month in short text (e.g., Jan, Feb, Sep)</li>
//                             <li><b>yy</b> → Year in 2 digits (e.g., 25 = 2025, 26 = 2026)</li>
//                             <li><b>yyyy</b> → Year in 4 digits (e.g., 2025, 2026)</li>
//                           </ul>

//                           <p><b>Examples:</b></p>
//                           <ul>
//                             <li><b>mm/yy</b> → 02/25 (Feb 2025)</li>
//                             <li><b>mmm/yy</b> → Feb/25</li>
//                             <li><b>mmm/yyyy</b> → Feb/2025</li>
//                             <li><b>dd/mm/yy</b> → 15/02/25</li>
//                             <li><b>dd/mmm/yy</b> → 15/Feb/25</li>
//                             <li><b>mm-yy</b> → 02-25</li>
//                             <li><b>mmm-yy</b> → Feb-25</li>
//                             <li><b>mmm-yyyy</b> → Feb-2025</li>
//                             <li><b>dd-mm-yy</b> → 15-02-25</li>
//                             <li><b>dd-mmm-yyyy</b> → 15-Feb-2025</li>
//                           </ul>
//                         </>
//                       }

//                       tooltipPosition="right"
//                       tooltipWidth={"500px"}
//                       fetchAllObject={true}
//                       label={"Date Format"}
//                       placeholder=""
//                       options={[
//                         { value: "mm/yy", label: "mm/yy" },
//                         { value: "mmm/yy", label: "mmm/yy" },
//                         { value: "mmm/yyyy", label: "mmm/yyyy" },
//                         { value: "dd/mm/yy", label: "dd/mm/yy" },
//                         { value: "dd/mmm/yy", label: "dd/mmm/yy" },
//                         { value: "mm-yy", label: "mm-yy" },
//                         { value: "mmm-yy", label: "mmm-yy" },
//                         { value: "mmm-yyyy", label: "mmm-yyyy" },
//                         { value: "dd-mm-yy", label: "dd-mm-yy" },
//                         { value: "dd-mmm-yyyy", label: "dd-mmm-yyyy" }
//                       ]}
//                       value={batchTrackingDateFormat}
//                       onChange={(e) => {
//                         setBatchTrackingDateFormat(e.value);  // Set the dropdown value
//                       }}

//                     />
//                   </div>}



//                 {inventoryDropDownValue == "Variants" &&
//                   <div className="grid gap-3 ">
//                     {(!selectedProductID && !key) && <div className="grid lg:grid-cols-2 sm:grid-cols-1 space-x-6">
//                       <div className="flex items-center space-x-4 grid lg:grid-cols-2 sm:grid-cols-1">
//                         <div>
//                           <Input
//                             label="Define Attribute"
//                             placeholder="Enter Attribute"
//                             type="text"
//                             value={defineAttribute}
//                             onChange={(e) => {
//                               setDefineAttribute(e.target.value);
//                               if (e.target.value.trim() !== "") {
//                                 setDefineAttributeError("");
//                               }
//                             }}
//                             errorMessage={defineAttributeError}
//                             infoText={"choose up to three variable attributes for this product to create and manage SKUs and thier inventory levels"}
//                             tooltipPosition="right"
//                             tooltipWidth={"700px"}
//                           />
//                         </div>
//                         <div className="mt-auto">
//                           <Button type="primary" iconType={"add"} onClick={handleAddAttributeBtnClick} >
//                             Add Attribute
//                           </Button>
//                         </div>
//                       </div>
//                     </div>}
//                     {(addAttributeRow.length > 0) &&
//                       <div>
//                         <div className="mx-auto">
//                           <table className=" table-auto w-full rounded-md" >
//                             <thead className="bg-[#f9f9fb] h-[50px] border-y-[1px] border-[#ddd] text-gray-500 ">
//                               <tr>
//                                 <th className="p-2 text-left">Attribute</th>
//                                 <th className="p-2 text-left">Values</th>
//                                 <th className="p-2 text-left">Actions</th>
//                               </tr>
//                             </thead>
//                             <tbody>
//                               {addAttributeRow.map((row, index) => (
//                                 <tr key={index} className="h-[50px] hover:bg-gray-100 border-t border-[#ddd]">
//                                   <td className="p-2 w-[100px]">
//                                     <label className="mb-1  text-[#000000]">{row.attribute}</label>
//                                   </td>
//                                   <td className="p-2 w-60">
//                                     <div>
//                                       <MultiAutocomplete
//                                         hideRemoveIcon={(key || selectedProductID) ? true : false}
//                                         label="	Values"
//                                         placeholder="Add values"
//                                         value={row.values}
//                                         onChange={(event, newValue, action) => handleAutocompleteChange(event, newValue, action, index)}
//                                       />
//                                     </div>
//                                   </td>
//                                   <td className="p-2 w-20">
//                                     {(!key && !selectedProductID) && <div className="flex items-center  w-full">
//                                       <span className="w-[100px]">
//                                         <Button type="secondary" px="px-2" onClick={() => handleRemoveAttributeRow(index)}>
//                                           <span className="w-6"><Icon type="remove" /></span> Remove
//                                         </Button>
//                                       </span>
//                                     </div>}
//                                   </td>


//                                 </tr>
//                               ))}
//                             </tbody>
//                           </table>
//                         </div>
//                       </div>}
//                     {addAttributeRow.length > 0 &&

//                       <div>
//                         <CustomSwitch
//                           formlabel="Automatically Generate SKU"
//                           checked={autoGenerateSKU}
//                           onChange={(checked) => setAutoGenerateSKU(checked)}
//                           disabled={key || selectedProductID}
//                         />
//                         <div className="mx-auto">
//                           <table className=" table-auto w-full rounded-md" >
//                             <thead className="bg-[#f9f9fb] h-[50px] border-y-[1px] border-[#ddd] text-gray-500 ">
//                               <tr>
//                                 <th className="p-2 text-left">Variant Name</th>
//                                 <th className="p-2 text-left">SKU</th>
//                                 <th className="p-2 text-left">Supply Price</th>
//                                 <th className="p-2 text-left">Margin %</th>
//                                 <th className="p-2 text-left">Margin Amount</th>
//                                 <th className="p-2 text-left">MSP</th>
//                                 <th className="p-2 text-left">Retail Price</th>
//                                 <th className="p-2 text-left">Discount Amount</th>
//                                 <th className="p-2 text-left">Discount %</th>
//                                 <th className="p-2 text-left">MRP</th>

//                                 <th className="p-2 text-left">Action</th>
//                               </tr>
//                             </thead>
//                             <tbody>

//                               {addVariantRow.filter(row => row.isDeleted == false).map((row, index) => (
//                                 <tr key={index} className="h-[50px] hover:bg-gray-100 border-t border-[#ddd]">
//                                   <td className="p-2 ">
//                                     <label className="mb-1  text-[#000000]">{row.attribute}</label>
//                                   </td>
//                                   <td className="p-2">
//                                     <div>
//                                       {((key || selectedProductID) && row.productID) ? (
//                                         <>
//                                           <div>{row.sku}</div>
//                                           <div>Product id: {row.productID}</div>
//                                           {row.skuError !== "" && <div className="text-red-600 text-sm mt-1">
//                                             {row.skuError}
//                                           </div>}
//                                         </>
//                                       ) : autoGenerateSKU ? (
//                                         null
//                                       ) : (
//                                         <Input
//                                           placeholder=""
//                                           type="text"
//                                           value={row.sku}
//                                           onChange={(e) => handleSkuChange(e, index)}
//                                           errorMessage={row.skuError}
//                                         />
//                                       )}
//                                     </div>
//                                   </td>
//                                   {/* Render inputs dynamically for each field */}
//                                   {['supplyPrice', 'marginPercentage', 'marginAmount', 'msp', 'retailPrice', 'discountAmount', 'discountPercentage', 'mrp'].map((field, idx) => (
//                                     <td key={idx} className="p-2 ">
//                                       <div>
//                                         <Input
//                                           placeholder=""
//                                           type="number"
//                                           value={row[field]}
//                                           onChange={(e) => handleVariantInputChange(e, field, index)}
//                                         />
//                                       </div>
//                                     </td>
//                                   ))}

//                                   {/* Remove button */}
//                                   <td className="p-2">
//                                     <div className="flex items-center justify-center w-full">
//                                       <Button type="secondary" px="px-2" onClick={() => handleRemoveVariantRow(index)}>
//                                         <span className="w-6"><Icon type="remove" /></span> Remove
//                                       </Button>
//                                     </div>
//                                   </td>
//                                 </tr>
//                               ))}
//                             </tbody>
//                           </table>
//                         </div>
//                       </div>
//                     }



//                   </div>
//                 }
//                 {/* {inventoryDropDownValue &&
//                   <div className="grid lg:grid-cols-2 sm:grid-cols-2 gap-3">
//                     <div>
//                       <div className="mx-auto">
//                         <table className="w-full rounded-md">
//                           <thead className="bg-[#f9f9fb] h-[50px] border-y-[1px] border-[#ddd] text-gray-500">
//                             <tr>
//                               <th className="p-2 text-left">Store</th>
//                               <th className="p-2 text-left">Min Qty</th>
//                               <th className="p-2 text-left">Max Qty</th>
//                               <th className="p-2 text-left">Reorder Qty</th>
//                               {(((!key || !selectedProductID) && inventoryDropDownValue == "FIFO") && !isPincode) &&

//                                 <th className="p-2 text-left">InStock Qty</th>
//                               }
//                               {isPincode && (
//                                 <>
//                                   <th className="p-2 text-left">Average Daily Sales</th>
//                                   <th className="p-2 text-left">MOQ</th>
//                                 </>
//                               )}
//                             </tr>
//                           </thead>
//                           <tbody>
//                             {storeQtys.map((row, index) => (
//                               <tr key={index} className="hover:bg-gray-100 border-t border-[#ddd]">
//                                 <td className="p-2 py-4">
//                                   <label>{row.StoreName}</label>
//                                 </td>
//                                 <td className="p-2 py-4">
//                                   <Input
//                                     type="number"
//                                     value={row.MinQty}
//                                     onChange={(e) => handleQtyChange(index, "MinQty", e.target.value)}
//                                   />
//                                 </td>
//                                 <td className="p-2 py-4">
//                                   <Input
//                                     type="number"
//                                     value={row.MaxQty}
//                                     onChange={(e) => handleQtyChange(index, "MaxQty", e.target.value)}
//                                   />
//                                 </td>
//                                 <td className="p-2 py-4">
//                                   <Input
//                                     type="number"
//                                     value={row.ReorderQty}
//                                     onChange={(e) => handleQtyChange(index, "ReorderQty", e.target.value)}
//                                   />
//                                 </td>
//                                 {(((!key || !selectedProductID) && inventoryDropDownValue == "FIFO") && !isPincode) && <td>
//                                   <Input
//                                     type="number"
//                                     value={row.InStockQty}
//                                     onChange={(e) => handleQtyChange(index, "InStockQty", e.target.value)}
//                                   />
//                                 </td>}
//                                 {isPincode && (
//                                   <>
//                                     <td className="p-2 py-4">
//                                       <Input
//                                         type="number"
//                                         value={row.AverageDailySales}
//                                         onChange={(e) =>
//                                           handleQtyChange(index, "AverageDailySales", e.target.value)
//                                         }
//                                       />
//                                     </td>
//                                     <td className="p-2 py-4">
//                                       <Input
//                                         type="number"
//                                         value={row.MOQ}
//                                         onChange={(e) =>
//                                           handleQtyChange(index, "MOQ", e.target.value)
//                                         }
//                                       />
//                                     </td>
//                                   </>
//                                 )}
//                               </tr>
//                             ))}
//                           </tbody>
//                         </table>

//                       </div>
//                     </div>
//                   </div>} */}


//               </div>
//             </PageSection>}


//           {(productTypeID === 1 || productTypeID === 2) &&
//             <PageSection title="Unit Of Measurement" showInfoIcon={true} performParentOnclick={() => { setShowInfoModal(true), setInfoType("ProductUOM") }}>
//               <div>
//                 <div className="grid gap-6 mt-5">
//                   {/* Primary UOM Select */}
//                   <div className="grid lg:grid-cols-6 sm:grid-cols-2 gap-3">




//                     <Autocompletesearch
//                       disabled={((key || selectedProductID) && (primaryUomValue && primaryUomLabel))}
//                       value={primaryUomLabel}
//                       label={"Primary UOM"}
//                       data={uomOptionData} // Pass the category options
//                       filterKey={["label"]} // Filter by Name and SKU
//                       defaultDataCount={50}
//                       onChange={(value) => {
//                         setPrimaryUomLabel("");;
//                         setPrimaryUomValue("");
//                       }}
//                       onSelect={(item) => {

//                         setPrimaryUomLabel(item.label);
//                         setPrimaryUomValue(item.value);
//                         console.log("Primary uom input changed:", item.value);
//                       }}
//                       placeholder="Select or search  Primary UOM"
//                       showsearch={false}

//                       renderSuggestion={(item, index) => (
//                         <div>
//                           <p className="">{item.label}</p>

//                         </div>
//                       )}
//                       errormessage={primaryUomError}
//                     />
//                   </div>

//                   {/* Secondary UOM Table */}
//                   {(primaryUomLabel && primaryUomValue) &&
//                     <>
//                       <div className="grid lg:grid-cols-2 sm:grid-cols-2 gap-3">
//                         <div>
//                           <div className="mx-auto">
//                             <table
//                               className=" w-full rounded-md"
//                             >
//                               <thead className="bg-[#f9f9fb] h-[50px] border-y-[1px] border-[#ddd] text-gray-500">
//                                 <tr>
//                                   <th className="p-2 text-left">Secondary UOM</th>
//                                   <th className="p-2 text-left">Conversion</th>
//                                   <th className="p-2 text-left"></th>
//                                 </tr>
//                               </thead>
//                               <tbody>
//                                 {uomTableRows.map((row, index) => (
//                                   <tr key={index} className=" hover:bg-gray-100 border-t border-[#ddd] ">
//                                     {/* Secondary UOM Column */}
//                                     <td className="p-2 py-4">
//                                       {index === 0 ? (
//                                         <div>


//                                           <Autocompletesearch
//                                             value={row.secondaryUOM}
//                                             data={uomOptionData} // Pass the category options
//                                             filterKey={["label"]} // Filter by Name and SKU
//                                             defaultDataCount={50}
//                                             onChange={(value) => {
//                                               if (value !== "") {
//                                                 setSecondaryUomSelectError("");
//                                               }

//                                             }}
//                                             onSelect={(item) => {

//                                               handleSecondaryUOMChange(index, item);

//                                               console.log("secondary uom input changed:", item);
//                                             }}
//                                             placeholder="Select or search  Secondary UOM"
//                                             showsearch={false}

//                                             renderSuggestion={(item, index) => (
//                                               <div>
//                                                 <p className="">{item.label}</p>

//                                               </div>
//                                             )}
//                                             errormessage={secondaryUomSelectError}
//                                           />
//                                         </div>
//                                       ) : (
//                                         <div>
//                                           <label>1 {row.secondaryUOM} =</label>
//                                         </div>
//                                       )}
//                                     </td>

//                                     {/* Conversion Column */}
//                                     <td className="p-2 py-4">
//                                       <Input
//                                         placeholder="Enter Conversion"
//                                         type="text"
//                                         value={row.conversion}
//                                         onChange={(e) => {
//                                           handleConversionChange(index, e);
//                                           setConversionErrorMessage(""); // Clear error on change
//                                         }}
//                                         errorMessage={index === 0 ? conversionErrorMessage : ""}
//                                       />
//                                       {index !== 0 && row.conversion && (
//                                         <div className=" text-gray-500 mt-1">{primaryUomLabel}</div>
//                                       )}
//                                     </td>

//                                     {/* Remove Button Column */}
//                                     <td className="p-2 py-4">
//                                       {index === 0 ? (
//                                         <div className="w-30 ">
//                                           <Button type="primary" onClick={handleAddUomRow}>
//                                             <span className="w-5">
//                                               <Icon type="add" />
//                                             </span>{" "}
//                                             Add
//                                           </Button>
//                                         </div>
//                                       ) : (
//                                         <div className="w-30 ">
//                                           <Button type="secondary" onClick={() => handleRemoveUomRow(index)}>
//                                             <span className="w-5">
//                                               <Icon type="remove" />
//                                             </span>{" "}
//                                             Remove
//                                           </Button>
//                                         </div>
//                                       )}
//                                     </td>
//                                   </tr>
//                                 ))}
//                               </tbody>
//                             </table>
//                           </div>
//                         </div>
//                       </div>

//                       {/* Default Sales and Purchase UOM */}
//                       <div className="grid lg:grid-cols-5 sm:grid-cols-2 gap-3">


//                         <Autocompletesearch
//                           label={"Default sales UOM"}
//                           value={defaultSalesUOMLabel}
//                           data={defaultUomOptions}
//                           filterKey={["label"]} // Filter by Name and SKU
//                           defaultDataCount={50}
//                           onChange={(value) => {

//                           }}
//                           onSelect={(item) => {
//                             setDefaultSalesUOMLabel(item.label);
//                             setDefaultSalesUOMValue(item.value);
//                             console.log("Default sales UOM", item);
//                           }}
//                           placeholder="select or search Default sales UOM"
//                           showsearch={false}

//                           renderSuggestion={(item, index) => (
//                             <div>
//                               <p className="">{item.label}</p>

//                             </div>
//                           )}
//                         />

//                         <Autocompletesearch
//                           label={"Default purchase UOM"}
//                           value={defaultPurchaseUOMLabel}
//                           data={defaultUomOptions}
//                           filterKey={["label"]} // Filter by Name and SKU
//                           defaultDataCount={50}
//                           onChange={(value) => {

//                           }}
//                           onSelect={(item) => {
//                             setDefaultPurchaseUOMLabel(item.label);
//                             setDefaultPurchaseUOMValue(item.value);
//                             console.log("Default perchase UOM", item);
//                           }}
//                           placeholder="select or search Default purchase UOM"
//                           showsearch={false}

//                           renderSuggestion={(item, index) => (
//                             <div>
//                               <p className="">{item.label}</p>

//                             </div>
//                           )}
//                         />
//                       </div>
//                     </>}
//                 </div>
//               </div>
//             </PageSection>}

//           {(productTypeID === 5) &&
//             <PageSection title="Packages">

//               <div className="grid gap-6 mt-5">
//                 <div className="grid lg:grid-cols-6 sm:grid-cols-2 gap-3">
//                   <Input
//                     label="Validity in day(s)"
//                     placeholder=""
//                     type="number"
//                     value={validityInDays}
//                     onChange={(e) => {
//                       setValidityInDays(e.target.value);
//                       setValidityInDaysError("");

//                     }}
//                     errorMessage={validityInDaysError}

//                   />
//                 </div>
//                 <div className="grid lg:grid-cols-2 sm:grid-cols-2 gap-3">
//                   <div>
//                     <div className="mx-auto">
//                       <table
//                         className=" w-full rounded-md"
//                       >
//                         <thead className="bg-[#f9f9fb] h-[50px] border-y-[1px] border-[#ddd] text-gray-500">
//                           <tr>
//                             <th className="p-2 text-left">Services</th>
//                             <th className="p-2 text-left">Retail Price</th>
//                             <th className="p-2 text-left"></th>
//                           </tr>
//                           <tr>
//                             <td className="p-2 text-left">   <Autocompletesearch

//                               value={selectedService?.Name}
//                               data={services} // Pass the category options
//                               filterKey={["Name"]} // Filter by Name and SKU
//                               defaultDataCount={50}
//                               onChange={(value) => {
//                                 setSelectedService({});
//                                 fetchServices(value);
//                               }}
//                               onSelect={(item) => {
//                                 setSelectedService(item);
//                               }}
//                               placeholder="Select or search services"
//                               renderSuggestion={(item, index) => (
//                                 <div>
//                                   <p className="">{item.Name}</p>

//                                 </div>
//                               )}
//                               errorMessage={packagesServiceError}
//                             /></td>
//                             <td className="p-2 text-left"></td>
//                             <td className="p-2 text-left">  <Button type="primary" iconType={"add"} disabled={!selectedService?.key} onClick={() => {
//                               let packageService = {
//                                 Service: selectedService?.Name,
//                                 ServiceID: selectedService?.key,
//                               };
//                               for (let index = 0; index < services.length; index++) {
//                                 const service = services[index];
//                                 if (service.key === packageService.ServiceID) {
//                                   packageService.RetailPrice = service.RetailPrice;
//                                 }
//                               }
//                               let updatedPackageServices = packageServices;
//                               updatedPackageServices.push(packageService);
//                               setPackageServices(updatedPackageServices);
//                               setSelectedService({});
//                             }}>

//                               Add
//                             </Button></td>
//                           </tr>
//                         </thead>
//                         <tbody>
//                           {packageServices.map((row, index) => (
//                             <tr key={index} className=" hover:bg-gray-100 border-t border-[#ddd] ">
//                               {/* Secondary UOM Column */}
//                               <td className="p-2 py-4">

//                                 <div>
//                                   <label>{row.Service}</label>
//                                 </div>

//                               </td>
//                               <td className="p-2 py-4">

//                                 <div>
//                                   <label>{row.RetailPrice}</label>
//                                 </div>

//                               </td>


//                               {/* Remove Button Column */}
//                               <td className="p-2 py-4">


//                                 <Button
//                                   type="secondary"
//                                   onClick={() => {
//                                     setPackageServices(prevServices => {
//                                       const newServices = [...prevServices];
//                                       newServices.splice(index, 1);
//                                       return newServices;
//                                     });
//                                   }}
//                                   iconType="remove"
//                                 >
//                                   Remove
//                                 </Button>

//                               </td>
//                             </tr>
//                           ))}
//                         </tbody>
//                       </table>
//                     </div>
//                   </div>
//                 </div>

//               </div>

//             </PageSection>}

//           <PageSection title="Additional Settings">
//             <div className="grid gap-6 mt-5">

//               {/* 
//               <div className="grid lg:grid-cols-5 sm:grid-cols-2 gap-3">
//                 <CustomSwitch
//                   formlabel="Favourite"
//                   checked={favourite}
//                   onChange={(checked) => setFavourite(checked)}
//                 />
//                 <CustomSwitch
//                   formlabel="Allow price edit "
//                   checked={allowPriceEdit}
//                   onChange={(checked) => setAllowPriceEdit(checked)}
//                 />
//                 <CustomSwitch
//                   formlabel="Discountable "
//                   checked={discountable}
//                   onChange={(checked) => setDiscountable(checked)}
//                 />
//                 <CustomSwitch
//                   formlabel="Allow tax change "
//                   checked={allowTaxChange}
//                   onChange={(checked) => setAllowTaxCharge(checked)}
//                 />
//                 <CustomSwitch
//                   formlabel="Prompt for qty at the time billing "
//                   checked={PromptforQtyattheTimeBilling}
//                   onChange={(checked) => setPromptforQtyatthetimeBilling(checked)}
//                 />
//               </div>

//               <div className="grid lg:grid-cols-5 sm:grid-cols-2 gap-3">
//                 <Input
//                   label="Sequence"
//                   placeholder=""
//                   type="number"
//                   value={sequenceNo}
//                   onChange={(e) => {
//                     setSequenceNo(e.target.value);

//                   }}

//                 />
//                 <CustomSwitch
//                   formlabel="Repack/Produce"
//                   checked={repackProduce}
//                   onChange={(checked) => setRepackProduce(checked)}
//                 />
//                 <CustomSwitch
//                   formlabel="BOM "
//                   checked={bom}
//                   onChange={(checked) => setBom(checked)}
//                 />
//                 <CustomSwitch
//                   formlabel="Can be used as consumable "
//                   checked={canbeUsedasConsumable}
//                   onChange={(checked) => setCanbeUsedasConsumable(checked)}
//                 />
//                 <CustomSwitch
//                   formlabel="Show as additional charges in bill print  "
//                   checked={showAdditionalChargesonBillPrint}
//                   onChange={(checked) => setShowAdditionalChargesonBillPrint(checked)}
//                 />
//                 {isPincode &&
//                   <>
//                     <Input
//                       label="Packaging Charges "
//                       placeholder=""
//                       type="number"
//                       value={packagingCharges}
//                       onChange={(e) => {
//                         setPackagingCharges(e.target.value);

//                       }}



//                     />
//                     <CustomSwitch
//                       formlabel="Out of Stock"
//                       checked={outOfStock}
//                       onChange={(checked) => setOutOfStock(checked)}
//                     />

//                     <CustomSwitch
//                       formlabel="Associate Membership"
//                       checked={associateMembership}
//                       onChange={(checked) => setAssociateMembership(checked)}
//                     />
//                     {associateMembership &&
//                       <Autocompletesearch
//                         label={"Membership"}
//                         value={membershipID}
//                         data={uomOptionData}
//                         filterKey={["label"]} // Filter by Name and SKU
//                         defaultDataCount={50}
//                         onChange={(value) => {

//                         }}
//                         onSelect={(item) => {
//                           setMembership(item.label);
//                           setMembershipID(item.value);
//                         }}
//                         placeholder="select or search membership"
//                         showsearch={false}

//                         renderSuggestion={(item, index) => (
//                           <div>
//                             <p className="">{item.label}</p>

//                           </div>
//                         )}
//                       />

//                     }
//                   </>
//                 }
//               </div> */}

//               <div>
//                 <div
//                   className=" mb-1 ">
//                   Sales Option
//                 </div>
//                 <div className="grid lg:grid-cols-5 sm:grid-cols-2 gap-3 mt-5">
//                   <CustomSwitch
//                     infoText="Fast moving product or popular products that can be accessed easily during billing under favourites option"
//                     tooltipPosition="right"
//                     tooltipWidth={"500px"}
//                     formlabel="Favourite"
//                     checked={favourite}
//                     onChange={(checked) => setFavourite(checked)}
//                   />
//                   <CustomSwitch
//                     infoText={"User will be able to change retail price / selling price at the time of billing"}
//                     tooltipPosition="right"
//                     tooltipWidth={"500px"}
//                     formlabel="Allow price edit "
//                     checked={allowPriceEdit}
//                     onChange={(checked) => setAllowPriceEdit(checked)}
//                   />
//                   <CustomSwitch
//                     infoText={"Invoice level dicounts, line item level discounts, membership discounts, offer dicounts can be applied on this product at the time of billing.If this opton is not enabled then no discount can be applied on this product."}
//                     tooltipPosition="top"
//                     tooltipWidth={"500px"}
//                     formlabel="Discountable "
//                     checked={discountable}
//                     onChange={(checked) => setDiscountable(checked)}
//                   />
//                   <CustomSwitch
//                     infoText={"Tax can be changed by the user at the time of billing"}
//                     tooltipPosition="top"
//                     tooltipWidth={"350px"}
//                     formlabel="Allow tax change "
//                     checked={allowTaxChange}
//                     onChange={(checked) => setAllowTaxCharge(checked)}
//                   />
//                   <CustomSwitch
//                     infoText={"When this product is selected at the time of billing a poup screen with option to change qty will be displayed"}
//                     tooltipPosition="left"
//                     tooltipWidth={"350px"}
//                     formlabel="Prompt for qty at the time billing "
//                     checked={PromptforQtyattheTimeBilling}
//                     onChange={(checked) => setPromptforQtyatthetimeBilling(checked)}
//                   />
//                   <span className="">
//                     <Input
//                       label="Sequence no"
//                       placeholder=""
//                       type="number"
//                       value={sequenceNo}
//                       onChange={(e) => {
//                         setSequenceNo(e.target.value);

//                       }}

//                     />
//                   </span>
//                   {registration.hasOwnProperty("OMNIEnabled") &&
//                     <span className="">
//                       <Input
//                         label="Packaging Charges "
//                         placeholder=""
//                         type="number"
//                         value={packagingCharges}
//                         onChange={(e) => {
//                           setPackagingCharges(e.target.value);

//                         }}
//                       />
//                     </span>}
//                   <CustomSwitch
//                     infoText={"Enable Show as additional charges if this is a fee like packing, delivery, or service charge, so it shows separately in the bill."}
//                     tooltipPosition="top"
//                     tooltipWidth={"500px"}
//                     formlabel="Show as additional charges in bill print  "
//                     checked={showAdditionalChargesonBillPrint}
//                     onChange={(checked) => setShowAdditionalChargesonBillPrint(checked)}
//                   />
//                   <CustomSwitch
//                     infoText={"Enable Associate Membership if this product is a membership/plan that should be linked to the customer profile"}
//                     tooltipPosition="top"
//                     tooltipWidth={"400px"}
//                     formlabel="Associate Membership"
//                     checked={associateMembership}
//                     onChange={(checked) => setAssociateMembership(checked)}
//                   />
//                   {associateMembership &&
//                     <Autocompletesearch
//                       label={"Membership"}
//                       value={membership}
//                       data={membershipData}
//                       filterKey={["Name"]} // Filter by Name and SKU
//                       defaultDataCount={50}
//                       onChange={(value) => {

//                       }}
//                       onSelect={(item) => {
//                         setMembership(item.Name);
//                         setMembershipID(item.key);
//                       }}
//                       placeholder="select or search membership"
//                       showsearch={false}

//                       renderSuggestion={(item, index) => (
//                         <div>
//                           <p className="">{item.Name}</p>

//                         </div>
//                       )}
//                     />

//                   }
//                 </div>

//               </div>

//               <div>
//                 <div
//                   className="mb-1 ">
//                   Inventory Option
//                 </div>
//                 <div className="grid lg:grid-cols-5 sm:grid-cols-2 gap-3 mt-5">

//                   {(productTypeID == 1 || productTypeID == 2) && <CustomSwitch
//                     infoText={"Please select this option if this product is repacked or prodcued by you.E.g, packing loose sugar into packs of 1kg."}
//                     tooltipPosition="right"
//                     tooltipWidth={"500px"}
//                     formlabel="Repack/Produce"
//                     checked={repackProduce}
//                     onChange={(checked) => setRepackProduce(checked)}
//                   />}
//                   {(productTypeID !== 4 || productTypeID !== 5) && <CustomSwitch
//                     infoText={"Enable bill of materials (BOM) option to specify raw materials required to prepare/service this product. E.g specify ingredients required to prepare pizza or consumables used for facial"}
//                     tooltipPosition="right"
//                     tooltipWidth={"500px"}
//                     formlabel="BOM "
//                     checked={bom}
//                     onChange={(checked) => setBom(checked)}
//                   />}
//                   {bom &&
//                     <CustomSwitch
//                       infoText={"Enable this option if the raw materials used and qty used are know only at the time of billing. E.g color, brand and qty of for hair color tubes may vary from client to client."}
//                       tooltipPosition="top"
//                       tooltipWidth={"500px"}
//                       formlabel="Manually specify product consumption "
//                       checked={bomManual}
//                       onChange={(checked) => setBomManual(checked)}
//                     />}
//                   {productTypeID === 1 && <CustomSwitch
//                     infoText={"Enable this option if this product can be used as raw material/consumable for other product/services."}
//                     tooltipPosition="top"
//                     tooltipWidth={"500px"}
//                     formlabel="Can be used as consumable "
//                     checked={canbeUsedasConsumable}
//                     onChange={(checked) => setCanbeUsedasConsumable(checked)}
//                   />}


//                 </div>

//               </div>

//               {registration.hasOwnProperty("OMNIEnabled") && <div>

//                 <div
//                   className="mb-1 ">
//                   Online Store Option
//                 </div>
//                 <div className="grid lg:grid-cols-5 sm:grid-cols-2 gap-3 mt-5">

//                   {registration.hasOwnProperty("OMNIEnabled") && <CustomSwitch
//                     tooltipWidth={"300px"}
//                     tooltipPosition="right"
//                     formlabel="Show Online"
//                     infoText={"Show this product in your online store"}
//                     checked={OMNIEnabled}
//                     onChange={(checked) => setOMNIEnabled(checked)}
//                   />}
//                   {(registration.hasOwnProperty("OMNIEnabled") && OMNIEnabled) && <CustomSwitch
//                     formlabel="Out Of Stock"
//                     checked={outOfStock}
//                     onChange={(checked) => setOutOfStock(checked)}
//                   />}

//                 </div>
//               </div>}





//             </div>
//           </PageSection>

//           {/* {isPincode &&
//             <PageSection title="Alerts">
//               <div className="grid gap-6 mt-5">


//                 <div className="grid lg:grid-cols-6 sm:grid-cols-2 gap-3">
//                   <CustomSwitch
//                     formlabel="Enable alerts"
//                     checked={enableAlert}
//                     onChange={(checked) => setEnableAlert(checked)}
//                   />
//                   {enableAlert &&
//                     <Input
//                       label="Notify customer after (days)"
//                       placeholder=""
//                       type="number"
//                       value={notifyCustomerDays}
//                       onChange={(e) => {
//                         setNotifyCustomerDays(e.target.value);

//                       }}

//                     />
//                   }


//                 </div>

//               </div>
//             </PageSection>
//           } */}


//           <PageSection title="Additonal Information" showInfoIcon={true} performParentOnclick={() => { setShowInfoModal(true), setInfoType("ProductAdditionalInformation") }}>

//             <div className="grid gap-6 mt-5">


//               <div className="grid lg:grid-cols-6 sm:grid-cols-2 gap-3">
//                 <Input
//                   label={customFieldData.CustomField1Name || "Custom Field 1"}
//                   placeholder=""
//                   value={customFeild1}
//                   onChange={(e) => {
//                     setCustomField1(e.target.value);

//                   }}

//                 />
//                 <Input
//                   label={customFieldData.CustomField2Name || "Custom Field 2"}
//                   placeholder=""
//                   value={customFeild2}
//                   onChange={(e) => {
//                     setCustomField2(e.target.value);

//                   }}

//                 />
//                 <Input
//                   label={customFieldData.CustomField3Name || "Custom Field 3"}
//                   placeholder=""
//                   value={customFeild3}
//                   onChange={(e) => {
//                     setCustomField3(e.target.value);

//                   }}

//                 />
//                 <Input
//                   label={customFieldData.CustomField4Name || "Custom Field 4"}
//                   placeholder=""
//                   value={customFeild4}
//                   onChange={(e) => {
//                     setCustomField4(e.target.value);

//                   }}

//                 />
//                 <Input
//                   label={customFieldData.CustomField5Name || "Custom Field 5"}
//                   placeholder=""
//                   value={customFeild5}
//                   onChange={(e) => {
//                     setCustomField5(e.target.value);

//                   }}

//                 />
//                 <Input
//                   label={customFieldData.CustomField6Name || "Custom Field 6"}
//                   placeholder=""
//                   value={customFeild6}
//                   onChange={(e) => {
//                     setCustomField6(e.target.value);

//                   }}

//                 />


//               </div>








//             </div>
//           </PageSection>

//           {/* Other sections here... */}

//         </div>)}
//       {showConfirmBox && (
//         <ConfirmBox
//           title="Are you sure?"
//           text="This action cannot be undone."
//           onConfirm={handleConfirmDelete} // Pass the delete handler
//           onCancel={handleCancelDelete} // Pass the cancel handler
//         />
//       )}
//       {showInfoModal &&
//         <InfoModal
//           type={infoType}
//           setPopUp={setShowInfoModal}
//           width="w-[50%]"
//         />}
//     </CreatePage>

//   );
// };

// export default Addproduct;


import { FaTimes } from "react-icons/fa";
import React, { act, useState } from "react";
import CreatePage from "../../controls/CreatePage";
import PageSection from "../../controls/PageSection";
import Input from "../../controls/Input";
import ImageUpload from "../../controls/ImageUpload";
import Select from "../../controls/Select";
import CustomSwitch from "../../controls/CustomSwitch";
import { useEffect } from "react";
import { fetchCategory } from "../../../api/CategoryApi";
import { fetchSubCategory, } from "../../../api/subCategoryApi";
import { fetchBrands } from "../../../api/brandApi";
import { checkSkusAlreadyExist, fetchProducts, handleAddProduct, handleAddVariants } from "../../../api/ProductApi";
import { uploadImagesToServer } from "../../../../uploadImageToServer"
import Autocompletesearch from "../../controls/Autocompletesearchbk";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { handleEditProduct, fetchSingleProductApi } from "../../../api/ProductApi";
import { fetchMembership } from "../../../api/MembershipApi";
import Loading from "../../controls/Loading";
import ConfirmBox from "../../controls/ConfirmBox";
import AddCategory from "../category/AddCategory";
import AddSubCategory from "../subcategory/AddSubCategory";
import AddBrand from "../brand/AddBrand";
import Cataloguesearchdrawer from "./Cataloguesearchdrawer";
import { fetchStore } from "../../../api/storeApi";
import { useLocation } from "react-router-dom";
import Globalcataloguelabel from "../../controls/Globalcataloguelabel";
import TextArea from "../../controls/TextArea";
import Button from "../../controls/Button";
import Icon from "../../../assets/icons/Icon";
import { fetchTaxes } from "../../../api/taxApi";
import MultiAutocomplete from "../../controls/MultiAutocomplete";
import QuillEditor from "../../controls/QuillEditor";
import { useRef } from 'react';
import { useSelector, useDispatch } from "react-redux";
import { selectProductModule } from "../../../redux/slices/customFieldSlice";
import { selectUser, selectRegistration } from "../../../redux/slices/userSlice";
import useCurrencySymbol from "../../controls/CurrencySymbol";
import { getUOMs, isMobileView } from "../../controls/CommonFunctions"
import PopupModal from "../../controls/PopupModal";
import InfoModal from "../../controls/InfoModal";

const Addproduct = ({ onSave, onClose, selectedProductID }) => {
  const productCustomFields = useSelector(selectProductModule);
  const user = useSelector(selectUser);

  const registration = useSelector(selectRegistration);

  const [productAutoGeneratedSKU, setProductAutoGeneratedSKU] = useState(registration?.AutoGenerateSKU || false);
  const [isPincode, setIsPincode] = useState(false);
  console.log(registration, "select registration");
  const currencySymbol = useCurrencySymbol();
  const [markup,setMarkup]=useState(0);

  const [maxQty,setMaxQty]=useState(0);
  const [minQty,setMinQty]=useState(0);
  const [notifyCustomerInDays,setNotifyCustomerInDays]=useState(0);
  const [reorderQty,setReorderQty]=useState(0);
  const [smsTemplateId,setSmsTemplateId]=useState("");
  const [searchMode,setSearchMode]=useState("");
  const [enableAlerts,setEnableAlerts]=useState(false);



  // Get the first product field (if available)
  const customFieldData = productCustomFields;
  console.log("customfields", customFieldData);

  const topRef = useRef(null);

  const [dataLoading, setDataLoading] = useState(false);
  const [chargeTaxesonthisProduct, setChargeTaxesonthisProduct] = useState(registration?.IsAllowChargeTaxOnProduct || false);
  const [taxInclusiveSales, setTaxInclusiveSales] = useState(registration?.IsAllowTaxInclusiveOnSales || false);
  const [taxInclusivePurchase, setTaxInclusivePurchase] = useState(false);
  const [taxDropDownValue, setTaxDropDownValue] = useState("");
  const [taxDropDownLabel, setTaxDropDownLabel] = useState("");
  const [infoType, setInfoType] = useState("");

  const [showInfoModal, setShowInfoModal] = useState(false);
  const [inventoryDropDownValue, setInventoryDropDownValue] = useState("FIFO");


  const [categoryData, setCategoryData] = useState([]);
  const [categoryName, setCategoryName] = useState("");
  const [categoryId, setCategoryId] = useState("");

  const [subCategoryName, setSubCategoryName] = useState("");
  const [subCategoryId, setSubCategoryId] = useState("");
  const [filteredsubcategorydata, setfilteredsubcategorydata] = useState([]);

  const [brandData, setBrandData] = useState([]);
  const [brandName, setBrandName] = useState("");
  const [brandId, setBrandId] = useState("");

  //input values 
  const [productName, setProductName] = useState("");
  const [sku, setSku] = useState(productAutoGeneratedSKU ? "Auto Generate" : "");
  const [psin, setPsin] = useState("");
  const [barcode, setBarcode] = useState("");
  const [supplyPrice, setSupplyPrice] = useState("");
  const [marginPercentage, setMarginPercentage] = useState("");
  const [marginAmount, setMarginAmount] = useState("");
  const [msp, setMsp] = useState("");
  const [retailPrice, setRetailPrice] = useState("");
  const [discountPercentage, setDiscountPercentage] = useState("");
  const [discountAmount, setDiscountAmount] = useState("");
  const [mrp, setMrp] = useState("");
  const [hsnSacCode, setHsnSacCode] = useState("");

  //additional setting toogles variables
  const [favourite, setFavourite] = useState(false);
  const [allowPriceEdit, setAllowPriceEdit] = useState(registration?.IsAllowPriceEdit || false);
  const [discountable, setDiscountable] = useState(true);
  const [allowTaxChange, setAllowTaxCharge] = useState(registration?.IsAllowTaxChange ||  false);
  const [PromptforQtyattheTimeBilling, setPromptforQtyatthetimeBilling] = useState(false);
  const [sequenceNo, setSequenceNo] = useState("");
  const [repackProduce, setRepackProduce] = useState(false);
  const [bom, setBom] = useState(false);
  const [bomManual, setBomManual] = useState(false);
  const [canbeUsedasConsumable, setCanbeUsedasConsumable] = useState(false);
  const [showAdditionalChargesonBillPrint, setShowAdditionalChargesonBillPrint] = useState(false);

  //name rror variable
  const [productNameError, setProductNameError] = useState("");
  const [skuError, setSkuError] = useState("");
  const [barcodeError, setBarcodeError] = useState("");
  const [categoryError, setCategoryError] = useState("");
  const [retailPriceError, setRetailPriceError] = useState("");
  const [mrpError, setMrpError] = useState("");
  const [mrpAndRetailPriceError, setMrpAndRetailPriceError] = useState("");
  const navigate = useNavigate();

  const [imgArray, setImgArray] = useState([]); // Store the array of uploaded images.
  const [imgLoading, setimgLoading] = useState(false); // Track loading state.

  const [addCategoryComp, setAddCategoryComp] = useState(false);
  const [openSubCategory, setOpenSubCategory] = useState(false);
  const [openAddBrand, setOpenAddBrand] = useState(false);
  const [catalogueSearchDrawer, setCatalogueSearchDrawer] = useState(false);

  const [allSubCategoryData, setAllSubCategoryData] = useState([]);
  const [storeData, setStoreData] = useState([]);
  const [storeDataInInventory, setStoreDataInInventory] = useState([]);

  const [isGc, setIsGc] = useState(false);
  const [customFeild1, setCustomField1] = useState("");
  const [customFeild2, setCustomField2] = useState("");
  const [customFeild3, setCustomField3] = useState("");
  const [customFeild4, setCustomField4] = useState("");
  const [customFeild5, setCustomField5] = useState("");
  const [customFeild6, setCustomField6] = useState("");

  const [autoGenerateSKU, setAutoGenerateSKU] = useState(false);
  const [serviceDuration, setServiceDuration] = useState(0);
  const [walletTopUpSameAsRetailPrice, setWalletTopUpSameAsRetailPrice] = useState(false);
  const [walletTopUpAmount, setWalletTopUpAmount] = useState(0);
  const [walletTopUpError, setWalletTopUpError] = useState("");
  const [editWalletTopUpAmount, setEditWalletTopUpAmount] = useState(false);



  const [productType, setProductType] = useState("");
  const [productTypeID, setproductTypeID] = useState("");
  const [productTypeError, setproductTypeError] = useState("");

  const [OMNIEnabled, setOMNIEnabled] = useState(false);
  const [maxOrderQty, setMaxOrderQty] = useState(0);



  //new field varaibels 
  const [packagingCharges, setPackagingCharges] = useState(0);
  const [soldAtSpecificStoresOnly, setSoldAtSpecificStoresOnly] = useState(false);
  const [someStoresHaveDifferentPricing, setSomeStoresHaveDifferentPricing] = useState(false);
  const [taxBaseOnRetailPrice, setTaxBaseOnRetailPrice] = useState(false);
  const [taxData, setTaxData] = useState([]);

  const [uniqueLabel, setUniqueLabel] = useState("");
  const [batchTrackingBatchNoRequired, setBatchTrackingBatchNoRequired] = useState(false);
  const [batchTrackingMRPRequired, setBatchTrackingMRPRequired] = useState(false);
  const [batchTrackingExpDateRequired, setBatchTrackingExpDateRequired] = useState(false);
  const [batchTrackingMfgDateRequired, setBatchTrackingMfgDateRequired] = useState(false);
  const [batchTrackingDateFormat, setBatchTrackingDateFormat] = useState('');

  const [defaultSalesUOMValue, setDefaultSalesUOMValue] = useState("");
  const [defaultSalesUOMLabel, setDefaultSalesUOMLabel] = useState("");
  const [defaultPurchaseUOMValue, setDefaultPurchaseUOMValue] = useState("");
  const [defaultPurchaseUOMLabel, setDefaultPurchaseUOMLabel] = useState("");

  const [shortDescription, setShortDescription] = useState("");
  const [longDescription, setLongDescription] = useState("");

  const [outOfStock, setOutOfStock] = useState(false);
  const [associateMembership, setAssociateMembership] = useState(false);
  const [membership, setMembership] = useState("");
  const [membershipID, setMembershipID] = useState("");
  const [membershipData, setMembershipData] = useState([]);

  const [validityInDays, setValidityInDays] = useState("");
  const [validityInDaysError, setValidityInDaysError] = useState("");
  const [packageServices, setPackageServices] = useState([]);
  const [services, setServices] = useState([]);
  const [selectedService, setSelectedService] = useState({});
  const [packagesServiceError, setPackageServiceError] = useState("");


  const [error, setError] = useState(false);

  const uomOptionData = getUOMs;
  console.log("uomoption", uomOptionData);


  const fetchGlobalCatalogueObject = (product) => {
    stateData(product);
    console.log("proudct", product);
  }

  const stateData = (product) => {
    setCategoryName("");
    setCategoryId("");
    setSubCategoryName("");
     setSubCategoryId("");
    setBrandName("");
    setBrandId("");
// CATEGORY & SUBCATEGORY
if (
  product?.Category &&
  Array.isArray(categoryData) &&
  categoryData.length
) {
  const category = categoryData.find(
    (c) => c.Name === product.Category
  );

  if (category) {
    setCategoryName(category.Name);
    setCategoryId(category.key);
    setCategoryError("");

    // SUBCATEGORY
    if (
      product?.Subcategory &&
      Array.isArray(allSubCategoryData) &&
      allSubCategoryData.length
    ) {
      const subCategory = allSubCategoryData.find(
        (c) => c.Name === product.Subcategory
      );

      if (subCategory) {
        setSubCategoryName(subCategory.Name);
        setSubCategoryId(subCategory.key);
      }
    }
  }
}

// BRAND
if (
  product?.Brand &&
  Array.isArray(brandData) &&
  brandData.length
) {
  const brand = brandData.find(
    (b) => b.Brand === product.Brand
  );

  if (brand) {
    setBrandName(brand.Brand);
    setBrandId(brand.key);
  }
}


    setMrpError("");
    setProductNameError("");
    setBarcodeError("");
    setCategoryError("");
    console.log("Global data:", product);
    setProductName(product?.name);
    setBarcode(product?.Code);
    // setPsin(product?.PincodeProductID);
    setMrp(product?.MRP);
    // setCustomField3(product?.Type);
    // setCustomField1(product?.Code);
    // setCustomField2("GC");
    // setCategoryName(product?.Category);
    // setSubCategoryName(product?.Subcategory);
    // setBrandName(product?.Brand);



    // If `ProductImages` is an array of image URLs

    setImgArray(product?.ProductImages);



  };

  const { key } = useParams();
  useEffect(() => {
    if (key || selectedProductID) {
      let productID = key || selectedProductID;
      fetchsingledata(productID); // Fetch single product data if key is present
    }
    else {
      const e = { label: "Goods for sale", value: "1", id: 1 };
      setproductTypeID(e.id);
      setProductType(e.label);
      onProductTypeChange(e)
    }
  }, []);

  const fetchsingledata = async (key) => {
    setDataLoading(true);
    try {
      const response = await fetchSingleProductApi(key);
      console.log("response data", response);
      console.log("response data", response);
      const filteredData = response;


      setDataLoading(false);
      const product = filteredData;
      console.log("product data", product);
      setProductName(product.Name);
      setSku(product.SKU);
      setBarcode(product.BarCode);
      setMarginAmount(product.MarginAmount);
      setMarginPercentage(product.MarginPercentage);
      setSupplyPrice(product.SupplyPrice);
      setMsp(product.MSP);
      setRetailPrice(product.RetailPrice);
      setDiscountPercentage(product.DiscountPercentage);
      setDiscountAmount(product.DiscountAmount);
      setMrp(product.MRP);
      setHsnSacCode(product.HSNSACCode);
      setPsin(product.PincodeProductID);
      setChargeTaxesonthisProduct(product.ChargeTaxOnProduct);
      setTaxInclusiveSales(product.TaxInclusive);
      setTaxInclusivePurchase(product.TaxInclusivePurchase);
      setTaxDropDownLabel(product.TaxGroup);
      setTaxDropDownValue(product.TaxID);
      setInventoryDropDownValue(product.InventoryType);
      setCategoryName(product.Category);
      setCategoryName(product.Category);
      setCategoryId(product.CategoryID);
      setSubCategoryName(product.SubCategory);
      setSubCategoryName(product.SubCategory);
      setSubCategoryId(product.SubCategoryID);
      setBrandName(product.Brand);
      setBrandName(product.Brand);
      setBrandId(product.BrandID);
      setAllowTaxCharge(product.AllowTaxChange);
      setFavourite(product.Favourite);
      setAllowPriceEdit(product.AllowPriceEdit);
      setDiscountable(product.AllowDiscount);
      setPromptforQtyatthetimeBilling(product.QtyPrompt);
      setSequenceNo(product.SequenceNo);
      setRepackProduce(product.RepackProduce);
      setBom(product.BOM);
      setBomManual(product.BOMManual);
      setCanbeUsedasConsumable(product.CanBeUsedAsConsumable);
      setShowAdditionalChargesonBillPrint(product.ShowAsAdditionalCharges);
      setUniqueLabel(product.UniqueLabel);
      setSoldAtSpecificStoresOnly(product.AccessibleToSelectedStores);
      setSomeStoresHaveDifferentPricing(product.StoreSpecificPricing);
      setBatchTrackingBatchNoRequired(product.BatchTrackingBatchNoRequired);
      setBatchTrackingMRPRequired(product.BatchTrackingMRPRequired);
      setBatchTrackingMfgDateRequired(product.BatchTrackingMfgDateRequired);
      setBatchTrackingExpDateRequired(product.BatchTrackingExpDateRequired);
      setBatchTrackingDateFormat(product.BatchTrackingDateFormat);
      setAutoGenerateSKU(product.AutoGenerateSKU);
      setWalletTopUpAmount(product.WalletTopUpAmount);
      setWalletTopUpSameAsRetailPrice(product.WalletTopUpSameAsRetailPrice);
      setEditWalletTopUpAmount(product.EditWalletTopUpAmount);
      setMarkup(product?.Markup || 0);
      setMaxQty(product?.MaxQty || 0);
           setMinQty(product?.MinQty || 0);
           setNotifyCustomerInDays(product?.NotifyCustomerInDays || 0);
           setReorderQty(product?.ReorderQty);
           setSmsTemplateId(product?.SMSTemplateID || "");
           setSearchMode(product?.SearchMode || "All"),
           setEnableAlerts(product?.EnableAlerts || false);
      setValidityInDays(product.ValidityInDays);
      setPackageServices(product.PackageServices);
      {
        setCustomField1(product.CustomField1);
        setCustomField2(product.CustomField2);
        setCustomField3(product.CustomField3);
        setCustomField4(product.CustomField4);
        setCustomField5(product.CustomField5);
        setCustomField6(product.CustomField6);
      }

      setproductTypeID(product.ProductTypeID);
      console.log("productType id", product.ProductTypeID);
      setProductType(product.ProductType);
      setPackagingCharges(product.PackagingCharges);
      setShortDescription(product.Description);
      setLongDescription(product.LongDescription);
      setOutOfStock(product.OutOfStock);
      setOMNIEnabled(product.OMNIEnabled);
      setAssociateMembership(product.AssociateMembership);
      setMembership(product.Membership);
      setMembershipID(product.MembershipID);
      setTaxBaseOnRetailPrice(product.PriceBasedTax);

   if (product.TaxPriceRange && product.TaxPriceRange.length > 0) {

  const taxRows = product.TaxPriceRange.map(range => ({
    FromPrice: range.FromPrice || "",
    ToPrice: range.ToPrice || "",
    TaxID: range.TaxID || "",
    TaxGroup: range.TaxGroup || "",
  }));

  // add one empty row at end
  taxRows.push({
    FromPrice: "",
    ToPrice: "",
    TaxID: "",
    TaxGroup: "",
  });

  setTaxOnRetailPriceRows(taxRows);
}

      // Set StoreSpecificPrices
      if (product.StoreSpecificPrices && product.StoreSpecificPrices.length > 0) {
        const storeRowsData = product.StoreSpecificPrices.map((store) => ({
          Store: store.Store,
          StoreID: store.StoreID,
          SupplyPrice: store.SupplyPrice,
          MarginAmount: store.MarginAmount,
          Markup:store?.Markup || 0,
          MarginPercentage: store.MarginPercentage,
          MSP: store.MSP,
          RetailPrice: store.RetailPrice,
          DiscountPercentage: store.DiscountPercentage,
          DiscountAmount: store.DiscountAmount,
          WalletTopUpSameAsRetailPrice: store.WalletTopUpSameAsRetailPrice,
          WalletTopUpAmount: store.WalletTopUpAmount,
          EditWalletTopUpAmount: store.EditWalletTopUpAmount,

          MRP: store.MRP,
        }));
        setStoreSpecificPricesRows([{ Store: "", StoreID: "", SupplyPrice: "", MSP: "", MarginAmount: "", MarginPercentage: "", RetailPrice: "", DiscountPercentage: "", DiscountAmount: "", MRP: "" }, ...storeRowsData]);

      }


      if (product.UOM) {
        const selectedUOM = uomOptionData.find(option => option.value === product.UOM);
        setPrimaryUomValue(product.UOM);
        setPrimaryUomLabel(selectedUOM.label);
      }
      if (product.SalesUOM) {
        try {
          const salesSelectedUOM = uomOptionData.find(option => option.value === product.SalesUOM);
          setDefaultSalesUOMValue(product.SalesUOM);
          setDefaultSalesUOMLabel(salesSelectedUOM.label);
        }
        catch (err) {
          setDefaultSalesUOMValue("");
          setDefaultSalesUOMLabel("");
        }
      }
      if (product.PurchaseUOM) {
        try {
          const purchaseSelectedUOM = uomOptionData.find(option => option.value === product.PurchaseUOM);
          setDefaultPurchaseUOMValue(product.PurchaseUOM);
          setDefaultPurchaseUOMLabel(purchaseSelectedUOM.label);
        }
        catch (e) {
          setDefaultPurchaseUOMValue("");
          setDefaultPurchaseUOMLabel("");
        }
      }
      if (product.UOM) {
        const selectedUOM = uomOptionData.find(option => option.value === product.UOM);
        setPrimaryUomValue(product.UOM);
        setPrimaryUomLabel(selectedUOM.label);
      }
      if (product.SalesUOM) {
        try {
          const salesSelectedUOM = uomOptionData.find(option => option.value === product.SalesUOM);
          setDefaultSalesUOMValue(product.SalesUOM);
          setDefaultSalesUOMLabel(salesSelectedUOM.label);
        }
        catch (err) {
          setDefaultSalesUOMValue("");
          setDefaultSalesUOMLabel("");
        }
      }
      if (product.PurchaseUOM) {
        try {
          const purchaseSelectedUOM = uomOptionData.find(option => option.value === product.PurchaseUOM);
          setDefaultPurchaseUOMValue(product.PurchaseUOM);
          setDefaultPurchaseUOMLabel(purchaseSelectedUOM.label);
        }
        catch (e) {
          setDefaultPurchaseUOMValue("");
          setDefaultPurchaseUOMLabel("");
        }
      }



      if (product.SecondaryUOMs && product.SecondaryUOMs.length > 0) {
        // Map the fetched data to the state
        const secondaryUoms = product.SecondaryUOMs.map((data) => ({
          secondaryUOM: data.SecondaryUOM,
          secondaryUOMValue: data.SecondaryUOMValue,
          conversion: data.Conversion.toString(),
        }));

        // Set the state with the fetched data
        setUomTableRows([{ secondaryUOM: "", secondaryUOMValue: "", conversion: "" }, ...secondaryUoms]);

        // Create default UOM options from the fetched data
        const primaryUomObj = {
          value: product.UOM,
          label: uomOptionData.find(option => option.value === product.UOM)?.label || product.UOM
        };

        const secondaryUomObjs = product.SecondaryUOMs.map(data => ({
          value: data.SecondaryUOMValue,
          label: data.SecondaryUOM
        }));

        setDefaultUomOptions([primaryUomObj, ...secondaryUomObjs]);
      }
      // Set variants and attributes
      // Set Attributes and Variants
      if (product.Attributes && product.Attributes.length > 0) {
        const attributeRows = product.Attributes.map((attr) => ({
          attribute: attr.Attribute,
          values: attr.AttributeValues.map((val) => val.value),
        }));
        setAddAttributeRow(attributeRows);
      }
      console.log("product.Variants", product?.Variants?.length);
      if (product?.Variants && product.Variants.length > 0) {
        const variantRows =
          product.Variants
            .map((variant) => ({
              attribute: variant.Name,
              sku: variant.SKU,
              mrp: variant.MRP || "",
              retailPrice: variant.RetailPrice || "",
              supplyPrice: variant.SupplyPrice || "",
              discountAmount: variant.DiscountAmount || "",
              discountPercentage: variant.DiscountPercentage || "",
              marginAmount: variant.MarginAmount || "",
              marginPercentage: variant.MarginPercentage || "",
              productID: variant.ProductID || "",
              msp: variant.MSP || "",
              skuError: variant.SKUError || "",
              isDeleted: variant.IsDeleted || false
            })) || [];

        console.log("variantRows", variantRows.length);
        setAddVariantRow(variantRows);
      }

      //       if (product.Variants && product.Variants.length > 0) {
      //         const variantRows = product.Variants.map((variant) => ({
      //           attribute: variant.Name,
      //           sku: variant.SKU,
      //           mrp: variant.MRP || "",
      // supplyPrice:variant.SupplyPrice || 0,
      //           retailPrice: variant.RetailPrice || "",
      //           discountAmount: variant.DiscountAmount || "",
      //           discountPercentage: variant.DiscountPercentage || "",
      //           productID:variant.ProductID || "",
      //           msp:variant.MSP || ""
      //         }));
      //         setAddVariantRow(variantRows);
      //       }



      if (product.StoreSpecificQtys && product.StoreSpecificQtys.length > 0) {
        // Map the fetched store quantities to match your storeQtys structure
        const storeQtysData = product.StoreSpecificQtys.map(store => ({
          StoreCode: store.StoreCode,
          StoreID: store.StoreID,
          StoreName: store.StoreName,
          InStockQty: store.InStockQty,
          MinQty: store.MinQty,
          MaxQty: store.MaxQty,
          ReorderQty: store.ReorderQty,

        }));
        setStoreQtys(storeQtysData);
      }

      if (product.Images && product.Images.length > 0) {
        // Map through images and store in imgArray (you can set them directly to state)
        setImgArray(product.Images.map(image => image.ImagePath)); // Assuming `ImagePath` holds the URL or Base64 string
      }
      console.log("porduct brand ", product.Brand, "category", product.Category);


      if (product.Images && product.Images?.length > 0) {
        // Map through images and store in imgArray (you can set them directly to state)
        setImgArray(product.Images.map(image => image.ImagePath)); // Assuming `ImagePath` holds the URL or Base64 string
      }
      console.log("porduct brand ", product.Brand, "category", product.Category);


    } catch (error) {
      setDataLoading(false);
      console.error("Error fetching single product data:", error);
      toast.error("Error fetching product data.");
    }
  };

  const fetchServices = async (packageSearchValue) => {
    try {
      const response = await fetchProducts(
        packageSearchValue,
        0,
        packageSearchValue ? 1000 : 10,
        "Services",

        // filters.psin,
        // filters.globalCatalogue === "all" ? "" : filters.globalCatalogue
      );

      if (response.code === "0") {
        setServices(response?.products);
      } else {
        setServices([]);
        toast.error(response.message || "Failed to fetch services!");
      }
    } catch (error) {
      console.error(error);
      toast.error("Error fetching products.");
      setServices([]);
    }
  };


  // Fetch all categories (do not filter by IsDeleted here)
  const fetchcategoryData = async () => {
    try {
      const response = await fetchCategory();
      const categories = response.productCategories.filter(
        (e) => !e.IsDeleted);
      setCategoryData(categories);
    } catch (err) {
      console.error("Error fetching categories:", err);
    }
  };

  // Fetch API data on component mount
  const fetchSubCategoriesData = async () => {
    try {

      const response = await fetchSubCategory();
      const subCategory = response.productSubCategories.filter(
        (e) => !e.IsDeleted);
      // AxiosAPI.get(`/catalog/subcategories`);
      setAllSubCategoryData(subCategory);

      console.log("all sub category data :", response.productSubCategories);

      // console.log("sub category data", response);
    } catch (error) {
      console.error("Error sub category:", error);
    }
  };

  const fetchBrandsData = async () => {
    try {
      const response = await fetchBrands();
      console.log("brand data", response.productBrands);
      const brands = response.productBrands.filter(
        (e) => !e.IsDeleted);
      setBrandData(brands);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchTaxesData = async () => {
    try {
      const response = await fetchTaxes();
      const filteredData = response.productTaxes.filter((tax) => tax.IsDeleted === false);
      setTaxData(filteredData);
      console.log("taxdata", taxData);
    } catch (error) {
      console.error("Error fetching taxes:", error);
    }
  };

  const taxOption = taxData.map(item => ({
    value: item.key,
    label: item.TaxGroup
  }));

  const fetchstoredata = async () => {
    try {
      let response = await fetchStore();
      console.log("store data", storeData.stores);  // Check if stores exist
      const stores = response.stores.filter((e) => !e.IsDeleted)
      setStoreData(stores);  // Assuming 'stores' is an array
      if (!key) {
        setStoreDataInInventory(stores);
      }


    } catch (error) {
      console.log("store data error", error);
    }
  };

  const fetchMembershipData = async () => {
    try {
      const response = await fetchMembership();
      const filterData = response.MembershipData.filter((e) => !e.IsDeleted);
      setMembershipData(filterData);
    } catch (error) {
      console.log("error in membership", error);
    }
  };




  useEffect(() => {
    fetchcategoryData();
    fetchBrandsData();
    fetchSubCategoriesData();
    fetchTaxesData();
    fetchstoredata();
    fetchMembershipData();
    fetchServices();
  }, []);


  const storeOptions = storeData.map(store => ({
    value: store.key,  // Assuming 'key' is a unique identifier for each store
    label: store.StoreName,  // Display the StoreName in the dropdown
  }));


  // Calculate Discount Percentage from Discount Amount and Retail Price
  const calculateDiscountPercentage = (discountAmount, retailPrice) => {
    if (retailPrice === 0) return 0; // To avoid division by zero
    const discountPercentage = (discountAmount / retailPrice) * 100;
    return  discountPercentage;
  };

  // Calculate Discount Amount from Discount Percentage and Retail Price
  const calculateDiscountAmount = (discountPercentage, retailPrice) => {
    if (retailPrice === 0) return 0; // To avoid division by zero
    const discountAmount = (discountPercentage / 100) * retailPrice;
    return discountAmount;
  };

  const handleImageUpload = async (image) => {
    // Start loading
    setimgLoading(true);
    // Simulate image upload
    const uploadurl = await uploadImagesToServer(image); // Replace with your actual upload logic

    console.log("uploadurl", uploadurl);

    if (uploadurl && imgArray.length < 4) {
      setImgArray((prevImgArray) => [...prevImgArray, uploadurl]);
    }
    setimgLoading(false); // Stop loading after image is uploaded
  };

  const [showConfirmBox, setShowConfirmBox] = useState(false); // Controls visibility of confirm box
  const [deleteIndex, setDeleteIndex] = useState(null); // Tracks the index of the image to delete
  // Function to handle when the delete button is clicked
  const handleImageDelete = (index) => {
    setDeleteIndex(index); // Store the image index to delete
    setShowConfirmBox(true); // Show the confirmation box
  };

  // Function to handle the image deletion confirmation
  const handleConfirmDelete = () => {
    if (deleteIndex !== null) {
      // Remove the image from the array
      const newImgArray = imgArray.filter((_, i) => i !== deleteIndex);
      setImgArray(newImgArray);
    }
    setShowConfirmBox(false); // Hide the confirmation box after deletion
  };

  // Function to handle cancellation
  const handleCancelDelete = () => {
    setShowConfirmBox(false); // Hide the confirm box without doing anything
  };


  const handleRemoveClick = () => {
    stateData(null);
    setIsGc(false);
    setProductName("");
    setBarcode("");
    setMrp("");
    setRetailPrice("");

    setMrpError("");
    setProductNameError("");
    setBarcodeError("");
    setCategoryError("");
    setProductName("");
    setBarcode("");
    setPsin("");
    setMrp("");
    setCustomField3("");
    setCustomField1("");
    setCustomField2("");
    setCategoryName("");
    setSubCategoryName("");
    setBrandName("");
    setImgArray([]);


  };


  //inventory specific storqty table 
  const [storeQtys, setStoreQtys] = useState([]);

  // Initialize storeQtys when storeDataInInventory changes
  useEffect(() => {
    if (storeDataInInventory.length > 0) {
      setStoreQtys(storeDataInInventory.map(store => ({
        StoreCode: store.StoreCode,
        StoreID: store.key,
        StoreName: store.StoreName,
        InStockQty: 0,
        MinQty: 0,
        MaxQty: 0,
        ReorderQty: 0,
      })));
    }
  }, [storeDataInInventory]);


  // Update handler
  const handleQtyChange = (index, field, value) => {
    const updatedQtys = [...storeQtys];
    updatedQtys[index][field] = value;
    setStoreQtys(updatedQtys);
  };


  //inventory specific qty close here

  //table code 
  // State to hold rows
  const [storeSpecificPricesRows, setStoreSpecificPricesRows] = useState([{
    Store: "",
    StoreID: "",
    SupplyPrice: 0,
    MarginAmount: 0,
    MarginPercentage: 0,
    MSP: 0,
    RetailPrice: 0,
    DiscountPercentage: 0,
    DiscountAmount: 0,
    WalletTopUpSameAsRetailPrice: false,
    WalletTopUpAmount: 0,
    EditWalletTopUpAmount: false,
    Markup:0,
    MRP: 0
  }]);

  // Handle input changes
  const handleStoreRowChange = (index, field, value) => {
    const updatedRows = [...storeSpecificPricesRows];

    if (field === 'storeSelection') {
      updatedRows[index] = {
        ...updatedRows[index],
        Store: value.label,
        StoreID: value.value
      };
    } else {
      updatedRows[index][field] = value;

      // Auto-calculate discount amounts
      if (['RetailPrice', 'DiscountPercentage', 'DiscountAmount'].includes(field)) {
        const retailPrice = parseFloat(updatedRows[index].RetailPrice) || 0;
        const discountPercentage = parseFloat(updatedRows[index].DiscountPercentage) || 0;
        const discountAmount = parseFloat(updatedRows[index].DiscountAmount) || 0;

        if (field === 'DiscountPercentage') {
          updatedRows[index].DiscountAmount = retailPrice ? ((discountPercentage / 100) * retailPrice).toFixed(2) : "";
        } else if (field === 'DiscountAmount') {
          updatedRows[index].DiscountPercentage = retailPrice ? ((discountAmount / retailPrice) * 100).toFixed(2) : "";
        } else if (field === 'RetailPrice') {
          if (updatedRows[index].DiscountPercentage) {
            updatedRows[index].DiscountAmount = ((parseFloat(updatedRows[index].DiscountPercentage) / 100) * retailPrice).toFixed(2);
          } else if (updatedRows[index].DiscountAmount) {
            updatedRows[index].DiscountPercentage = retailPrice ? ((parseFloat(updatedRows[index].DiscountAmount) / retailPrice * 100).toFixed(2)) : "";
          }
        }
      }
    }

    setStoreSpecificPricesRows(updatedRows);
  };

  // Add new row
  const [storeError, setStoreError] = useState("");
  const [retailPriceErrorUnderSpecificStore, setRetailPriceErrorUnderSpecificStore] = useState("");
  const addStoreSpecificPriceRow = () => {
    let storeError = "";
    let retailPriceError = "";
    // Check if store is already selected in other rows
    const selectedStoreID = storeSpecificPricesRows[0].StoreID;
    const isStoreAlreadyUsed = storeSpecificPricesRows.some(
      (row, index) => index !== 0 && row.StoreID === selectedStoreID
    );

    if (!selectedStoreID) {
      storeError = "Please select store!";
    } else if (isStoreAlreadyUsed) {
      storeError = "This store is already added!";
    }

    if (productTypeID !== 4) {
      if (storeSpecificPricesRows[0].RetailPrice === "" || storeSpecificPricesRows[0].RetailPrice == 0) {
        retailPriceError = "Please enter retail price!";
      }
    }



    if (storeError !== "" || retailPriceError !== "") {
      setStoreError(storeError);
      setRetailPriceErrorUnderSpecificStore(retailPriceError);
      return;
    }

    // Copy all values from first row
    const firstRow = storeSpecificPricesRows[0];
    setStoreSpecificPricesRows([
      // Keep the store selection but clear other fields in first row
      {
        Store: "",
        StoreID: "",
        SupplyPrice: 0,
        MarginAmount: 0,
        MarginPercentage: 0,
        MSP: 0,
        RetailPrice: 0,
        DiscountPercentage: 0,
        DiscountAmount: 0,
        WalletTopUpSameAsRetailPrice: false,
        WalletTopUpAmount: 0,
        EditWalletTopUpAmount: false,
        Markup:0,
        MRP: 0
      },
      // Add new row with all values from first row
      ...storeSpecificPricesRows.slice(1),
      {
        Store: firstRow.Store,
        StoreID: firstRow.StoreID,
        SupplyPrice: firstRow.SupplyPrice,
        MarginAmount: firstRow.MarginAmount,
        MarginPercentage: firstRow.MarginPercentage,
        MSP: firstRow.MSP,
        RetailPrice: firstRow.RetailPrice,
        DiscountPercentage: firstRow.DiscountPercentage,
        DiscountAmount: firstRow.DiscountAmount,
        WalletTopUpSameAsRetailPrice: firstRow.WalletTopUpSameAsRetailPrice,
        WalletTopUpAmount: firstRow.WalletTopUpAmount,
        EditWalletTopUpAmount: firstRow.EditWalletTopUpAmount,
        Markup:firstRow?.Markup || 0,
        MRP: firstRow.MRP
      }
    ]);
  };

  // Remove row
  const removeStoreSpecificPriceRow = (index) => {
    if (storeSpecificPricesRows.length <= 1) return;
    const newRows = [...storeSpecificPricesRows];
    newRows.splice(index, 1);
    setStoreSpecificPricesRows(newRows);
  };

  //
  // State to hold rows, where keys are dynamic based on the label
  const [taxOnRetailPriceRows, setTaxOnRetailPriceRows] = useState([{
    FromPrice: "",
    ToPrice: "",
    TaxID: "",
    TaxGroup: "",
  }]);

  // Add a new row to the form
  const addRow = () => {
    setTaxOnRetailPriceRows([...taxOnRetailPriceRows, {
      FromPrice: "",
      ToPrice: "",
      TaxID: "",
      TaxGroup: ""
    }]);
  };

  // Remove a row from the form
  const removeRow = (index) => {
    const newRows = [...taxOnRetailPriceRows];
    newRows.splice(index, 1);
    setTaxOnRetailPriceRows(newRows);
  };

  // Handle input changes dynamically based on the label
  const handleInputChangeTaxOnRetailPrice = (index, label, value) => {
    const updatedRows = [...taxOnRetailPriceRows];
    updatedRows[index][label] = value;
    setTaxOnRetailPriceRows(updatedRows);
  };



  //varinats code 
  // State to manage the attribute input and error message
  const [defineAttribute, setDefineAttribute] = useState("");
  const [defineAttributeError, setDefineAttributeError] = useState("");
  const [addAttributeRow, setAddAttributeRow] = useState([]); // State to hold added attribute rows
  const [addVariantRow, setAddVariantRow] = useState([]); // State to manage the variant rows

  const handleAddAttributeBtnClick = () => {
    if (addAttributeRow.length >= 3) {
      toast.error("You can only add up to 3 attributes.");
      return;
    }
    if (defineAttribute.trim() === "") {
      setDefineAttributeError("Please Enter Attribute");
      return;
    }

    // Add a new row with the entered attribute name and empty values
    const newRow = { attribute: defineAttribute, values: [] };
    setAddAttributeRow([...addAttributeRow, newRow]);

    // Reset the input and error message
    setDefineAttribute("");
    setDefineAttributeError("");
  };

  // Handle change in selected values for a particular row
  const handleAutocompleteChange = (event, newValue, action, index) => {
    const updatedRows = [...addAttributeRow];
    const previousValues = [...updatedRows[index].values]; // Store previous values
    updatedRows[index].values = newValue; // Update the specific row's values
    setAddAttributeRow(updatedRows);

    // Update the second table's Variant Name column with action and previous values
    updateVariantTable(newValue, action, index, previousValues);
  };

  // Function to update the second table's Variant Name column
  const updateVariantTable = (newValue, action, changedIndex, previousValues) => {
    // Generate all combinations of values from the first table
    const generateCombinations = (rows) => {
      if (rows.length === 0) return [];
      if (rows.length === 1) return rows[0].values;

      return rows.reduce((acc, row) => {
        if (row.values.length === 0) return acc;
        if (acc.length === 0) return row.values;

        return acc.flatMap((name) => row.values.map((value) => `${name} / ${value}`));
      }, []);
    };

    // Generate all combinations
    const variantNames = generateCombinations(addAttributeRow);

    // Get current variant rows to preserve existing data
    const currentVariantRows = [...addVariantRow];

    // Create a map of existing variants for quick lookup
    const existingVariantsMap = new Map();
    currentVariantRows.forEach(row => {
      existingVariantsMap.set(row.attribute, row);
    });

    // If a value was removed, handle soft deletion
    if (action === 'removeOption') {
      // Find which value(s) were removed by comparing with previous state
      const removedValues = previousValues.filter(value => !newValue.includes(value));

      if (removedValues.length > 0) {
        removedValues.forEach(removedValue => {
          // Find all variants that contain the removed value
          const variantsToUpdate = currentVariantRows.filter(variant =>
            variant.attribute.includes(removedValue)
          );

          // Update these variants - mark as deleted if they have productID, otherwise remove
          variantsToUpdate.forEach(variant => {
            if (variant.productID && variant.productID !== "") {
              // Mark as deleted but keep in the array
              existingVariantsMap.set(variant.attribute, {
                ...variant,
                isDeleted: true
              });
            } else {
              // Remove completely if no productID
              existingVariantsMap.delete(variant.attribute);
            }
          });
        });
      }
    }

    // Update the second table with the combined variant names while preserving existing data
    const newVariantRows = variantNames.map((name) => {
      // Check if this variant already exists
      const existingVariant = existingVariantsMap.get(name);

      if (existingVariant) {
        // Return the existing variant with all its data preserved
        return {
          ...existingVariant,
          attribute: name, // Keep the name in case it changed
          isDeleted: false // Reset isDeleted if variant is recreated
        };
      } else {
        // Create new variant with default values
        return {
          attribute: name,
          sku: "",
          skuError: "",
          mrp: mrp || "",
          retailPrice: retailPrice || "",
          discountAmount: discountAmount || "",
          discountPercentage: discountPercentage || "",
          supplyPrice: supplyPrice || "",
          marginPercentage: marginPercentage || "",
          marginAmount: marginAmount || "",
          msp: msp || "",
          productID: "",
          isDeleted: false
        };
      }
    });

    // Also include deleted variants that have productID (for data preservation)
    const deletedVariantsWithProductID = Array.from(existingVariantsMap.values())
      .filter(variant =>
        variant.isDeleted &&
        variant.productID &&
        variant.productID !== "" &&
        !variantNames.includes(variant.attribute)
      );

    // Combine new variants with preserved deleted variants
    const finalVariantRows = [...newVariantRows, ...deletedVariantsWithProductID];

    // Set the new variant rows, preserving existing data
    setAddVariantRow(finalVariantRows);
  };
  // Handle remove row
  const handleRemoveAttributeRow = (index) => {
    const updatedRows = addAttributeRow.filter((_, rowIndex) => rowIndex !== index);
    setAddAttributeRow(updatedRows);

    // Update the variant table based on the new attribute rows
    updateVariantTableAfterAttributeChange(updatedRows);
  };

  // Helper function to update variants when attributes change
  const updateVariantTableAfterAttributeChange = (updatedAttributeRows) => {
    const generateCombinations = (rows) => {
      if (rows.length === 0) return [];
      if (rows.length === 1) return rows[0].values;

      return rows.reduce((acc, row) => {
        if (row.values.length === 0) return acc;
        if (acc.length === 0) return row.values;

        return acc.flatMap((name) => row.values.map((value) => `${name} / ${value}`));
      }, []);
    };

    const variantNames = generateCombinations(updatedAttributeRows);
    const currentVariantRows = [...addVariantRow];

    const existingVariantsMap = new Map();
    currentVariantRows.forEach(row => {
      existingVariantsMap.set(row.attribute, row);
    });

    const newVariantRows = variantNames.map((name) => {
      const existingVariant = existingVariantsMap.get(name);
  
      if (existingVariant) {
        return {
          ...existingVariant,
          attribute: name,
          isDeleted: false
        };
      } else {
        return {
          attribute: name,
          sku: "",
          skuError: "",
          mrp: mrp || "",
          retailPrice: retailPrice || "",
          discountAmount: discountAmount || "",
          discountPercentage: discountPercentage || "",
          supplyPrice: supplyPrice || "",
          marginPercentage: marginPercentage || "",
          marginAmount: marginAmount || "",
          msp: msp || "",
          productID: "",
          isDeleted: false
        };
      }
    });

    // Include deleted variants that have productID
    const deletedVariantsWithProductID = Array.from(existingVariantsMap.values())
      .filter(variant =>
        variant.isDeleted &&
        variant.productID &&
        variant.productID !== "" &&
        !variantNames.includes(variant.attribute)
      );

    const finalVariantRows = [...newVariantRows, ...deletedVariantsWithProductID];
    setAddVariantRow(finalVariantRows);
  };

  // Handle SKU change
  const handleSkuChange = (e, index) => {
    const updatedRows = [...addVariantRow];
    updatedRows[index].sku = e.target.value; // Convert to uppercase
    updatedRows[index].skuError = "";
    setAddVariantRow(updatedRows);


  };





  // Handle variant input value changes
  // Handle variant input value changes
  const handleVariantInputChange = (e, field, index) => {
    const updatedRows = [...addVariantRow];

    if (field === "marginAmount") {
      updatedRows[index][field] = e.target.value;
      let response = calculateMargin(e.target.value, updatedRows[index].supplyPrice, "amount");
      console.log("response", response);
      updatedRows[index]["retailPrice"] = response.retailPrice;
      updatedRows[index]["marginPercentage"] = response.marginPercentage;
    }
    else if (field === "marginPercentage") {
      updatedRows[index][field] = e.target.value;
      let response = calculateMargin(e.target.value, updatedRows[index].supplyPrice, "percentage");
      console.log("response", response);
      updatedRows[index]["retailPrice"] = response.retailPrice;
      updatedRows[index]["marginAmount"] = response.marginAmount;
    }
    else if (field === "retailPrice") {
      updatedRows[index][field] = e.target.value;
      let response = calculateMargin(e.target.value, updatedRows[index].supplyPrice, "retailPrice");
      console.log("response", response);
      updatedRows[index]["marginAmount"] = response.marginAmount;
      updatedRows[index]["marginPercentage"] = response.marginPercentage;

      if (e.target.value && updatedRows[index]["discountPercentage"]) {
        const discountAmount = calculateDiscountAmount(parseFloat(updatedRows[index]["discountPercentage"]) || 0, e.target.value);
        updatedRows[index]["discountAmount"] = discountAmount;
      }
      else {
        updatedRows[index]["discountAmount"] = 0;
      }

    }
    else if (field === "discountAmount") {
      updatedRows[index][field] = e.target.value;
      const retailPrice = updatedRows[index].retailPrice || 0;
      const discountPercentage = calculateDiscountPercentage(parseFloat(e.target.value) || 0, retailPrice);
      updatedRows[index]["discountPercentage"] = discountPercentage;
    }
    else if (field === "discountPercentage") {
      updatedRows[index][field] = e.target.value;
      const retailPrice = updatedRows[index].retailPrice || 0;
      const discountAmount = calculateDiscountAmount(parseFloat(e.target.value) || 0, retailPrice);
      updatedRows[index]["discountAmount"] = discountAmount;

    }
    else {
      // For all other fields, just update the value
      updatedRows[index][field] = e.target.value;
    }

    setAddVariantRow(updatedRows);
  };

  // Handle removing a row
  const handleRemoveVariantRow = (index) => {
    const variantToRemove = addVariantRow[index];

    // Update variant rows
    const updatedVariantRows = [...addVariantRow];
    if (key || selectedProductID) {
      updatedVariantRows[index].isDeleted = true;
    } else {
      updatedVariantRows.splice(index, 1);
    }
    setAddVariantRow(updatedVariantRows);

    // Update attribute rows only if not in edit mode
    // if (!key && !selectedProductID) {
    updateAttributeRowsAfterVariantRemoval(updatedVariantRows);
    // }
  };

  // Improved function that only removes values not used in any remaining variants
  const updateAttributeRowsAfterVariantRemoval = (currentVariantRows) => {
    // Get all active variant names (excluding deleted ones)
    const activeVariantNames = currentVariantRows
      .filter(variant => !variant.isDeleted)
      .map(variant => variant.attribute);

    // Extract all values used in active variants
    const usedValues = new Set();
    activeVariantNames.forEach(variantName => {
      const parts = variantName.split(' / ');
      parts.forEach(part => usedValues.add(part));
    });

    // Update attribute rows, keeping only values that are still used
    const updatedAttributeRows = addAttributeRow.map(row => {
      const valuesToKeep = row.values.filter(value =>
        usedValues.has(value)
      );

      return {
        ...row,
        values: valuesToKeep
      };
    });

    setAddAttributeRow(updatedAttributeRows);
  };
  const splitCombinations = (combinedString, attributeCount = 3) => {
    // Handle case where input might be an array instead of a single string
    if (Array.isArray(combinedString)) {
      return combinedString.map(str => splitCombinations(str, attributeCount));
    }

    const parts = combinedString.split(' / ');
    const result = {};

    for (let i = 0; i < attributeCount; i++) {
      result[`Attribute${i + 1}`] = parts[i] || "";
    }

    return result;
  };

  const prepareVariantDataForDatabase = () => {
    // Extract attributes
    const attributes = addAttributeRow.map((row) => row.attribute);

    // Prepare variant data
    const variants = addVariantRow.map((variant) => {
      console.log("variant ", variant);
      const variantName = variant.attribute;
      const sku = variant.sku;
      if (!autoGenerateSKU) {
        if (sku == "") {
          toast.error("please enter sku");
          return;
        }
      }
      let attribute = splitCombinations(variantName, 3);
      console.log("attribute", attribute);
      return {
        ...attribute,
        DiscountAmount: variant.discountAmount || 0,
        DiscountPercentage: variant.discountPercentage || 0,
        IsDeleted: variant.isDeleted,
        MRP: variant.mrp || 0,
        MSP: variant.msp || 0,
        Name: variantName,
        ProductID: variant.productID,
        RetailPrice: variant.retailPrice || 0,
        MarginAmount: variant.marginAmount || 0,
        MarginPercentage: variant.marginPercentage || 0,
        SKU: sku,
        SKUError: variant.skuError,
        SupplyPrice: variant.supplyPrice || 0,
      };
    });

    return {
      Attributes: addAttributeRow.map((row) => ({
        Attribute: row.attribute,
        AttributeValues: row.values.map((value) => ({ label: value, value })),
      })),
      Variants: variants,
    };
  };

  //uom code here
  const [uomTableRows, setUomTableRows] = useState([{ secondaryUOM: "", secondaryUOMValue: "", conversion: "" }]);
  const [primaryUomValue, setPrimaryUomValue] = useState("");
  const [primaryUomLabel, setPrimaryUomLabel] = useState("");
  const [secondaryUomSelectError, setSecondaryUomSelectError] = useState("");
  const [conversionErrorMessage, setConversionErrorMessage] = useState("");
  const [primaryUomError, setPrimaryUomError] = useState("");
  const [defaultUomOptions, setDefaultUomOptions] = useState([]);

  // Handle Secondary UOM Select Change
  const handleSecondaryUOMChange = (index, item) => {
    const updatedRows = [...uomTableRows];
    updatedRows[index].secondaryUOM = item.label;
    updatedRows[index].secondaryUOMValue = item.value;
    setUomTableRows(updatedRows);
  };

  // Handle Conversion Input Change
  const handleConversionChange = (index, e) => {
    const value = e.target.value;
    const updatedRows = [...uomTableRows];
    updatedRows[index].conversion = value;
    setUomTableRows(updatedRows);
  };

  // Handle Add Button Click
  const handleAddUomRow = () => {
    const firstRow = uomTableRows[0];

    let primaryUomError = "";
    let secondaryUomSelectError = "";
    let conversionErrorMessage = "";

    // Validate if Primary UOM is selected
    if (primaryUomLabel.trim() == "" || !primaryUomLabel) {
      primaryUomError = "Please select a Primary UOM";
    }

    // Validate if Secondary UOM is selected
    if (!firstRow.secondaryUOM) {
      secondaryUomSelectError = "Please select a Secondary UOM";
    }

    // Validate if Conversion is entered
    if (!firstRow.conversion) {
      conversionErrorMessage = "Please enter conversion value";
    }

    if (primaryUomError !== "" || secondaryUomSelectError !== "" || conversionErrorMessage !== "") {
      setPrimaryUomError(primaryUomError);
      setSecondaryUomSelectError(secondaryUomSelectError);
      setConversionErrorMessage(conversionErrorMessage);
      return;
    }

    // Create objects for primary and secondary UOMs
    const primaryUomObj = { value: primaryUomValue, label: primaryUomLabel };
    const secondaryUomObj = {
      value: firstRow.secondaryUOMValue,
      label: firstRow.secondaryUOM
    };

    // Update the defaultUomOptions array with both objects
    setDefaultUomOptions(prevOptions => {
      // Combine both objects into one array for checking
      const newObjects = [];

      // Only add primary if it doesn't exist
      if (!prevOptions.some(option => option.value === primaryUomObj.value)) {
        newObjects.push(primaryUomObj);
      }

      // Only add secondary if it's different from primary and doesn't exist
      if (primaryUomObj.value !== secondaryUomObj.value &&
        !prevOptions.some(option => option.value === secondaryUomObj.value)) {
        newObjects.push(secondaryUomObj);
      }

      // If we have new objects to add, append them
      if (newObjects.length > 0) {
        return [...prevOptions, ...newObjects];
      }

      return prevOptions;
    });

    // Add a new row with the selected Primary UOM, Secondary UOM, and Conversion
    setUomTableRows([
      ...uomTableRows,
      {
        secondaryUOM: firstRow.secondaryUOM,
        secondaryUOMValue: firstRow.secondaryUOMValue,
        conversion: firstRow.conversion
      }
    ]);

    // Clear the first row fields
    setUomTableRows((prevRows) => [
      { secondaryUOMValue: "", secondaryUOM: "", conversion: "" },
      ...prevRows.slice(1)
    ]);

    // Log the data to the console
    const dataToLog = uomTableRows
      .slice(1) // Exclude the first row (add row)
      .map((row) => ({
        SecondaryUOM: row.secondaryUOM,
        Conversion: parseFloat(row.conversion),
        SecondaryUOMValue: row.secondaryUOMValue
      }));

    console.log(dataToLog);
    console.log("Default UOM Options:", [...defaultUomOptions, primaryUomObj, secondaryUomObj]);
  };

  // Handle Remove Button Click
  const handleRemoveUomRow = (index) => {
    const updatedRows = uomTableRows.filter((_, i) => i !== index);
    setUomTableRows(updatedRows);

  };
  let SecondaryUomData = uomTableRows
    .slice(1) // Exclude the first row (add row)
    .map((row) => ({
      SecondaryUOM: row.secondaryUOM,
      Conversion: parseFloat(row.conversion),
      SecondaryUOMValue: row.secondaryUOM.substring(0, 3).toUpperCase() // Example: "DRUMS" -> "DRM"
    }));

  //save functionality 
  const handlesaveclick = async () => {
    if (!autoGenerateSKU) {
      // Check for empty SKUs and set errors
      const hasEmptySkus = addVariantRow.some(variant => variant.sku.trim() === "");

      if (hasEmptySkus) {
        const updatedRows = addVariantRow.map(variant => {
          if (variant.sku.trim() === "") {
            return { ...variant, skuError: "Please enter SKU" };
          }
          return variant;
        });
        setAddVariantRow(updatedRows);
        toast.error("Please enter SKU for all variants");
        return;
      }
    }
    // Reset all errors first
    let productTypeError = "";
    let productNameError = "";
    let skuError = "";
    let barcodeError = "";
    let categoryError = "";
    let retailPriceError = "";
    let mrpError = "";
    let mrpAndRetailPriceError = "";
    let walletTopUpError = "";
    let packageServicesError = "";
    let validityInDaysError = "";

    if ((!soldAtSpecificStoresOnly) &&
      productTypeID === 4 &&
      !walletTopUpSameAsRetailPrice &&
      walletTopUpAmount === 0
    ) {
      walletTopUpError = "Please provide wallet recharge value";
    }

    if (productType.trim() === "") {
      productTypeError = "Please select product type!";
    }



    if (productName.trim() === "") {
      productNameError = "Please provide product name!";
    }
    if (sku.trim() === "") {
      skuError = "Please provide SKU!";
    }

    if (categoryName.trim() === "") {
      categoryError = "Please select category!";
    }
    if (!soldAtSpecificStoresOnly) {
      if (retailPrice == "") {
        retailPriceError = "Please provide retail price!";
      }

    }

    // Special case for MRP < Retail Price
    console.log("mrp", mrp, "retailprice", retailPrice);
    if (retailPrice < 0) {
      retailPriceError = "Retail price cannot be negative";
    }
    if (mrp < 0) {
      mrpError = "MRP cannot be negative";
    }


    if (mrp > 0 && retailPrice > 0) {
      const mrpNum = Number(mrp);
      const retailPriceNum = Number(retailPrice);
      if (mrpNum < retailPriceNum) {
        console.log("error occurred");
        mrpAndRetailPriceError = "MRP can't be less than retail price!";
        retailPriceError = "please enter correct retail price";
        mrpError = "please enter correct mrp price";
      } else {
        console.log("error not occurred");
        mrpAndRetailPriceError = "";
        retailPriceError = "";
        mrpError = "";
      }
    }
    // if ((mrp && retailPrice)) {
    //   if(mrp>=retailPrice){
    //   mrpAndRetailPriceError = "";
    //   retailPriceError = "";
    //   mrpError = "";
    //   }
    // }
    if (productTypeID === 5) {
      if (validityInDays == "") {
        validityInDaysError = "Please provide validity in day's";
        // console.log('validityInDaysError',validityInDaysError)
      }
      if (packageServices.length === 0) {
        packageServicesError = "Please select atleast one service.";
        // console.log('packageServicesError',packageServicesError)
      }
    }



    // Check if any errors exist
    if (productTypeError || productNameError || skuError || barcodeError || categoryError ||
      retailPriceError || mrpError || mrpAndRetailPriceError || walletTopUpError || validityInDaysError || packageServicesError) {
      topRef.current?.scrollIntoView({ behavior: 'smooth' });
      //  toast.error("Please enter mandatory fields!");
      setproductTypeError(productTypeError);
      setProductNameError(productNameError);
      setSkuError(skuError);
      setBarcodeError(barcodeError);
      setCategoryError(categoryError);
      setRetailPriceError(retailPriceError);
      setMrpError(mrpError);
      setMrpAndRetailPriceError(mrpAndRetailPriceError);
      setWalletTopUpError(walletTopUpError);
      setValidityInDaysError(validityInDaysError);
      setPackageServiceError(packageServicesError);
      setError(true);
      return;
    }
    setMrpAndRetailPriceError("");
    setError(false);
    setDataLoading(true);

    const images = imgArray.map((image) => ({
      ImagePath: image,
      ImageSize: ""
    }));
    let hasError = false;

    const cleanedTaxPriceRange = taxOnRetailPriceRows.filter(row =>
  Object.values(row).some(value => value !== "")
);
    // Build the payload
    const payload = {
   
      IsDeleted: false,
      Name: productName,
      SKU: sku,
      CustomSKU:sku.trim(),
      EnableAlerts:enableAlerts,
      BarCode: barcode,
      Category: categoryName,
      CategoryID: categoryId,
      Description: shortDescription,
      LongDescription: longDescription,
      SubCategory: subCategoryName,
      SubCategoryID: subCategoryId,
      Brand: brandName,
      BrandID: brandId,
      SupplyPrice: Number(supplyPrice),
      MSP: Number(msp),
      MarginAmount: Number(marginAmount),
      MarginPercentage: Number(marginPercentage),
      MaxQty:maxQty,
      MinQty:minQty,
      NotifyCustomerInDays:notifyCustomerInDays,
      ReorderQty:reorderQty,
      SMSTemplateID:smsTemplateId,
      SearchMode:searchMode,
      RetailPrice: Number(retailPrice),
      DiscountAmount: Number(discountAmount),
      DiscountPercentage: Number(discountPercentage),
      MRP: Number(mrp),
      ChargeTaxOnProduct: chargeTaxesonthisProduct,
      TaxInclusive: taxInclusiveSales,
      TaxInclusivePurchase: taxInclusivePurchase,
      HSNSACCode: hsnSacCode,
      TaxGroup: taxDropDownLabel,
      TaxID: taxDropDownValue,
      InventoryType: inventoryDropDownValue,
      Favourite: favourite,
      AllowPriceEdit: allowPriceEdit,
      AllowDiscount: discountable,
      AllowTaxChange: allowTaxChange,
      QtyPrompt: PromptforQtyattheTimeBilling,
      OMNIEnabled: OMNIEnabled,
      SequenceNo: sequenceNo,
      RepackProduce: repackProduce,
      OutOfStock: outOfStock,
      Membership: membership,
      MembershipID: membershipID,
      BOM: bom,
      BOMManual: bomManual,
      CanBeUsedAsConsumable: canbeUsedasConsumable,
      ShowAsAdditionalCharges: showAdditionalChargesonBillPrint,
      StoreSpecificQtys: storeQtys,
      Images: images,
      CustomField1: customFeild1,
      CustomField2: customFeild2,
      CustomField3: customFeild3,
      CustomField4: customFeild4,
      CustomField5: customFeild5,
      CustomField6: customFeild6,
      UniqueLabel: uniqueLabel,
         BatchTrackingAutoBatchNoRequired:false,
      BatchTrackingBatchNoRequired: batchTrackingBatchNoRequired,
      BatchTrackingMRPRequired: batchTrackingMRPRequired,
      BatchTrackingMfgDateRequired: batchTrackingMfgDateRequired,
      BatchTrackingDateFormat: batchTrackingDateFormat,
      BatchTrackingExpDateRequired: batchTrackingExpDateRequired,
      SecondaryUOMs: SecondaryUomData,
      SalesUOM: defaultSalesUOMValue,
      PurchaseUOM: defaultPurchaseUOMValue,
      UOM: primaryUomValue,
      ProductType: productType,
      ProductTypeID: productTypeID,
      PackagingCharges: Number(packagingCharges),
      AssociateMembership: associateMembership,
      StoreSpecificPrices: storeSpecificPricesRows.slice(1),
      StoreSpecificPricing: someStoresHaveDifferentPricing,
      AccessibleToSelectedStores: soldAtSpecificStoresOnly,
      
      TaxPriceRange: cleanedTaxPriceRange,
      PriceBasedTax: taxBaseOnRetailPrice,
      WalletTopUpSameAsRetailPrice: walletTopUpSameAsRetailPrice,
      WalletTopUpAmount: walletTopUpSameAsRetailPrice
        ? retailPrice
        : walletTopUpAmount,
      EditWalletTopUpAmount: editWalletTopUpAmount,
      PackageServices: packageServices,
      Markup:markup || 0,
      ValidityInDays: Number(validityInDays),
      ServiceDuration: serviceDuration,
      AutoGenerateSKU: autoGenerateSKU,
      MaxOrderQty: Number(maxOrderQty),
      ...prepareVariantDataForDatabase(),

    };
    // let omniTag = "",
    //   prodName = "",
    //   prodSKU = "";
    // prodName = payload.Name.replace(
    //   /[@!&\/\\#,+()$~%.'"`_:*?<>{}-]/g,
    //   ""
    // ).replace(/[' ']/g, "_");
    // prodSKU = payload.SKU.replace(
    //   /[@!&\/\\#,+()$~%.'"`_:*?<>{}-]/g,
    //   ""
    // ).replace(/[' ']/g, "_");
    // omniTag = prodName + "_" + prodSKU;
    // payload.OMNITag = omniTag;
    console.log("payloaddata--", payload)
    // If editing, include the identifier in the payload
    if (payload.Variants?.length > 0 && !autoGenerateSKU) {
      const skus = payload.Variants.map((item) => item.SKU?.trim());
      const skuExistResponse = await checkSkusAlreadyExist(payload?.Variants);

      const updatedRows = [...addVariantRow];
      let hasDuplicate = false;

      skuExistResponse?.result?.forEach((res) => {
        // Update ALL rows that match this SKU, not just the first one
        updatedRows.forEach((row, rowIndex) => {
          console.log(row.sku + "-> " + res.sku);
          if (row.sku == res.sku) {
            if (res.code === "1") {
              updatedRows[rowIndex].skuError = "SKU already exists!";
              hasDuplicate = true;
            } else {
              updatedRows[rowIndex].skuError = "";
            }
          }
        });
      });
      setAddVariantRow(updatedRows);
      if (hasDuplicate) {
        toast.error("Please check variants sku !");
        hasError = true;
        setDataLoading(false);
        return;
      }
    }


    if (payload.Variants?.length > 0) {
      const hasDuplicate = payload.Variants.some(
        (item) => item.skuError && item.skuError !== ""
      );


      if (hasDuplicate) {
        toast.error("Please check variants sku !");
        setDataLoading(false);
        hasError = true;
        return;
      }
    }

    try {
      let response;
      if (key) {
        response = await handleEditProduct(payload, key);
      } else {
        response = await handleAddProduct(payload);
      }

      if (response?.code === "0") {
        toast.success(`Product ${key ? "updated" : "created"} successfully`);

 

        if (onSave) {
          onSave(response.product);
          onClose();
        }
      } else {
        hasError = true;
        toast.error(
          response?.message || `Product ${key ? "update" : "creation"} failed`
        );
        
            const tempProduct = response?.product;
            if (tempProduct?.Variants && tempProduct?.Variants?.length > 0) {
              const variantRows = tempProduct.Variants.map((variant) => ({
                attribute: variant.Name,
                sku: variant.SKU,
                mrp: variant.MRP || "",
                retailPrice: variant.RetailPrice || "",
                supplyPrice: variant.SupplyPrice || "",
                discountAmount: variant.DiscountAmount || "",
                discountPercentage: variant.DiscountPercentage || "",
                productID: variant.ProductID || "",
                marginAmount: variant.MarginAmount,
                marginPercentage: variant.MarginPercentage,
                msp: variant.MSP || "",
                skuError: variant.SKUError || "",
                isDeleted: variant.IsDeleted,

              }));
              setAddVariantRow(variantRows);
            }

            return;
      }
    } catch (error) {
      hasError = true;
      if (error.response) {
        toast.error(error.response.data?.message || "An error occurred");
      } else if (error.request) {
        toast.error("No response from server");
      } else {
        toast.error(error.message || "An error occurred");
      }
    } finally {
      // setTimeout(() => {
      //   if (!onSave) {
      //     navigate("/catalogue/product");
      //   }
      //   setDataLoading(false);
      // }, 3000); // 5000 ms = 5 seconds
      if (!hasError) {
        setTimeout(() => {
          if (!onSave) {
            navigate("/catalogue/product");
          }
          setDataLoading(false); // stop loader after navigation
        }, 3000);
      } else {
        setDataLoading(false);
      }

    }



  };

  const handleCancel = () => {
    if (onSave) {
      onClose();
    }
    else {
      navigate(-1);
    }
  }

  const resetInventoryFields = () => {
    setPrimaryUomLabel("");
    setPrimaryUomValue("");


    SecondaryUomData = [];
    setDefaultUomOptions([]);
    setUomTableRows([{ secondaryUOM: "", secondaryUOMValue: "", conversion: "" }]);
    setUniqueLabel("");
    setDefaultPurchaseUOMLabel("");
    setDefaultPurchaseUOMLabel("");
    setDefaultSalesUOMLabel("");
    setDefaultSalesUOMValue("");
    setDefineAttribute("");
    setAddAttributeRow([]);
    setAddVariantRow([]);

    setAutoGenerateSKU(false);
    setBatchTrackingBatchNoRequired(false);
    setBatchTrackingMfgDateRequired(false);
    setBatchTrackingMRPRequired(false);
    setBatchTrackingExpDateRequired(false);
  }

  const onProductTypeChange = (type) => {
    let productTypeID = type.id;
    let productType = type.label;

    if (productTypeID !== "") {
      setproductTypeError("");
    }

    setproductTypeID(productTypeID),
      setProductType(productType);
    setInventoryDropDownValue("FIFO");
    resetInventoryFields();


  };


  console.log("gc", customFeild2, "customerField4", customFeild4);

  const inventoryInfo = {
    FIFO: {
      title: "FIFO (First In – First Out)",
      meaning: "The products you bought first are sold first.",
      whyUseful:
        "Helps in keeping old stock moving, avoids expired or outdated products staying in storage.",
      bestFor:
        "Grocery stores, supermarkets, pharmacies (milk, bread, medicines – sell older stock first).",
      example:
        "If you buy 10 milk packets today and 10 more tomorrow, the system will sell today’s 10 packets first.",
    },
    "Unique No": {
      title: "Unique No",
      meaning:
        "Each product or service gets a unique identification number (like a code).",
      whyUseful: "Easy to track and manage products individually.",
      bestFor:
        "Electronics, appliances, jewelry, services (where each item has a serial number or code).",
      example:
        "A mobile phone with IMEI number or a gold chain with a unique tag.",
    },
    Variants: {
      title: "Variants",
      meaning: "Same product but in different options like size, color, or type.",
      whyUseful:
        "Makes it easy to manage multiple versions of the same product under one product name.",
      bestFor: "Clothing, shoes, cosmetics, accessories.",
      example:
        "A T-shirt in sizes S, M, L, XL or a lipstick available in Red, Pink, and Nude shades.",
    },
    "Batch Tracking": {
      title: "Batch Tracking",
      meaning:
        "Products are tracked based on their batch number, manufacturing date, and expiry date.",
      whyUseful: "Important for products that expire or need quality tracking.",
      bestFor: "Medicine shops, food products, cosmetics, chemicals.",
      example:
        "A batch of medicines manufactured in January with expiry in December – helps sell before expiry.",
    },
  };
  const renderInfoText = (data) => {
    if (!data) return null;

    return (
      <div className="space-y-2 text-sm leading-relaxed">
        <p>
          <span className="font-semibold">{data.title}</span>
        </p>
        {data.meaning && (
          <p>
            <span className="font-semibold">Meaning: </span>
            {data.meaning}
          </p>
        )}
        {data.whyUseful && (
          <p>
            <span className="font-semibold">Why useful: </span>
            {data.whyUseful}
          </p>
        )}
        {data.bestFor && (
          <p>
            <span className="font-semibold">Best for: </span>
            {data.bestFor}
          </p>
        )}
        {data.example && (
          <p>
            <span className="font-semibold">Example: </span>
            {data.example}
          </p>
        )}
      </div>
    );
  };

  const calculateMargin = (inputValue, supplyPrice, inputType = 'percentage') => {
    // Convert inputValue to number and validate
    const numValue = parseFloat(inputValue) || 0;
    const numSupplyPrice = parseFloat(supplyPrice) || 0;

    if (numSupplyPrice <= 0) {
      return {
        retailPrice: 0,
        marginAmount: 0,
        marginPercentage: 0,
        supplyPrice: numSupplyPrice,
        inputType: inputType
      };
    }

    let retailPriceResult, marginAmount, marginPercentage;

    if (inputType === 'percentage') {
      // Markup calculation (percentage of cost price)
      marginPercentage = numValue;
      retailPriceResult = numSupplyPrice * (1 + (marginPercentage / 100));
      marginAmount = retailPriceResult - numSupplyPrice;
    }
    else if (inputType === 'amount') {
      // Calculate based on margin amount (markup on cost price)
      marginAmount = numValue;
      retailPriceResult = numSupplyPrice + marginAmount;
      // Margin percentage based on cost price (markup percentage)
      marginPercentage = (marginAmount / numSupplyPrice) * 100;
    }
    else if (inputType === 'retailPrice') {
      // Calculate based on retail price input
      retailPriceResult = numValue;
      marginAmount = retailPriceResult - numSupplyPrice;
      // Margin percentage based on cost price (markup percentage)
      marginPercentage = (marginAmount / numSupplyPrice) * 100;
    }

    return {
      retailPrice: Math.round(retailPriceResult * 100) / 100,
      marginAmount: Math.round(marginAmount * 100) / 100,
      marginPercentage: Math.round(marginPercentage * 100) / 100,
      supplyPrice: numSupplyPrice,
      inputType: inputType
    };
  }
  useEffect(() => {
    console.log("addVariantRow-->", addVariantRow);

  }, [addVariantRow])
  return (

    <CreatePage title={(key || selectedProductID) ? "Edit Product" : "New Product"}
      // handleCancel={handleCancel}
      // handleCancel={handleCancel}
      handleCancel={handleCancel}
      handleSave={handlesaveclick}>
      {dataLoading ? (
        <Loading />
      ) : (
        <div className="grid gap-4" ref={topRef}>

          {error && (
            <div className="bg-[#FEEDEE] w-full rounded-lg relative"  >
              <div className="m-5">
                <div className="flex justify-between items-start">
                  <ul className="max-w-[90%] space-y-1 text-[#000000] list-disc list-inside ">
                    {[productTypeError, productNameError, skuError, barcodeError, categoryError, mrpAndRetailPriceError, retailPriceError, mrpError, walletTopUpError, validityInDaysError, packagesServiceError]
                      .filter(Boolean) // Filters out null/undefined/false values
                      .map((errorMsg, index) => (
                        <li key={index}>{errorMsg}</li>
                      ))}
                  </ul>
                  <span
                    onClick={() => setError(false)} // Clear all errors
                    className="text-red-400 hover:text-red-800 ml-2 w-7 cursor-pointer"
                  >
                    <Icon type="remove" />
                  </span>
                </div>
              </div>
            </div>
          )}


          <PageSection title="GENERAL DETAILS">

            <div className="grid  mt-2 mb-5">


              <div className={`grid mt-3 lg:grid-cols-3 sm:grid-cols-1 gap-6`}>

                <Select
                  isMandatory={true}
                  disabled={key || selectedProductID}
                  fetchAllObject={true}
                  label={"Type"}
                  infoText={
                    <>
                      Goods for Sale – Physical items you sell (e.g., rice bag, shirt, mobile phone). <br />
                      Goods not for Sale – Items you keep for internal use, not for customers (e.g., shop furniture, demo items). <br />
                      Services – Non-physical things you sell (e.g., haircut, repair service). <br />
                      Wallet Recharge – Recharge for customer wallet balance in POS. <br />
                      Packages – Combination of goods or services sold together (e.g., combo meal, beauty package).
                    </>
                  }
                  tooltipPosition="right"
                  tooltipWidth={"500px"}
                  value={productTypeID}
                  options={[
                    { label: "Goods for sale", value: "1", id: 1 },
                    { label: "Goods not for sale", value: "2", id: 2 },
                    { label: "Services", value: "3", id: 3 },
                    { label: "Wallet Recharge", value: "4", id: 4 },
                    { label: "Package", value: "5", id: 5 },
                  ]}
                  onChange={(e) => {
                    console.log("e", e);
                    setproductTypeID(e.id);
                    setProductType(e.label);
                    onProductTypeChange(e)
                  }}
                  errorMessage={productTypeError}
                />



                <Input
                  infoText={"The name of the product/service shown while billing. If you want to show the name in another language for customers, you can enter it in that language.Example: Enter “Milk” in English and “दूध” in Hindi – on customer bill, “दूध” will be printed."}
                  tooltipWidth={"400px"}
                  tooltipPosition="right"
                  label="Name"
                  isMandatory={true}
                  type="text"
                  placeholder="Enter product name.."
                  value={productName}
                  onChange={(e) => {
                    setProductName(e.target.value);
                    if (e.target.value.trim() !== "") {
                      setProductNameError("");
                    }
                  }}
                  errorMessage={productNameError}
                />

                <div>
                  <Input
                    isMandatory={true}
                    label="SKU (Stock Keeping Unit)"
                    infoText={"A unique code you create for each product for internal tracking.Helps to quickly search products in your POS.Example: T-shirt Blue Large = SKU: TSH-BLU-L."}
                    tooltipWidth={"300px"}
                    type="text"
                    placeholder="Enter sku.."
                    value={sku}
                    //disabled={(key || selectedProductID) || productAutoGeneratedSKU}
                    disabled={productAutoGeneratedSKU}
                    onChange={(e) => {
                      setSku(e.target.value);
                      if (e.target.value.trim() !== "") {
                        setSkuError("");
                      }
                    }}
                    errorMessage={skuError}
                  />
                </div>

                <div>
                  <Input
                    isMandatory={false}
                    label="Barcode (EAN, ISBN, UPC, GTIN, etc.)"
                    infoText={<div>
                      <h2>Enter or scan the product’s barcode</h2>
                      <p>
                        Enter or scan the product’s barcode (e.g., printed code on groceries, books, clothes).
                        This helps in fast billing and accurate stock tracking.
                      </p>

                      <h3>Types of Barcodes</h3>
                      <div>
                        <strong>EAN / UPC</strong> → Common barcodes on most retail products worldwide (like groceries, packaged foods, clothes).
                      </div>
                      <div>
                        <strong>ISBN</strong> → Barcode for books.
                      </div>
                      <div>
                        <strong>GTIN</strong> → Global Trade Item Number – another format for international products.
                      </div>
                    </div>
                    }
                    tooltipWidth={"400px"}
                    removeBtnOnclick={isGc && !key ? handleRemoveClick : false}
                    type="text"
                    placeholder="Enter barcode.."
                    value={barcode}
                    endtext={"Global Catalogue"}
                    onEnter={() => { console.log("enter"), setCatalogueSearchDrawer(true); }}
                    handleEndtextOnclick={() => { console.log("click"), setCatalogueSearchDrawer(true); }}
                    onChange={(e) => {
                      setBarcode(e.target.value);
                      if (e.target.value.trim() !== "") {
                        setBarcodeError("");
                      }
                    }}
                    // disabled={isGc}
                    errorMessage={barcodeError}
                  />
                </div>

                {catalogueSearchDrawer && (
                  <Cataloguesearchdrawer
                    barcode={barcode}
                    setDrawer={setCatalogueSearchDrawer}
                    globalCatalogueData={fetchGlobalCatalogueObject}
                  />
                )}

                {/* {psin && (
                  <div>
                    <Input
                      label="PSIN"
                      type="text"
                      placeholder="Enter psin.."
                      value={psin}
                      onChange={(e) => setPsin(e.target.value)}
                      disabled={true}
                    />
                  </div>
                )}

                {isPincode && customFeild2 === "GC" && (!customFeild4 || (!key && !selectedProductID)) && (
                  <>
                    <div>
                      <Select
                        label={"Catalogue Issue"}
                        options={[
                          { label: "Wrong grammage/weight/volume ", value: "Wrong grammage/weight/volume " },
                          { label: "Wrong Product", value: "Wrong Product" },
                          { label: "Offer Pack/Combo", value: "Offer Pack/Combo" },
                          { label: "Wrong Variant", value: "Wrong Variant" },
                        ]}
                        onChange={(e) => { setCustomField4(e.target.value) }}
                        value={customFeild4}
                        disabled={key || selectedProductID}
                      />
                    </div>

                    <div>
                      <Input
                        value={customFeild5}
                        label="Catalogue Issue Remarks"
                        type="text"
                        placeholder="Enter catalogue issue remarks..."
                        onChange={(e) => setCustomField5(e.target.value)}
                        disabled={key || selectedProductID}
                      />
                    </div>
                  </>
                )} */}



                {/* {!isGc && ( */}
                {(
                  <>
                    <div>
                      <Autocompletesearch
                        isMandatory={true}
                        infoText={"The main group under which the product belongs.Example: “Clothing”, “Groceries”, “Electronics”."}
                        tooltipWidth={"500px"}
                        tooltipPosition="right"
                        value={categoryName}
                        label="Category"
                        data={categoryData}
                        filterKey={["Name"]}
                        defaultDataCount={500}
                        onChange={(value) => {
                          if (value !== "") {
                            setCategoryError("");
                          }
                          console.log("Category input changed:", value);
                          setCategoryName("");
                          setCategoryId("");
                          setfilteredsubcategorydata([]);
                        }}
                        onSelect={(item) => {
                          console.log("Category selected:", item);
                          setCategoryName(item.Name);
                          setCategoryId(item.key);
                          setfilteredsubcategorydata(
                            allSubCategoryData.filter(
                              (category) =>
                                category.ParentID && category.ParentID.toLowerCase() === item.key.toLowerCase()
                            )
                          );
                        }}
                        placeholder="Search Category"
                        showsearch={false}
                        Addbutntext="Add Category"
                        Addbuttonclick={() => setAddCategoryComp(true)}
                        renderSuggestion={(item, index) => (
                          <div>
                            <p className="">{item.Name}</p>
                          </div>
                        )}
                        errorMessage={categoryError}
                      />
                    </div>

                    {addCategoryComp && <AddCategory closeDrawer={setAddCategoryComp} onSave={(data) => { console.log("category data adeed", data), setCategoryId(data.categoryID), setCategoryName(data.Name) }} />}

                    <div>
                      <Autocompletesearch
                        infoText={"A smaller group inside the main category.Example: Under “Clothing” → “Men’s Shirts” or “Women’s Kurtis”."}
                        tooltipWidth={"400px"}
                        value={subCategoryName}
                        label="Sub Category"
                        data={filteredsubcategorydata}
                        filterKey={["Name"]}
                        defaultDataCount={500}
                        onChange={(value) => console.log("sub category input changed:", value)}
                        onSelect={(item) => {
                          console.log("subcategory selected:", item);
                          setSubCategoryId(item.key);
                          setSubCategoryName(item.Name);
                        }}
                        placeholder="Search sub category"
                        showsearch={false}
                        Addbutntext="Add Sub Category"
                        Addbuttonclick={() => setOpenSubCategory(true)}
                        renderSuggestion={(item, index) => (
                          <div>
                            <p className="">{item.Name}</p>
                          </div>
                        )}
                      />
                    </div>

                    {openSubCategory && (
                      <AddSubCategory
                        categoryID={categoryId}
                        categoryName={categoryName}
                        closeDrawer={setOpenSubCategory}
                        onSave={(data) => {
                          console.log("sub category data added", data);
                          setSubCategoryId(data.categoryID);
                          setSubCategoryName(data.Name);
                        }}
                      />
                    )}

                    <div>
                      <Autocompletesearch
                        infoText={"The brand name of the product.Example: Nike, Samsung, Nestle, Tata."}
                        tooltipWidth={"300px"}
                        tooltipPosition="right"
                        value={brandName}
                        label="Brand"
                        data={brandData}
                        filterKey={["Brand"]}
                        defaultDataCount={500}
                        onChange={(value) => console.log("brand input changed:", value)}
                        onSelect={(item) => {
                          console.log("Brand selected:", item);
                          setBrandName(item.Brand);
                          setBrandId(item.key);
                        }}
                        placeholder="Search Brand"
                        showsearch={false}
                        Addbutntext="Add Brand"
                        Addbuttonclick={() => setOpenAddBrand(true)}
                        renderSuggestion={(item, index) => (
                          <div>
                            <p className="">{item.Brand}</p>
                          </div>
                        )}
                      />
                    </div>

                    {openAddBrand && <AddBrand closeDrawer={setOpenAddBrand} onSave={(data) => { console.log("brand data adeed ", data.brand), setBrandId(data.brandID), setBrandName(data.Brand) }} />}
                  </>
                )}

                {/* {(isPincode && isGc) && (
                  <>
                    <div>
                      <Input
                        isMandatory={true}
                        infoText={"The main group under which the product belongs.Example: “Clothing”, “Groceries”, “Electronics”."}
                        tooltipWidth={"500px"}
                        tooltipPosition="right"
                        label="Category"
                        type="text"
                        placeholder="Enter category.."
                        value={categoryName}
                        onChange={(e) => setCategoryName(e.target.value)}
                        disabled={true}
                      />
                    </div>

                    <div>
                      <Input
                        infoText={"A smaller group inside the main category.Example: Under “Clothing” → “Men’s Shirts” or “Women’s Kurtis”."}
                        tooltipWidth={"400px"}
                        label="Sub Category"
                        type="text"
                        placeholder="Enter sub category.."
                        value={subCategoryName}
                        onChange={(e) => setSubCategoryName(e.target.value)}
                        disabled={true}
                      />
                    </div>

                    <div>
                      <Input
                        infoText={"The brand name of the product.Example: Nike, Samsung, Nestle, Tata."}
                        tooltipWidth={"300px"}
                        tooltipPosition="right"
                        label="Brand"
                        type="text"
                        placeholder="Enter Brand.."
                        value={brandName}
                        onChange={(e) => setBrandName(e.target.value)}
                        disabled={true}
                      />
                    </div>
                  </>
                )} */}

                {productTypeID == 3 &&
                  <Input
                    label="Service Time"
                    type="number"
                    placeholder="service time"
                    value={serviceDuration}
                    onChange={(e) => {
                      setServiceDuration(e.target.value);

                    }}
                  />

                }
              </div>

              <div>

                <div className="mt-[24px] grid grid-cols-1">

                  <TextArea
                    infoText={"A one-line description shown only on your online store (not needed if you don’t sell online).Example: “Soft cotton t-shirt with round neck.”"}
                    tooltipPosition="right"
                    tooltipWidth={"400px"}
                    label={"Short Description"} value={shortDescription} onChange={(e) => { setShortDescription(e.target.value) }}
                    h="100px"
                    placeholder="Enter Short Description"
                    errorMessage=""
                  />

                </div>
                <div className="mt-[24px] grid grid-cols-1">
                  {(registration?.key == "1hxUQlaTRjhvPlpZdsI9" || registration?.key == "Xj8lWQb4732SZePXyWdg" || registration?.key=="Txbnw2iE4NOS3lzj4gtF") ?

                    <TextArea
                      infoText={"Detailed product information (only for online store).Example: “100% pure cotton t-shirt, available in multiple sizes, machine washable.”"}
                      tooltipPosition="right"
                      tooltipWidth={"400px"}
                      label={"Long Description"} value={longDescription} onChange={(e) => { setLongDescription(e.target.value) }}
                      h="200px"
                      placeholder="Enter Long Description"
                      errorMessage=""
                    />
                    :
                    <QuillEditor
                      tooltipPosition="right"
                      tooltipWidth={"400px"}
                      infoText={"Detailed product information (only for online store).Example: “100% pure cotton t-shirt, available in multiple sizes, machine washable.”"}
                      label={"Long Description"} minHeight="100px" value={longDescription} onChange={(content) => { setLongDescription(content) }} />

                  }

                </div>

              </div>
            </div>
          </PageSection>

          <PageSection showInfoIcon={true} title="Images" tooltipWidth="500px" tooltipPosition={"right"} infoText={"Add up to 4 pictures of your product.Useful for online store display, helps customers recognize the item.Example: Front view, side view, color options."}>
            <div className="grid gap-6 mt-5">
              <div className="grid lg:grid-cols-1 sm:grid-cols-1">
                <div className="flex w-fit items-start">
                  {/* Set the width to fit the content and align items to the start */}
                  <div className="image-preview-container">
                    {/* Show the image upload button if loading is false */}
                    {imgLoading ? (
                      <p>Uploading...</p>
                    ) : (
                      imgArray.length < 4 && (
                        <ImageUpload
                          onImagedelete={() => setImgArray([])} // Clear all images
                          onImageChange={handleImageUpload} // Handle image change/upload
                          isMultiple={true}
                        />
                      )
                    )}
                  </div>

                  {/* Image Previewer in one row */}
                  {imgArray.length > 0 && (
                    <div className="ml-4 mt-2">
                      <div className="flex space-x-4">
                        {/* Display images in a row with spacing */}
                        {imgArray.map((image, index) => (
                          <div
                            key={index}
                            className="relative transition-transform duration-300 ease-in-out hover:scale-110 border border-[#d7d5e2] shadow"
                          >
                            <img
                              src={image}
                              alt="preview"
                              className="h-[200px] w-[200px] object-cover" // Fixed size for preview
                            />
                            <button
                              onClick={() => handleImageDelete(index)}
                              className="cursor-pointer absolute right-1 bottom-1 bg-red-500 text-white rounded-full p-1"
                            >
                              <FaTimes />
                            </button>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </PageSection>



          <PageSection title="Price & Taxes">
            <div className="grid gap-6 mt-5">
              {(!isMobileView() && storeOptions.length > 1) &&
                <div className="grid lg:grid-cols-5 sm:grid-cols-2 gap-3">
                  <CustomSwitch
                    formlabel="Sold at specific stores only"
                    checked={soldAtSpecificStoresOnly}
                    onChange={(checked) => {
                      setSoldAtSpecificStoresOnly(checked);
                      if (checked) setSomeStoresHaveDifferentPricing(false);
                      setStoreSpecificPricesRows([
                        // Keep the store selection but clear other fields in first row
                        {
                          Store: "",
                          StoreID: "",
                          SupplyPrice: 0,
                          MarginAmount: 0,
                          MarginPercentage: 0,
                          MSP: 0,
                          Markup:0,
                          RetailPrice: 0,
                          DiscountPercentage: 0,
                          DiscountAmount: 0,
                          WalletTopUpSameAsRetailPrice: false,
                          WalletTopUpAmount: 0,
                          EditWalletTopUpAmount: false,
                          MRP: 0
                        }]);
                    }}
                    infoText="Please select this option if this product is sold only in specific stores"
                    tooltipPosition="right"
                    tooltipWidth="450px"
                  />
                  {!soldAtSpecificStoresOnly &&
                    <CustomSwitch
                      formlabel="Some stores have different pricing"
                      checked={someStoresHaveDifferentPricing}
                      onChange={(checked) => {
                        setSomeStoresHaveDifferentPricing(checked);
                        if (checked) setSoldAtSpecificStoresOnly(false);
                           setStoreSpecificPricesRows([
                        // Keep the store selection but clear other fields in first row
                        {
                          Store: "",
                          StoreID: "",
                          SupplyPrice: 0,
                          MarginAmount: 0,
                          MarginPercentage: 0,
                          MSP: 0,
                          RetailPrice: 0,
                          DiscountPercentage: 0,
                          DiscountAmount: 0,
                          WalletTopUpSameAsRetailPrice: false,
                          WalletTopUpAmount: 0,
                          Markup:0,
                          EditWalletTopUpAmount: false,
                          MRP: 0
                        }]);
                      }}
                      infoText="Please select this option if product pricing is different at some stores"
                      tooltipPosition="top"
                      tooltipWidth="450px"
                      disabled={soldAtSpecificStoresOnly} // Optional: disable if other switch is on
                    />}
                </div>

              }
              {(!soldAtSpecificStoresOnly && productTypeID !== 4) &&
                <div className="grid lg:grid-cols-5 sm:grid-cols-2 gap-3">
                  <Input
                    infoText={`The price at which you buy the product from your supplier.
(Your cost price / purchase price)`}
                    tooltipPosition="top"
                    tooltipWidth={"200px"}
                    starttext={currencySymbol}
                    label="Supply Price"
                    placeholder=""
                    type="number"
                    value={supplyPrice}
                    onChange={(e) => setSupplyPrice(e.target.value)}
                  />
                  <Input
                    infoText={`The markup percentage applied to your supply price to calculate the retail price.
  Formula: Retail Price = Supply Price × (1 + Margin% / 100)
  Example: If supply price is 50 and margin is 40%, retail price = 50 × 1.4 = 70`}
                    tooltipPosition="top"
                    tooltipWidth={"400px"}
                    label="Margin %"
                    placeholder=""
                    type="number"
                    value={marginPercentage}
                    onChange={(e) => {
                      setMarginPercentage(e.target.value);
                      let response = calculateMargin(e.target.value, supplyPrice, "percentage");
                      console.log("response", response);
                      setRetailPrice(response.retailPrice);
                      // setMrp(response.mrp);
                      setMarginAmount(response.marginAmount);
                    }}
                    disabled={!supplyPrice}
                  />
                  <Input
                    infoText={`The fixed amount added to your supply price to calculate the retail price.
  Formula: Retail Price = Supply Price + Margin Amount
Examples:• Supply: 100, Amount: 50 → Retail: 150 (Margin: 50%)`}
                    tooltipPosition="top"
                    tooltipWidth={"400px"}
                    starttext={currencySymbol}
                    label="Margin Amount"
                    placeholder=""
                    type="number"
                    value={marginAmount}
                    onChange={(e) => {
                      setMarginAmount(e.target.value);
                      let response = calculateMargin(e.target.value, supplyPrice, "amount");
                      setRetailPrice(response.retailPrice);
                      // setMrp(response.mrp);
                      setMarginPercentage(response.marginPercentage);
                    }}
                    disabled={!supplyPrice}
                  />
                  <Input
                    infoText={`The lowest price at which you are willing to sell the product.
(You should not sell below this to avoid losses)`}
                    tooltipPosition="top"
                    tooltipWidth={"300px"}
                    starttext={currencySymbol}
                    label="MSP (Minimum Selling Price)"
                    placeholder=""
                    type="number"
                    value={msp}
                    onChange={(e) => setMsp(e.target.value)}
                  />
                  <Input
                    isMandatory={true}
                    infoText={`The price you normally sell the product to customers (before any discount).
(Your shop’s selling price)`}
                    tooltipPosition="top"
                    tooltipWidth={"300px"}
                    starttext={currencySymbol}
                    label="Retail Price"
                    placeholder=""
                    type="number"
                    value={retailPrice}

                    onChange={(e) => {
                      setRetailPrice(e.target.value);
                      let response = calculateMargin(e.target.value, supplyPrice, "retailPrice");
                      setMarginAmount(response.marginAmount);

                      if (e.target.value && discountPercentage) {
                        const newAmount = calculateDiscountAmount(discountPercentage, e.target.value);
                        setDiscountAmount(newAmount);
                      }
                      else {
                        setDiscountAmount("");
                      }

                      // setMrp(response.mrp);
                      setMarginPercentage(response.marginPercentage);
                      if (e.target.value !== "") {
                        setRetailPriceError("");
                      }
                    }
                    }
                    errorMessage={retailPriceError}
                  />
                  <Input
                    infoText={`The percentage of discount you want to give to the customer.
(Example: 10% off on the product)`}
                    tooltipPosition="left"
                    tooltipWidth={"400px"}
                    label="Discount %"
                    placeholder=""
                    type="number"
                    value={discountPercentage}
                    onChange={(e) => {
                      const newPercentage = e.target.value;
                      setDiscountPercentage(newPercentage);
                      if (retailPrice) {
                        const newAmount = calculateDiscountAmount(newPercentage, retailPrice);
                        setDiscountAmount(newAmount);
                      }
                    }}
                  />
                  <Input
                    infoText={`The actual money value of the discount in rupees.
(Example: ₹100 off on a ₹1000 item)`}
                    tooltipPosition="top"
                    tooltipWidth={"300px"}
                    label="Discount Amount"
                    placeholder=""
                    starttext={currencySymbol}
                    type="number"
                    value={discountAmount}
                    onChange={(e) => {
                      const newAmount = e.target.value;
                      setDiscountAmount(newAmount);
                      if (retailPrice) {
                        const newPercentage = calculateDiscountPercentage(newAmount, retailPrice);
                        setDiscountPercentage(newPercentage);
                      }
                    }}
                  />
                  <Input
                    isMandatory={false}
                    infoText={`The highest price printed on the product by the manufacturer.
(You cannot sell above this price)`}
                    tooltipPosition="left"
                    tooltipWidth={"100px"}
                    label="MRP (Maximum Retail Price)"
                    placeholder=""
                    type="number"
                    starttext={currencySymbol}
                    value={mrp}
                    onChange={(e) => {
                      setMrp(e.target.value)
                      if (e.target.value) {
                        setMrpError("");
                      }
                    }
                    }
                    errorMessage={mrpError}
                  />


                </div>
              }
              {(!soldAtSpecificStoresOnly && productTypeID == 4) &&
                <div className="grid lg:grid-cols-5 sm:grid-cols-2 gap-3">


                  <Input
                    infoText={`The lowest price at which you are willing to sell the product.
(You should not sell below this to avoid losses)`}
                    tooltipPosition="top"
                    tooltipWidth={"300px"}
                    starttext={currencySymbol}
                    label="MSP (Minimum Selling Price)"
                    placeholder=""
                    type="number"
                    value={msp}
                    onChange={(e) => setMsp(e.target.value)}
                  />
                  <Input
                    isMandatory={true}
                    infoText={`The price you normally sell the product to customers (before any discount).
(Your shop’s selling price)`}
                    tooltipPosition="top"
                    tooltipWidth={"300px"}
                    starttext={currencySymbol}
                    label="Retail Price"
                    placeholder=""
                    type="number"
                    value={retailPrice}
                    onChange={(e) => {
                      setRetailPrice(e.target.value);
                      if (e.target.value !== "") {
                        setRetailPriceError("");
                      }
                    }
                    }
                    errorMessage={retailPriceError}
                  />

                  <CustomSwitch
                    formlabel="Wallet recharge amount same as retail price"
                    checked={walletTopUpSameAsRetailPrice}
                    onChange={(checked) => {
                      setWalletTopUpSameAsRetailPrice(checked);

                    }}
                  />
                  {!walletTopUpSameAsRetailPrice && <Input
                    label="Wallet Recharge Amount"
                    placeholder=""
                    type="number"
                    value={walletTopUpAmount}
                    onChange={(e) => {
                      setWalletTopUpAmount(e.target.value)
                      setWalletTopUpError("");

                    }
                    }
                    errorMessage={walletTopUpError}
                  />}
                  {!walletTopUpSameAsRetailPrice && <CustomSwitch
                    formlabel="Allow user to specify recharge amount at time of billing"
                    checked={editWalletTopUpAmount}
                    onChange={(checked) => {
                      setEditWalletTopUpAmount(checked);

                    }}
                  />}

                </div>
              }
              {(soldAtSpecificStoresOnly || someStoresHaveDifferentPricing) &&
                <div>
                  <div className="mx-auto">
                    <table className="w-full rounded-md">
                      <thead className="bg-[#f9f9fb] h-[50px] border-y-[1px] border-[#ddd] text-gray-500">
                        <tr>
                          <th className="p-2 text-left">Store</th>
                          {productTypeID !== 4 && <th className="p-2 text-left">Supply Price</th>}
                          {productTypeID !== 4 && <th className="p-2 text-left">Margin %</th>}
                          {productTypeID !== 4 && <th className="p-2 text-left">Margin Amount</th>}
                          {productTypeID !== 4 && <th className="p-2 text-left">MSP</th>}
                          <th className="p-2 text-left">Retail Price</th>
                          {productTypeID !== 4 && <th className="p-2 text-left">Disc %</th>}
                          {productTypeID !== 4 && <th className="p-2 text-left">Disc Amt</th>}
                          {productTypeID === 4 && <th className="p-2 text-left">Wallet recharge amount same as retail price</th>}
                          {productTypeID === 4 && <th className="p-2 text-left">Wallet Recharge Amount</th>}
                          {productTypeID === 4 && <th className="p-2 text-left">Allow user to specify recharge amount at time of billing</th>}
                          {productTypeID !== 4 && <th className="p-2 text-left">MRP</th>}
                          <th className="p-2 text-left"></th>
                        </tr>
                      </thead>
                      <tbody>
                        {storeSpecificPricesRows.map((row, index) => (
                          <tr key={index} className='h-[50px] hover:bg-gray-100 border-t border-[#ddd]'>
                            <td className="p-2">
                              {index === 0 ? (
                                <Select
                                  fetchAllObject={true}
                                  placeholder="Select Store"
                                  options={storeOptions.filter(
                                    option => !storeSpecificPricesRows.some(
                                      (row, idx) => idx !== 0 && row.StoreID === option.value
                                    )
                                  )}
                                  value={row.StoreID}
                                  onChange={(e) => {
                                    handleStoreRowChange(index, 'storeSelection', e);
                                    setStoreError("");
                                  }}
                                  errorMessage={storeError}
                                />
                              ) : (
                                <div>
                                  <label>{row.Store}</label>
                                </div>
                              )}
                            </td>


                            {productTypeID !== 4 && (
                              <td className="p-2">
                                <Input
                                  placeholder="Enter Supply Price"
                                  type="number"
                                  starttext={currencySymbol}
                                  value={row.SupplyPrice}
                                  onChange={(e) => handleStoreRowChange(index, 'SupplyPrice', e.target.value)}
                                />
                              </td>
                            )}


                            {productTypeID !== 4 && (
                              <td className="p-2">
                                <Input
                                  placeholder=""
                                  type="number"
                                  value={row.MarginPercentage}
                                  onChange={(e) => {
                                    handleStoreRowChange(index, 'MarginPercentage', e.target.value)
                                    let response = calculateMargin(e.target.value, row.SupplyPrice, "percentage");
                                    console.log("response", response);
                                    handleStoreRowChange(index, 'RetailPrice', response.retailPrice)
                                    handleStoreRowChange(index, 'MarginAmount', response.marginAmount)
                                  }}
                                />
                              </td>
                            )}
                            {productTypeID !== 4 && (
                              <td className="p-2">
                                <Input
                                  placeholder=""
                                  type="number"
                                  value={row.MarginAmount}
                                  onChange={(e) => {
                                    handleStoreRowChange(index, 'MarginAmount', e.target.value)
                                    let response = calculateMargin(e.target.value, row.SupplyPrice, "amount");
                                    console.log("response", response);
                                    handleStoreRowChange(index, 'RetailPrice', response.retailPrice)
                                    handleStoreRowChange(index, 'MarginPercentage', response.marginPercentage)
                                  }}
                                />
                              </td>
                            )}
                            {productTypeID !== 4 && (
                              <td className="p-2">
                                <Input
                                  placeholder="Enter MSP"
                                  type="number"
                                  starttext={currencySymbol}
                                  value={row.MSP}
                                  onChange={(e) => handleStoreRowChange(index, 'MSP', e.target.value)}
                                />
                              </td>
                            )}

                            <td className="p-2">
                              <Input
                                placeholder="Enter Retail Price"
                                type="number"
                                starttext={currencySymbol}
                                value={row.RetailPrice}

                                onChange={(e) => {
                                  handleStoreRowChange(index, 'RetailPrice', e.target.value);
                                  let response = calculateMargin(e.target.value, row.SupplyPrice, "retailPrice");
                                  handleStoreRowChange(index, 'MarginAmount', response.marginAmount);
                                  handleStoreRowChange(index, 'MarginPercentage', response.marginPercentage);
                                  setRetailPriceErrorUnderSpecificStore("");
                                }}
                                errorMessage={index === 0 ? retailPriceErrorUnderSpecificStore : ""}
                              />
                            </td>

                            {productTypeID !== 4 && (
                              <td className="p-2">
                                <Input
                                  placeholder="Enter Disc %"
                                  type="number"
                                  value={row.DiscountPercentage}
                                  onChange={(e) => handleStoreRowChange(index, 'DiscountPercentage', e.target.value)}
                                />
                              </td>
                            )}

                            {productTypeID !== 4 && (
                              <td className="p-2">
                                <Input
                                  placeholder="Enter Disc Amt"
                                  type="number"
                                  starttext={currencySymbol}
                                  value={row.DiscountAmount}
                                  onChange={(e) => handleStoreRowChange(index, 'DiscountAmount', e.target.value)}
                                />
                              </td>
                            )}

                            {productTypeID === 4 && (
                              <td className="p-2">
                                <CustomSwitch
                                  checked={row.WalletTopUpSameAsRetailPrice}
                                  onChange={(checked) => {
                                    handleStoreRowChange(index, 'WalletTopUpSameAsRetailPrice', checked)
                                  }}
                                />
                              </td>
                            )}

                            {productTypeID === 4 && (row.WalletTopUpSameAsRetailPrice ? (
                              <td className="p-2">
                                <Input
                                  type="number"
                                  starttext={currencySymbol}
                                  value={row.WalletTopUpAmount}
                                  onChange={(e) => handleStoreRowChange(index, 'WalletTopUpAmount', e.target.value)}
                                />
                              </td>
                            ) : <td className="p-2"></td>)}

                            {productTypeID === 4 && (row.WalletTopUpSameAsRetailPrice ? (
                              <td className="p-2">
                                <CustomSwitch
                                  checked={row.EditWalletTopUpAmount}
                                  onChange={(checked) => {
                                    handleStoreRowChange(index, 'EditWalletTopUpAmount', checked)
                                  }}
                                />
                              </td>
                            ) : <td className="p-2"></td>)}

                            {productTypeID !== 4 && (
                              <td className="p-2">
                                <Input
                                  placeholder="Enter MRP"
                                  type="number"
                                  starttext={currencySymbol}
                                  value={row.MRP}
                                  onChange={(e) => {
                                    handleStoreRowChange(index, 'MRP', e.target.value);
                                  }}
                                />
                              </td>
                            )}

                            <td className="p-2">
                              {index === 0 ? (
                                <Button
                                  type="primary"
                                  px='px-4'
                                  onClick={addStoreSpecificPriceRow}
                                  disabled={!storeSpecificPricesRows[0].StoreID}
                                >
                                  <span className="w-5"><Icon type="add" /></span> Add
                                </Button>
                              ) : (
                                <div className="p-2">
                                  <Button
                                    type="secondary"
                                    px='px-4'
                                    onClick={() => removeStoreSpecificPriceRow(index)}
                                  >
                                    <span className="w-5"><Icon type="remove" /></span> Remove
                                  </Button>
                                </div>
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              }
              <div className="grid lg:grid-cols-6 sm:grid-cols-2 gap-3">
                <CustomSwitch
                  infoText={"Enable taxes if the product is taxable.This means you should turn on the tax option whenever the product attracts GST/VAT or any applicable tax.Example:If you are selling a mobile phone, taxes apply → ✅ Enable Taxes.If you are giving a free carry bag, no tax applies → ❌ Do not enable Taxes."}
                  tooltipWidth={"500px"}
                  tooltipPosition="right"
                  formlabel="Charge taxes on this product"
                  checked={chargeTaxesonthisProduct}
                  onChange={(checked) => setChargeTaxesonthisProduct(checked)}
                />
                {chargeTaxesonthisProduct && (
                  <>

                    <CustomSwitch
                      infoText={"If enabled, tax will be calculated on the *Retail Price (the price you sell to customers)* instead of the supply price. Example:  Retail Price: ₹100  Tax: 18%  Bill shows ₹100 + 18% = ₹118."}
                      tooltipWidth={"500px"}
                      formlabel="Tax based on retail price"
                      checked={taxBaseOnRetailPrice}
                      onChange={(checked) => setTaxBaseOnRetailPrice(checked)}
                    />
                    <CustomSwitch
                      infoText={"Use this if your selling price already includes tax. Example: MRP on packet: ₹118 (which already has 18% GST included).POS will automatically split it as ₹100 (price) + ₹18 (tax). Customer still sees ₹118 only."}
                      tooltipWidth={"500px"}
                      formlabel="Tax inclusive (Sales)"
                      checked={taxInclusiveSales}
                      onChange={(checked) => setTaxInclusiveSales(checked)}
                    />
                    <CustomSwitch
                      infoText={"Use this when the price from your supplier already includes tax.Example: You buy an item at ₹118 from supplier (inclusive of 18% GST).POS will record it as base price ₹100 + tax ₹18."}
                      tooltipWidth={"500px"}
                      formlabel="Tax inclusive (Purchase)"
                      checked={taxInclusivePurchase}
                      onChange={(checked) => setTaxInclusivePurchase(checked)}
                    />
                  </>
                )}
              </div>

              <div className="grid lg:grid-cols-4 sm:grid-cols-2 gap-3">

                {chargeTaxesonthisProduct && (
                  <>
                    <div>
                      <Input
                        infoText={"used for Goods.SAC (Service Accounting Code) → used for Services.These are official codes required for GST compliance. Example:HSN for rice: 1006 HSN for cosmetics: 3304 SAC for salon services: 9997"}
                        tooltipWidth={"500px"}
                        tooltipPosition="right"
                        label="HSN (Harmonized System of Nomenclature)" type="text" placeholder="Enter HSN/SAC Code.." value={hsnSacCode} onChange={(e) => { setHsnSacCode(e.target.value) }} errorMessage="" />
                      <div className="text-sm text-blue-700  hover:text-blue-400 cursor-pointer" onClick={() => window.open("https://services.gst.gov.in/services/searchhsnsac", "_blank")}>HSN Code Finder (Government GST Portal)</div>
                      <div className="text-sm text-blue-700 hover:text-blue-400 cursor-pointer" onClick={() => window.open("https://cleartax.in/s/gst-hsn-lookup", "_blank")}>ClearTax HSN/SAC Code List</div>
                    </div>
                    {!taxBaseOnRetailPrice &&
                      // <Select
                      //   fetchAllObject={true}
                      //   label={"Tax"}
                      //   placeholder={"select tax"}
                      //   options={taxOption}
                      //   value={taxDropDownLabel}
                      //   onChange={(e) => {

                      //   }}
                      // />

                      <Autocompletesearch
                        value={taxDropDownLabel}
                        defaultDataCount={20}
                        infoText={"Select the tax rate to apply.In India, most common GST rates are: 0%, 5%, 12%, 18%, 28%.If you are outside India, you can create your own tax percentage as per your country’s rules (like VAT, Sales Tax, etc.)."}
                        tooltipPosition="right"
                        tooltipWidth={"500px"}
                        label="Tax"
                        data={taxOption}
                        filterKey={["label"]}
                        onChange={(value) => console.log("type input changed:", value)}
                        onSelect={(e) => {
                          setTaxDropDownValue(e.value);
                          setTaxDropDownLabel(e.label);
                          setTaxDropDownLabel(e.label);
                          console.log("taxDropDownValue", e.value);
                        }}
                        placeholder="search or select tax"
                        showsearch={false}
                        renderSuggestion={(item) => (
                          <div>
                            <p className="">{item.label}</p>
                          </div>
                        )}
                      />
                    }


                  </>
                )}
              </div>

              {taxBaseOnRetailPrice &&

                <div className="grid gap-4">
                  {taxOnRetailPriceRows.map((row, index) => (
                    <div key={index}>
                      <div className="grid lg:grid-cols-6 sm:grid-cols-1 gap-4">
                        {/* Dynamic Input for "Price - From" */}
                        <Input
                          label="Price - From"
                          type="text"
                          placeholder="Enter Price - From"
                          value={row["FromPrice"]}
                          onChange={(e) => handleInputChangeTaxOnRetailPrice(index, "FromPrice", e.target.value)}
                          errorMessage=""
                        />
                        {/* Dynamic Input for "Price - To" */}
                        <Input
                          label="Price - To"
                          type="text"
                          placeholder="Enter Price - To"
                          value={row["ToPrice"]}
                          onChange={(e) => handleInputChangeTaxOnRetailPrice(index, "ToPrice", e.target.value)}
                          errorMessage=""
                        />
                        {/* Dynamic Select for Tax */}
                        {/* <Select
                          fetchAllObject={true}
                          label="Tax"
                          placeholder="select tax"
                          options={taxOption}
                          value={row["TaxID"]}
                          onChange={(e) => { handleInputChangeTaxOnRetailPrice(index, "TaxGroup", e.label), handleInputChangeTaxOnRetailPrice(index, "TaxID", e.value) }}
                        /> */}
                        <Autocompletesearch
                          value={row["TaxGroup"]}
                          defaultDataCount={20}
                          label="Tax"
                          data={taxOption}
                          filterKey={["label"]}
                          onChange={(value) => console.log("type input changed:", value)}
                          onSelect={(e) => {
                            { handleInputChangeTaxOnRetailPrice(index, "TaxGroup", e.label), handleInputChangeTaxOnRetailPrice(index, "TaxID", e.value) }
                          }}
                          placeholder="search or select tax"
                          showsearch={false}
                          renderSuggestion={(item) => (
                            <div>
                              <p className="">{item.label}</p>
                            </div>
                          )}
                        />
                        {/* Add/Remove buttons */}
                        {index === taxOnRetailPriceRows.length - 1 ? (
                          <div className="mt-6 w-[86px]">
                            <Button
                              type="primary"
                              onClick={addRow}
                            >
                              <span className="w-6"><Icon type="add" /></span> Add
                            </Button>
                          </div>
                        ) : (
                          <div className="mt-6 w-[86px]">
                            <Button
                              type="danger"
                              onClick={() => removeRow(index)}
                            >
                              <span className="w-6"><Icon type="remove" /></span> Remove
                            </Button>
                          </div>
                        )}
                      </div>
                    </div>
                  ))}
                </div>


              }




            </div>
          </PageSection>



          {((productTypeID == 1 || productTypeID == 2)) &&
            <PageSection title="Inventory">
              <div className="grid gap-6 mt-5">
                <div className="grid lg:grid-cols-6 sm:grid-cols-2 gap-3">

                  <Select
                    isMandatory={true}
                    disabled={key || selectedProductID}
                    fetchAllObject={true}
                    label={"Type"}
                    tooltipPosition="right"
                    tooltipWidth={"500px"}
                    infoText={renderInfoText(inventoryInfo[inventoryDropDownValue])} // Dynamic tooltip
                    placeholder={"select type"}
                    options={[
                      { value: "FIFO", label: "FIFO" },
                      { value: "Unique No", label: "Unique No" },
                      { value: "Variants", label: "Variants" },
                      { value: "Batch Tracking", label: "Batch Tracking" },

                    ]}

                    value={inventoryDropDownValue}
                    onChange={(e) => {
                      setInventoryDropDownValue(e.value);  // Set the dropdown value
                      resetInventoryFields();
                      console.log("inventory dropdown value", e.value);  // Log the selected value
                    }}
                  />
                  {inventoryDropDownValue == "Unique No" &&
                    <Input
                      infoText={"Enter a Unique Label (like IMEI, Serial Number, or your own code). This helps track individual products for warranty, repairs, and stock accuracy."}
                      tooltipWidth={"500px"}
                      tooltipPosition="top"
                      label="Unique Label"
                      placeholder="Enter unique label"
                      value={uniqueLabel}
                      onChange={(e) => {
                        setUniqueLabel(e.target.value);
                      }}

                    />
                  }
                </div>


                {inventoryDropDownValue == "Batch Tracking" &&
                  <div className="grid lg:grid-cols-6 sm:grid-cols-1 gap-4">
                    <CustomSwitch
                      infoText={"This is the unique number given by the manufacturer or created by you for a group of items.Example: You receive 100 strips of Paracetamol Tablets under Batch No. B1234.It helps track which batch was sold in case of complaints, returns, or recalls."}
                      tooltipPosition="right"
                      tooltipWidth={"500px"}
                      formlabel="Batch No"
                      checked={batchTrackingBatchNoRequired}
                      onChange={(checked) => setBatchTrackingBatchNoRequired(checked)}
                    />
                    <CustomSwitch
                      infoText={"This is the selling price printed on the product pack by the manufacturer.Example: A shampoo bottle with an MRP of ₹199.Adding MRP ensures correct billing as per printed price."}
                      tooltipPosition="right"
                      tooltipWidth={"500px"}
                      formlabel="MRP (Maximum Retail Price)"
                      checked={batchTrackingMRPRequired}
                      onChange={(checked) => setBatchTrackingMRPRequired(checked)}
                    />
                    <CustomSwitch
                      formlabel="Manufacturing Date (Mfg Date)"
                      infoText={"The date when the product was made or packed.Example: A biscuit packet manufactured in June 2023.Useful for stock rotation (sell older stock first – “FIFO” method)."}
                      tooltipPosition="top"
                      tooltipWidth={"500px"}
                      checked={batchTrackingMfgDateRequired}
                      onChange={(checked) => {
                        setBatchTrackingMfgDateRequired(checked);
                        if (checked) {
                          setBatchTrackingDateFormat("mm/yy");
                        } else {
                          setBatchTrackingDateFormat("");
                        }
                      }}
                    />

                    <CustomSwitch
                      formlabel="Exp Date"
                      infoText={"The last date the product can be sold or used safely.Example: A medicine expiring in May 2025.Helps the shopkeeper avoid selling expired products and manage stock clearance on time."}
                      tooltipPosition="top"
                      tooltipWidth={"500px"}
                      checked={batchTrackingExpDateRequired}
                      onChange={(checked) => {
                        setBatchTrackingExpDateRequired(checked);
                        if (checked) {
                          setBatchTrackingDateFormat("mm/yy");
                        } else {
                          setBatchTrackingDateFormat("");
                        }
                      }}
                    />

                  </div>

                }
                {(batchTrackingMfgDateRequired || batchTrackingExpDateRequired) &&
                  <div className="grid lg:grid-cols-6 sm:grid-cols-1 gap-4">
                    <Select
                      infoText={
                        <>
                          <p>You can choose your preferred date format.This will be used wherever dates are shown, such as Manufacturing Date (MFG Date) or Expiry Date (EXP Date).</p>
                          <ul>
                            <li><b>dd</b> → Day (e.g., 01, 15, 28)</li>
                            <li><b>mm</b> → Month in numbers (e.g., 02 = Feb, 05 = May)</li>
                            <li><b>mmm</b> → Month in short text (e.g., Jan, Feb, Sep)</li>
                            <li><b>yy</b> → Year in 2 digits (e.g., 25 = 2025, 26 = 2026)</li>
                            <li><b>yyyy</b> → Year in 4 digits (e.g., 2025, 2026)</li>
                          </ul>

                          <p><b>Examples:</b></p>
                          <ul>
                            <li><b>mm/yy</b> → 02/25 (Feb 2025)</li>
                            <li><b>mmm/yy</b> → Feb/25</li>
                            <li><b>mmm/yyyy</b> → Feb/2025</li>
                            <li><b>dd/mm/yy</b> → 15/02/25</li>
                            <li><b>dd/mmm/yy</b> → 15/Feb/25</li>
                            <li><b>mm-yy</b> → 02-25</li>
                            <li><b>mmm-yy</b> → Feb-25</li>
                            <li><b>mmm-yyyy</b> → Feb-2025</li>
                            <li><b>dd-mm-yy</b> → 15-02-25</li>
                            <li><b>dd-mmm-yyyy</b> → 15-Feb-2025</li>
                          </ul>
                        </>
                      }

                      tooltipPosition="right"
                      tooltipWidth={"500px"}
                      fetchAllObject={true}
                      label={"Date Format"}
                      placeholder=""
                      options={[
                        { value: "mm/yy", label: "mm/yy" },
                        { value: "mmm/yy", label: "mmm/yy" },
                        { value: "mmm/yyyy", label: "mmm/yyyy" },
                        { value: "dd/mm/yy", label: "dd/mm/yy" },
                        { value: "dd/mmm/yy", label: "dd/mmm/yy" },
                        { value: "mm-yy", label: "mm-yy" },
                        { value: "mmm-yy", label: "mmm-yy" },
                        { value: "mmm-yyyy", label: "mmm-yyyy" },
                        { value: "dd-mm-yy", label: "dd-mm-yy" },
                        { value: "dd-mmm-yyyy", label: "dd-mmm-yyyy" }
                      ]}
                      value={batchTrackingDateFormat}
                      onChange={(e) => {
                        setBatchTrackingDateFormat(e.value);  // Set the dropdown value
                      }}

                    />
                  </div>}



                {inventoryDropDownValue == "Variants" &&
                  <div className="grid gap-3 ">
                    {(!selectedProductID && !key) && <div className="grid lg:grid-cols-2 sm:grid-cols-1 space-x-6">
                      <div className="flex items-center space-x-4 grid lg:grid-cols-2 sm:grid-cols-1">
                        <div>
                          <Input
                            label="Define Attribute"
                            placeholder="Enter Attribute"
                            type="text"
                            value={defineAttribute}
                            onChange={(e) => {
                              setDefineAttribute(e.target.value);
                              if (e.target.value.trim() !== "") {
                                setDefineAttributeError("");
                              }
                            }}
                            errorMessage={defineAttributeError}
                            infoText={"choose up to three variable attributes for this product to create and manage SKUs and thier inventory levels"}
                            tooltipPosition="right"
                            tooltipWidth={"700px"}
                          />
                        </div>
                        <div className="mt-auto">
                          <Button type="primary" iconType={"add"} onClick={handleAddAttributeBtnClick} >
                            Add Attribute
                          </Button>
                        </div>
                      </div>
                    </div>}
                    {(addAttributeRow.length > 0) &&
                      <div>
                        <div className="mx-auto">
                          <table className=" table-auto w-full rounded-md" >
                            <thead className="bg-[#f9f9fb] h-[50px] border-y-[1px] border-[#ddd] text-gray-500 ">
                              <tr>
                                <th className="p-2 text-left">Attribute</th>
                                <th className="p-2 text-left">Values</th>
                                <th className="p-2 text-left">Actions</th>
                              </tr>
                            </thead>
                            <tbody>
                              {addAttributeRow.map((row, index) => (
                                <tr key={index} className="h-[50px] hover:bg-gray-100 border-t border-[#ddd]">
                                  <td className="p-2 w-[100px]">
                                    <label className="mb-1  text-[#000000]">{row.attribute}</label>
                                  </td>
                                  <td className="p-2 w-60">
                                    <div>
                                      <MultiAutocomplete
                                        hideRemoveIcon={(key || selectedProductID) ? true : false}
                                        label="	Values"
                                        placeholder="Add values"
                                        value={row.values}
                                        onChange={(event, newValue, action) => handleAutocompleteChange(event, newValue, action, index)}
                                      />
                                    </div>
                                  </td>
                                  <td className="p-2 w-20">
                                    {(!key && !selectedProductID) && <div className="flex items-center  w-full">
                                      <span className="w-[100px]">
                                        <Button type="secondary" px="px-2" onClick={() => handleRemoveAttributeRow(index)}>
                                          <span className="w-6"><Icon type="remove" /></span> Remove
                                        </Button>
                                      </span>
                                    </div>}
                                  </td>


                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>}
                    {addAttributeRow.length > 0 &&

                      <div>
                        <CustomSwitch
                          formlabel="Automatically Generate SKU"
                          checked={autoGenerateSKU}
                          onChange={(checked) => setAutoGenerateSKU(checked)}
                          disabled={key || selectedProductID}
                        />
                        <div className="mx-auto">
                          <table className=" table-auto w-full rounded-md" >
                            <thead className="bg-[#f9f9fb] h-[50px] border-y-[1px] border-[#ddd] text-gray-500 ">
                              <tr>
                                <th className="p-2 text-left">Variant Name</th>
                                <th className="p-2 text-left">SKU</th>
                                <th className="p-2 text-left">Supply Price</th>
                                <th className="p-2 text-left">Margin %</th>
                                <th className="p-2 text-left">Margin Amount</th>
                                <th className="p-2 text-left">MSP</th>
                                <th className="p-2 text-left">Retail Price</th>
                                <th className="p-2 text-left">Discount Amount</th>
                                <th className="p-2 text-left">Discount %</th>
                                <th className="p-2 text-left">MRP</th>

                                <th className="p-2 text-left">Action</th>
                              </tr>
                            </thead>
                            <tbody>

                              {addVariantRow.filter(row => row.isDeleted == false).map((row, index) => (
                                <tr key={index} className="h-[50px] hover:bg-gray-100 border-t border-[#ddd]">
                                  <td className="p-2 ">
                                    <label className="mb-1  text-[#000000]">{row.attribute}</label>
                                  </td>
                                  <td className="p-2">
                                    <div>
                                      {((key || selectedProductID) && row.productID) ? (
                                        <>
                                          <div>{row.sku}</div>
                                          <div>Product id: {row.productID}</div>
                                          {row.skuError !== "" && <div className="text-red-600 text-sm mt-1">
                                            {row.skuError}
                                          </div>}
                                        </>
                                      ) : autoGenerateSKU ? (
                                        null
                                      ) : (
                                        <Input
                                          placeholder=""
                                          type="text"
                                          value={row.sku}
                                          onChange={(e) => handleSkuChange(e, index)}
                                          errorMessage={row.skuError}
                                        />
                                      )}
                                    </div>
                                  </td>
                                  {/* Render inputs dynamically for each field */}
                                  {['supplyPrice', 'marginPercentage', 'marginAmount', 'msp', 'retailPrice', 'discountAmount', 'discountPercentage', 'mrp'].map((field, idx) => (
                                    <td key={idx} className="p-2 ">
                                      <div>
                                        <Input
                                          placeholder=""
                                          type="number"
                                          value={row[field]}
                                          onChange={(e) => handleVariantInputChange(e, field, index)}
                                        />
                                      </div>
                                    </td>
                                  ))}

                                  {/* Remove button */}
                                  <td className="p-2">
                                    <div className="flex items-center justify-center w-full">
                                      <Button type="secondary" px="px-2" onClick={() => handleRemoveVariantRow(index)}>
                                        <span className="w-6"><Icon type="remove" /></span> Remove
                                      </Button>
                                    </div>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    }



                  </div>
                }
                {/* {inventoryDropDownValue &&
                  <div className="grid lg:grid-cols-2 sm:grid-cols-2 gap-3">
                    <div>
                      <div className="mx-auto">
                        <table className="w-full rounded-md">
                          <thead className="bg-[#f9f9fb] h-[50px] border-y-[1px] border-[#ddd] text-gray-500">
                            <tr>
                              <th className="p-2 text-left">Store</th>
                              <th className="p-2 text-left">Min Qty</th>
                              <th className="p-2 text-left">Max Qty</th>
                              <th className="p-2 text-left">Reorder Qty</th>
                              {(((!key || !selectedProductID) && inventoryDropDownValue == "FIFO") && !isPincode) &&

                                <th className="p-2 text-left">InStock Qty</th>
                              }
                              {isPincode && (
                                <>
                                  <th className="p-2 text-left">Average Daily Sales</th>
                                  <th className="p-2 text-left">MOQ</th>
                                </>
                              )}
                            </tr>
                          </thead>
                          <tbody>
                            {storeQtys.map((row, index) => (
                              <tr key={index} className="hover:bg-gray-100 border-t border-[#ddd]">
                                <td className="p-2 py-4">
                                  <label>{row.StoreName}</label>
                                </td>
                                <td className="p-2 py-4">
                                  <Input
                                    type="number"
                                    value={row.MinQty}
                                    onChange={(e) => handleQtyChange(index, "MinQty", e.target.value)}
                                  />
                                </td>
                                <td className="p-2 py-4">
                                  <Input
                                    type="number"
                                    value={row.MaxQty}
                                    onChange={(e) => handleQtyChange(index, "MaxQty", e.target.value)}
                                  />
                                </td>
                                <td className="p-2 py-4">
                                  <Input
                                    type="number"
                                    value={row.ReorderQty}
                                    onChange={(e) => handleQtyChange(index, "ReorderQty", e.target.value)}
                                  />
                                </td>
                                {(((!key || !selectedProductID) && inventoryDropDownValue == "FIFO") && !isPincode) && <td>
                                  <Input
                                    type="number"
                                    value={row.InStockQty}
                                    onChange={(e) => handleQtyChange(index, "InStockQty", e.target.value)}
                                  />
                                </td>}
                                {isPincode && (
                                  <>
                                    <td className="p-2 py-4">
                                      <Input
                                        type="number"
                                        value={row.AverageDailySales}
                                        onChange={(e) =>
                                          handleQtyChange(index, "AverageDailySales", e.target.value)
                                        }
                                      />
                                    </td>
                                    <td className="p-2 py-4">
                                      <Input
                                        type="number"
                                        value={row.MOQ}
                                        onChange={(e) =>
                                          handleQtyChange(index, "MOQ", e.target.value)
                                        }
                                      />
                                    </td>
                                  </>
                                )}
                              </tr>
                            ))}
                          </tbody>
                        </table>

                      </div>
                    </div>
                  </div>} */}


              </div>
            </PageSection>}


          {(productTypeID === 1 || productTypeID === 2) &&
            <PageSection title="Unit Of Measurement" showInfoIcon={true} performParentOnclick={() => { setShowInfoModal(true), setInfoType("ProductUOM") }}>
              <div>
                <div className="grid gap-6 mt-5">
                  {/* Primary UOM Select */}
                  <div className="grid lg:grid-cols-6 sm:grid-cols-2 gap-3">




                    <Autocompletesearch
                      disabled={((key || selectedProductID) && (primaryUomValue && primaryUomLabel))}
                      value={primaryUomLabel}
                      label={"Primary UOM"}
                      data={uomOptionData} // Pass the category options
                      filterKey={["label"]} // Filter by Name and SKU
                      defaultDataCount={50}
                      onChange={(value) => {
                        setPrimaryUomLabel("");;
                        setPrimaryUomValue("");
                      }}
                      onSelect={(item) => {

                        setPrimaryUomLabel(item.label);
                        setPrimaryUomValue(item.value);
                        console.log("Primary uom input changed:", item.value);
                      }}
                      placeholder="Select or search  Primary UOM"
                      showsearch={false}

                      renderSuggestion={(item, index) => (
                        <div>
                          <p className="">{item.label}</p>

                        </div>
                      )}
                      errormessage={primaryUomError}
                    />
                  </div>

                  {/* Secondary UOM Table */}
                  {(primaryUomLabel && primaryUomValue) &&
                    <>
                      <div className="grid lg:grid-cols-2 sm:grid-cols-2 gap-3">
                        <div>
                          <div className="mx-auto">
                            <table
                              className=" w-full rounded-md"
                            >
                              <thead className="bg-[#f9f9fb] h-[50px] border-y-[1px] border-[#ddd] text-gray-500">
                                <tr>
                                  <th className="p-2 text-left">Secondary UOM</th>
                                  <th className="p-2 text-left">Conversion</th>
                                  <th className="p-2 text-left"></th>
                                </tr>
                              </thead>
                              <tbody>
                                {uomTableRows.map((row, index) => (
                                  <tr key={index} className=" hover:bg-gray-100 border-t border-[#ddd] ">
                                    {/* Secondary UOM Column */}
                                    <td className="p-2 py-4">
                                      {index === 0 ? (
                                        <div>


                                          <Autocompletesearch
                                            value={row.secondaryUOM}
                                            data={uomOptionData} // Pass the category options
                                            filterKey={["label"]} // Filter by Name and SKU
                                            defaultDataCount={50}
                                            onChange={(value) => {
                                              if (value !== "") {
                                                setSecondaryUomSelectError("");
                                              }

                                            }}
                                            onSelect={(item) => {

                                              handleSecondaryUOMChange(index, item);

                                              console.log("secondary uom input changed:", item);
                                            }}
                                            placeholder="Select or search  Secondary UOM"
                                            showsearch={false}

                                            renderSuggestion={(item, index) => (
                                              <div>
                                                <p className="">{item.label}</p>

                                              </div>
                                            )}
                                            errormessage={secondaryUomSelectError}
                                          />
                                        </div>
                                      ) : (
                                        <div>
                                          <label>1 {row.secondaryUOM} =</label>
                                        </div>
                                      )}
                                    </td>

                                    {/* Conversion Column */}
                                    <td className="p-2 py-4">
                                      <Input
                                        placeholder="Enter Conversion"
                                        type="text"
                                        value={row.conversion}
                                        onChange={(e) => {
                                          handleConversionChange(index, e);
                                          setConversionErrorMessage(""); // Clear error on change
                                        }}
                                        errorMessage={index === 0 ? conversionErrorMessage : ""}
                                      />
                                      {index !== 0 && row.conversion && (
                                        <div className=" text-gray-500 mt-1">{primaryUomLabel}</div>
                                      )}
                                    </td>

                                    {/* Remove Button Column */}
                                    <td className="p-2 py-4">
                                      {index === 0 ? (
                                        <div className="w-30 ">
                                          <Button type="primary" onClick={handleAddUomRow}>
                                            <span className="w-5">
                                              <Icon type="add" />
                                            </span>{" "}
                                            Add
                                          </Button>
                                        </div>
                                      ) : (
                                        <div className="w-30 ">
                                          <Button type="secondary" onClick={() => handleRemoveUomRow(index)}>
                                            <span className="w-5">
                                              <Icon type="remove" />
                                            </span>{" "}
                                            Remove
                                          </Button>
                                        </div>
                                      )}
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>

                      {/* Default Sales and Purchase UOM */}
                      <div className="grid lg:grid-cols-5 sm:grid-cols-2 gap-3">


                        <Autocompletesearch
                          label={"Default sales UOM"}
                          value={defaultSalesUOMLabel}
                          data={defaultUomOptions}
                          filterKey={["label"]} // Filter by Name and SKU
                          defaultDataCount={50}
                          onChange={(value) => {

                          }}
                          onSelect={(item) => {
                            setDefaultSalesUOMLabel(item.label);
                            setDefaultSalesUOMValue(item.value);
                            console.log("Default sales UOM", item);
                          }}
                          placeholder="select or search Default sales UOM"
                          showsearch={false}

                          renderSuggestion={(item, index) => (
                            <div>
                              <p className="">{item.label}</p>

                            </div>
                          )}
                        />

                        <Autocompletesearch
                          label={"Default purchase UOM"}
                          value={defaultPurchaseUOMLabel}
                          data={defaultUomOptions}
                          filterKey={["label"]} // Filter by Name and SKU
                          defaultDataCount={50}
                          onChange={(value) => {

                          }}
                          onSelect={(item) => {
                            setDefaultPurchaseUOMLabel(item.label);
                            setDefaultPurchaseUOMValue(item.value);
                            console.log("Default perchase UOM", item);
                          }}
                          placeholder="select or search Default purchase UOM"
                          showsearch={false}

                          renderSuggestion={(item, index) => (
                            <div>
                              <p className="">{item.label}</p>

                            </div>
                          )}
                        />
                      </div>
                    </>}
                </div>
              </div>
            </PageSection>}

          {(productTypeID === 5) &&
            <PageSection title="Packages">

              <div className="grid gap-6 mt-5">
                <div className="grid lg:grid-cols-6 sm:grid-cols-2 gap-3">
                  <Input
                    label="Validity in day(s)"
                    placeholder=""
                    type="number"
                    value={validityInDays}
                    onChange={(e) => {
                      setValidityInDays(e.target.value);
                      setValidityInDaysError("");

                    }}
                    errorMessage={validityInDaysError}

                  />
                </div>
                <div className="grid lg:grid-cols-2 sm:grid-cols-2 gap-3">
                  <div>
                    <div className="mx-auto">
                      <table
                        className=" w-full rounded-md"
                      >
                        <thead className="bg-[#f9f9fb] h-[50px] border-y-[1px] border-[#ddd] text-gray-500">
                          <tr>
                            <th className="p-2 text-left">Services</th>
                            <th className="p-2 text-left">Retail Price</th>
                            <th className="p-2 text-left"></th>
                          </tr>
                          <tr>
                            <td className="p-2 text-left">   <Autocompletesearch

                              value={selectedService?.Name}
                              data={services} // Pass the category options
                              filterKey={["Name"]} // Filter by Name and SKU
                              defaultDataCount={50}
                              onChange={(value) => {
                                setSelectedService({});
                                fetchServices(value);
                              }}
                              onSelect={(item) => {
                                setSelectedService(item);
                              }}
                              placeholder="Select or search services"
                              renderSuggestion={(item, index) => (
                                <div>
                                  <p className="">{item.Name}</p>

                                </div>
                              )}
                              errorMessage={packagesServiceError}
                            /></td>
                            <td className="p-2 text-left"></td>
                            <td className="p-2 text-left">  <Button type="primary" iconType={"add"} disabled={!selectedService?.key} onClick={() => {
                              let packageService = {
                                Service: selectedService?.Name,
                                ServiceID: selectedService?.key,
                              };
                              for (let index = 0; index < services.length; index++) {
                                const service = services[index];
                                if (service.key === packageService.ServiceID) {
                                  packageService.RetailPrice = service.RetailPrice;
                                }
                              }
                              let updatedPackageServices = packageServices;
                              updatedPackageServices.push(packageService);
                              setPackageServices(updatedPackageServices);
                              setSelectedService({});
                            }}>

                              Add
                            </Button></td>
                          </tr>
                        </thead>
                        <tbody>
                          {packageServices.map((row, index) => (
                            <tr key={index} className=" hover:bg-gray-100 border-t border-[#ddd] ">
                              {/* Secondary UOM Column */}
                              <td className="p-2 py-4">

                                <div>
                                  <label>{row.Service}</label>
                                </div>

                              </td>
                              <td className="p-2 py-4">

                                <div>
                                  <label>{row.RetailPrice}</label>
                                </div>

                              </td>


                              {/* Remove Button Column */}
                              <td className="p-2 py-4">


                                <Button
                                  type="secondary"
                                  onClick={() => {
                                    setPackageServices(prevServices => {
                                      const newServices = [...prevServices];
                                      newServices.splice(index, 1);
                                      return newServices;
                                    });
                                  }}
                                  iconType="remove"
                                >
                                  Remove
                                </Button>

                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

              </div>

            </PageSection>}

          <PageSection title="Additional Settings">
            <div className="grid gap-6 mt-5">

              {/* 
              <div className="grid lg:grid-cols-5 sm:grid-cols-2 gap-3">
                <CustomSwitch
                  formlabel="Favourite"
                  checked={favourite}
                  onChange={(checked) => setFavourite(checked)}
                />
                <CustomSwitch
                  formlabel="Allow price edit "
                  checked={allowPriceEdit}
                  onChange={(checked) => setAllowPriceEdit(checked)}
                />
                <CustomSwitch
                  formlabel="Discountable "
                  checked={discountable}
                  onChange={(checked) => setDiscountable(checked)}
                />
                <CustomSwitch
                  formlabel="Allow tax change "
                  checked={allowTaxChange}
                  onChange={(checked) => setAllowTaxCharge(checked)}
                />
                <CustomSwitch
                  formlabel="Prompt for qty at the time billing "
                  checked={PromptforQtyattheTimeBilling}
                  onChange={(checked) => setPromptforQtyatthetimeBilling(checked)}
                />
              </div>

              <div className="grid lg:grid-cols-5 sm:grid-cols-2 gap-3">
                <Input
                  label="Sequence"
                  placeholder=""
                  type="number"
                  value={sequenceNo}
                  onChange={(e) => {
                    setSequenceNo(e.target.value);

                  }}

                />
                <CustomSwitch
                  formlabel="Repack/Produce"
                  checked={repackProduce}
                  onChange={(checked) => setRepackProduce(checked)}
                />
                <CustomSwitch
                  formlabel="BOM "
                  checked={bom}
                  onChange={(checked) => setBom(checked)}
                />
                <CustomSwitch
                  formlabel="Can be used as consumable "
                  checked={canbeUsedasConsumable}
                  onChange={(checked) => setCanbeUsedasConsumable(checked)}
                />
                <CustomSwitch
                  formlabel="Show as additional charges in bill print  "
                  checked={showAdditionalChargesonBillPrint}
                  onChange={(checked) => setShowAdditionalChargesonBillPrint(checked)}
                />
                {isPincode &&
                  <>
                    <Input
                      label="Packaging Charges "
                      placeholder=""
                      type="number"
                      value={packagingCharges}
                      onChange={(e) => {
                        setPackagingCharges(e.target.value);

                      }}



                    />
                    <CustomSwitch
                      formlabel="Out of Stock"
                      checked={outOfStock}
                      onChange={(checked) => setOutOfStock(checked)}
                    />

                    <CustomSwitch
                      formlabel="Associate Membership"
                      checked={associateMembership}
                      onChange={(checked) => setAssociateMembership(checked)}
                    />
                    {associateMembership &&
                      <Autocompletesearch
                        label={"Membership"}
                        value={membershipID}
                        data={uomOptionData}
                        filterKey={["label"]} // Filter by Name and SKU
                        defaultDataCount={50}
                        onChange={(value) => {

                        }}
                        onSelect={(item) => {
                          setMembership(item.label);
                          setMembershipID(item.value);
                        }}
                        placeholder="select or search membership"
                        showsearch={false}

                        renderSuggestion={(item, index) => (
                          <div>
                            <p className="">{item.label}</p>

                          </div>
                        )}
                      />

                    }
                  </>
                }
              </div> */}

              <div>
                <div
                  className=" mb-1 ">
                  Sales Option
                </div>
                <div className="grid lg:grid-cols-5 sm:grid-cols-2 gap-3 mt-5">
                  <CustomSwitch
                    infoText="Fast moving product or popular products that can be accessed easily during billing under favourites option"
                    tooltipPosition="right"
                    tooltipWidth={"500px"}
                    formlabel="Favourite"
                    checked={favourite}
                    onChange={(checked) => setFavourite(checked)}
                  />
                  <CustomSwitch
                    infoText={"User will be able to change retail price / selling price at the time of billing"}
                    tooltipPosition="right"
                    tooltipWidth={"500px"}
                    formlabel="Allow price edit "
                    checked={allowPriceEdit}
                    onChange={(checked) => setAllowPriceEdit(checked)}
                  />
                  <CustomSwitch
                    infoText={"Invoice level dicounts, line item level discounts, membership discounts, offer dicounts can be applied on this product at the time of billing.If this opton is not enabled then no discount can be applied on this product."}
                    tooltipPosition="top"
                    tooltipWidth={"500px"}
                    formlabel="Discountable "
                    checked={discountable}
                    onChange={(checked) => setDiscountable(checked)}
                  />
                  <CustomSwitch
                    infoText={"Tax can be changed by the user at the time of billing"}
                    tooltipPosition="top"
                    tooltipWidth={"350px"}
                    formlabel="Allow tax change "
                    checked={allowTaxChange}
                    onChange={(checked) => setAllowTaxCharge(checked)}
                  />
                  <CustomSwitch
                    infoText={"When this product is selected at the time of billing a poup screen with option to change qty will be displayed"}
                    tooltipPosition="left"
                    tooltipWidth={"350px"}
                    formlabel="Prompt for qty at the time billing "
                    checked={PromptforQtyattheTimeBilling}
                    onChange={(checked) => setPromptforQtyatthetimeBilling(checked)}
                  />
                  <span className="">
                    <Input
                      label="Sequence no"
                      placeholder=""
                      type="number"
                      value={sequenceNo}
                      onChange={(e) => {
                        setSequenceNo(e.target.value);

                      }}

                    />
                  </span>
                  {registration.hasOwnProperty("OMNIEnabled") &&
                    <span className="">
                      <Input
                        label="Packaging Charges "
                        placeholder=""
                        type="number"
                        value={packagingCharges}
                        onChange={(e) => {
                          setPackagingCharges(e.target.value);

                        }}
                      />
                    </span>}
                  <CustomSwitch
                    infoText={"Enable Show as additional charges if this is a fee like packing, delivery, or service charge, so it shows separately in the bill."}
                    tooltipPosition="top"
                    tooltipWidth={"500px"}
                    formlabel="Show as additional charges in bill print  "
                    checked={showAdditionalChargesonBillPrint}
                    onChange={(checked) => setShowAdditionalChargesonBillPrint(checked)}
                  />
                  <CustomSwitch
                    infoText={"Enable Associate Membership if this product is a membership/plan that should be linked to the customer profile"}
                    tooltipPosition="top"
                    tooltipWidth={"400px"}
                    formlabel="Associate Membership"
                    checked={associateMembership}
                    onChange={(checked) => setAssociateMembership(checked)}
                  />
                  {associateMembership &&
                    <Autocompletesearch
                      label={"Membership"}
                      value={membership}
                      data={membershipData}
                      filterKey={["Name"]} // Filter by Name and SKU
                      defaultDataCount={50}
                      onChange={(value) => {

                      }}
                      onSelect={(item) => {
                        setMembership(item.Name);
                        setMembershipID(item.key);
                      }}
                      placeholder="select or search membership"
                      showsearch={false}

                      renderSuggestion={(item, index) => (
                        <div>
                          <p className="">{item.Name}</p>

                        </div>
                      )}
                    />

                  }
                </div>

              </div>

              <div>
                <div
                  className="mb-1 ">
                  Inventory Option
                </div>
                <div className="grid lg:grid-cols-5 sm:grid-cols-2 gap-3 mt-5">

                  {(productTypeID == 1 || productTypeID == 2) && <CustomSwitch
                    infoText={"Please select this option if this product is repacked or prodcued by you.E.g, packing loose sugar into packs of 1kg."}
                    tooltipPosition="right"
                    tooltipWidth={"500px"}
                    formlabel="Repack/Produce"
                    checked={repackProduce}
                    onChange={(checked) => setRepackProduce(checked)}
                  />}
                  {(productTypeID !== 4 || productTypeID !== 5) && <CustomSwitch
                    infoText={"Enable bill of materials (BOM) option to specify raw materials required to prepare/service this product. E.g specify ingredients required to prepare pizza or consumables used for facial"}
                    tooltipPosition="right"
                    tooltipWidth={"500px"}
                    formlabel="BOM "
                    checked={bom}
                    onChange={(checked) => setBom(checked)}
                  />}
                  {bom &&
                    <CustomSwitch
                      infoText={"Enable this option if the raw materials used and qty used are know only at the time of billing. E.g color, brand and qty of for hair color tubes may vary from client to client."}
                      tooltipPosition="top"
                      tooltipWidth={"500px"}
                      formlabel="Manually specify product consumption "
                      checked={bomManual}
                      onChange={(checked) => setBomManual(checked)}
                    />}
                  {productTypeID === 1 && <CustomSwitch
                    infoText={"Enable this option if this product can be used as raw material/consumable for other product/services."}
                    tooltipPosition="top"
                    tooltipWidth={"500px"}
                    formlabel="Can be used as consumable "
                    checked={canbeUsedasConsumable}
                    onChange={(checked) => setCanbeUsedasConsumable(checked)}
                  />}


                </div>

              </div>

              {registration.hasOwnProperty("OMNIEnabled") && <div>

                <div
                  className="mb-1 ">
                  Online Store Option
                </div>
                <div className="grid lg:grid-cols-5 sm:grid-cols-2 gap-3 mt-5">

                  {registration.hasOwnProperty("OMNIEnabled") && <CustomSwitch
                    tooltipWidth={"300px"}
                    tooltipPosition="right"
                    formlabel="Show Online"
                    infoText={"Show this product in your online store"}
                    checked={OMNIEnabled}
                    onChange={(checked) => setOMNIEnabled(checked)}
                  />}
                  {(registration.hasOwnProperty("OMNIEnabled") && OMNIEnabled) && <CustomSwitch
                    formlabel="Out Of Stock"
                    checked={outOfStock}
                    onChange={(checked) => setOutOfStock(checked)}
                  />}

                </div>
              </div>}





            </div>
          </PageSection>

          {/* {isPincode &&
            <PageSection title="Alerts">
              <div className="grid gap-6 mt-5">


                <div className="grid lg:grid-cols-6 sm:grid-cols-2 gap-3">
                  <CustomSwitch
                    formlabel="Enable alerts"
                    checked={enableAlert}
                    onChange={(checked) => setEnableAlert(checked)}
                  />
                  {enableAlert &&
                    <Input
                      label="Notify customer after (days)"
                      placeholder=""
                      type="number"
                      value={notifyCustomerDays}
                      onChange={(e) => {
                        setNotifyCustomerDays(e.target.value);

                      }}

                    />
                  }


                </div>

              </div>
            </PageSection>
          } */}


          <PageSection title="Additonal Information" showInfoIcon={true} performParentOnclick={() => { setShowInfoModal(true), setInfoType("ProductAdditionalInformation") }}>

            <div className="grid gap-6 mt-5">


              <div className="grid lg:grid-cols-6 sm:grid-cols-2 gap-3">
                <Input
                  label={customFieldData.CustomField1Name || "Custom Field 1"}
                  placeholder=""
                  value={customFeild1}
                  onChange={(e) => {
                    setCustomField1(e.target.value);

                  }}

                />
                <Input
                  label={customFieldData.CustomField2Name || "Custom Field 2"}
                  placeholder=""
                  value={customFeild2}
                  onChange={(e) => {
                    setCustomField2(e.target.value);

                  }}

                />
                <Input
                  label={customFieldData.CustomField3Name || "Custom Field 3"}
                  placeholder=""
                  value={customFeild3}
                  onChange={(e) => {
                    setCustomField3(e.target.value);

                  }}

                />
                <Input
                  label={customFieldData.CustomField4Name || "Custom Field 4"}
                  placeholder=""
                  value={customFeild4}
                  onChange={(e) => {
                    setCustomField4(e.target.value);

                  }}

                />
                <Input
                  label={customFieldData.CustomField5Name || "Custom Field 5"}
                  placeholder=""
                  value={customFeild5}
                  onChange={(e) => {
                    setCustomField5(e.target.value);

                  }}

                />
                <Input
                  label={customFieldData.CustomField6Name || "Custom Field 6"}
                  placeholder=""
                  value={customFeild6}
                  onChange={(e) => {
                    setCustomField6(e.target.value);

                  }}

                />


              </div>








            </div>
          </PageSection>

          {/* Other sections here... */}

        </div>)}
      {showConfirmBox && (
        <ConfirmBox
          title="Are you sure?"
          text="This action cannot be undone."
          onConfirm={handleConfirmDelete} // Pass the delete handler
          onCancel={handleCancelDelete} // Pass the cancel handler
        />
      )}
      {showInfoModal &&
        <InfoModal
          type={infoType}
          setPopUp={setShowInfoModal}
          width="w-[50%]"
        />}
    </CreatePage>

  );
};

export default Addproduct;